import React, { Component } from "react";
import classes from "./ARCInvoiceManagement.module.css";
import axios from "../../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import SellerInvoice from "../../../../asserts/templates/seller_invoice.xlsx";
import SellerCreditNote from "../../../../asserts/templates/seller_credit_note.xlsx";
import SellerDebitNote from "../../../../asserts/templates/seller_debit_note.xlsx";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../../components/ui/inputField";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Paper } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import ClearIcon from "@material-ui/icons/Clear";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import NumberFormat from "react-number-format";
import Modal from "react-bootstrap/Modal";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import { toast } from "react-toastify";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import CustomTable from "../../../../components/ui/Table/Table";
import moment from "moment";
import { TablePagination } from "@material-ui/core";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RightDrawer from "../../../../components/ui/RightDrawer";
import ZohoModel from "../../../../components/ZohoModel/ZohoModel";
import ErpConnectorModel from "../../../../components/ZohoModel/ErpConnector";
import DatePicker from "../../../../components/ui/DatePicker";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import { canWrite } from '../../../../utils/privilegeUtils';
import TuneIcon from "@mui/icons-material/Tune";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Chip from "@material-ui/core/Chip";

let flagForDebit = 1;
let flagForCredit = 1;
let flagForInvoice = 1;
let variableForTimer = null;

// Set to true AFTER BoxWrapper renders {props.headerExtra} right after its
// search input. The Filter button then sits next to the search box. While
// false it is rendered just above each table, so it never disappears.
const FILTER_BUTTON_IN_BOXWRAPPER = true;

// indian rupeess system---
const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumSignificantDigits: 10,
  }).format(value);
// ---End---

// date  format converter[dd/mm/yyyy to yyyy/mm/dd]
const dateFormat = (value) => {
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "/" + old_date[1] + "/" + old_date[0];
  }
};

const dateFormatWithDash = (value) => {
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "-" + old_date[1] + "-" + old_date[0];
  }
};

// date  format converter[dd/mm/yyyy to dd-mm-yyyy]
const dateFormatWithslash = (value) => {
  if (value) {
    let old_date = String(value).split("/");
    return old_date[0] + "-" + old_date[1] + "-" + old_date[2];
  }
};

class InvoiceManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExportingAll: false,
      invoiceTypeOptions: [],
      invoiceCol: [
        {
          key: "invoiceNo",
          render: (index, row) => {
            return row["invoice_no"];
          },
        },
        {
          key: "invoiceDate",
          render: (index, row) => {
            return row["invoice_date"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["cust_gstin"];
          },
        },
        {
          key: "totalAmount",
          render: (index, row) => {
            return numberFormat(row["total_amount"]);
          },
        },

        {
          key: "dueDate",
          render: (index, row) => {
            // return dateFormat(row['due_date']);
            return row["due_date"];
          },
        },
      ],
      invoiceData: null,
      oldInvoiceData: null,
      actionHeaderForZohoInvoice: [
        { id: "cust_pan", name: "Customer PAN" },
        { id: "gst_invoice_type", name: "GST Invoice Type" },
        { id: "taxable_value", name: "Taxable Value" },
        { id: "non_taxable_adj", name: "Non Taxable Value" },
        { id: "cess", name: "CESS" },
        { id: "gst_tax_rate", name: "GST Tax %" },
        { id: "hsn_sac_code", name: "HSN/SAC Code" },
        { id: "cgst", name: "CGST" },
        { id: "igst", name: "IGST" },
        { id: "sgst", name: "SGST" },
        { id: "pos", name: "Place Of Supply" },
        { id: "invoice_collection_agency", name: "Invoice Collection Agency" },
        { id: "erp_cust_code", name: "Customer Code" },
      ],
      actionHeaderForZohoDebit: [
        { id: "erp_cust_code", name: "Customer Code" },
        { id: "debitNoteDate", name: "Debit Note Date" },
        { id: "cust_pan", name: "Customer PAN" },
        { id: "taxable_value", name: "Taxable Value" },
        { id: "non_taxable_adj", name: "Non Taxable Value" },
        { id: "cess", name: "CESS" },
        { id: "gst_tax_rate", name: "GST Tax %" },
        { id: "hsn_sac_code", name: "HSN/SAC Code" },
        { id: "cgst", name: "CGST" },
        { id: "igst", name: "IGST" },
        { id: "sgst", name: "SGST" },
        { id: "tax_amount", name: "Tax Amount" },
        { id: "pos", name: "Place Of Supply" },
        { id: "debit_note_reason", name: "Debit Note Reason" },
      ],
      actionHeaderForZohoCredit: [
        { id: "erp_cust_code", name: "Customer Code" },
        { id: "credit_note_date", name: "Credit Note Date" },
        { id: "cust_pan", name: "Customer PAN" },
        { id: "taxable_value", name: "Taxable Value" },
        { id: "non_taxable_adj", name: "Non Taxable Value" },
        { id: "cess", name: "CESS" },
        { id: "gst_tax_rate", name: "GST Tax %" },
        { id: "hsn_sac_code", name: "HSN/SAC Code" },
        { id: "cgst", name: "CGST" },
        { id: "igst", name: "IGST" },
        { id: "sgst", name: "SGST" },
        { id: "tax_amount", name: "Tax Amount" },
        { id: "pos", name: "Place Of Supply" },
        { id: "credit_note_reason", name: "Credit Note Reason" },
      ],
      invoiceHeader: [
        { label: "Invoice Number" },
        { label: "Invoice Date" },
        { label: "GSTIN" },
        { label: "Total Amount" },
        { label: "Due Date" },
      ],
      actions: [
        {
          label: <VisibilityIcon style={{ cursor: "pointer" }} />,
          onclickEvent: (index, row) => this.openModal(index),
        },
      ],
      effitracInvShow: false,

      // debit effitrac table
      debitEffitracCol: [
        {
          key: "invoiceNo",
          render: (index, row) => {
            return row["invoice_no"];
          },
        },
        {
          key: "invoiceDate",
          render: (index, row) => {
            // return row['invoiceDate']
            //   ? dateFormatWithslash(row['invoiceDate'])
            //   : row['invoice_date'];
            return row["invoice_date"];
          },
        },
        {
          key: "debitNoteNo",
          render: (index, row) => {
            return row["debit_note_no"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["cust_gstin"];
          },
        },
        {
          key: "totalAmount",
          render: (index, row) => {
            return numberFormat(row["total_amount"]);
          },
        },
      ],
      debitEffitracData: null,
      oldDebitEffitracData: null,
      debitEffitracHeader: [
        { label: "Invoice Number" },
        { label: "Invoice Date" },
        { label: "Debit Note No" },
        { label: "GSTIN" },
        { label: "Total Amount" },
      ],
      debitEffitracActions: [
        {
          label: <VisibilityIcon style={{ cursor: "pointer" }} />,
          onclickEvent: (index, row) => this.openEffitracDebitShowModal(index),
        },
      ],
      effitracDebitShow: false,
      debitTargetId: null,
      // credit effitrac table
      creditEffitracCol: [
        {
          key: "invoiceNo",
          render: (index, row) => {
            return row["invoice_no"];
          },
        },
        {
          key: "invoiceDate",
          render: (index, row) => {
            // return dateFormat(row['invoice_date']);
            return row["invoice_date"];
          },
        },
        {
          key: "creditNoteNo",
          render: (index, row) => {
            return row["credit_note_no"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["cust_gstin"];
          },
        },
        {
          key: "totalAmount",
          render: (index, row) => {
            return numberFormat(row["total_amount"]);
          },
        },
      ],
      creditEffitracData: null,
      // oldCreditEffitracData: null,
      searchForCreditDate: null,
      creditEffitracHeader: [
        { label: "Invoice Number" },
        { label: "Invoice Date" },
        { label: "Credit Note No" },
        { label: "GSTIN" },
        { label: "Total Amount" },
      ],
      creditEffitracActions: [
        {
          label: <VisibilityIcon style={{ cursor: "pointer" }} />,
          onclickEvent: (index, row) => this.openEffitracCreditShowModal(index),
        },
      ],
      effitracCreditShow: false,
      creditTargetId: null,
      // credit effitrac table end

      uploadUrl: null,
      read_only: "",
      next: {},
      prev: {},
      file_value: null,
      total_records: 0,
      errorPage: 1, // Current page
      perErrorPages: 10, // Records per page
      errortotal: 0, // Total records
      successful_records: 0,
      error_records: 0,
      error_rows: {},
      searchInput: "",
      autoSync: false,
      loadingExport: false,

      targetId: null,
      sellerCustomerCol: [
        // { key: 'seller_code', label: 'Seller Code', },
        {
          label: "GSTIN",
          render: (name, all) => {
            return all["record"]["GSTIN"];
          },
        },
        {
          label: "Invoice Number",
          render: (name, all) => {
            return all["record"]["InvoiceNo"];
          },
        },
        { key: "row", label: "Row #" },
        {
          label: "Errors",
          render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => {
              return (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <span>{i}</span>&nbsp;<span>:</span>&nbsp;
                  <span style={{ color: "red" }}>
                    {all["errors_in"][i].join(",")}
                  </span>
                </div>
              );
            });
          },
        },
        // {label:"Status",key:"status"}
      ],
      sellerCustomerData: [],
      error: null,
      download_file: SellerInvoice,
      download_file_name: "seller_invoice.xlsx",
      section_name: "Invoice",
      allArcSellerdebitNote: [],
      OriginalDataAllArcSellerdebitNote: [],
      showDebitNoteDetailsData: {},

      allArcInvoiceData: [],
      OriginalallArcInvoiceData: [],
      showInvoiceDetailsData: {},

      allArcSellerCreditNote: [],
      OriginalSellerCreditNote: [],
      showCreditNoteDetailsData: {},

      showUploadData: false,
      debitNoteTableData: false,
      invoiceTableData: true,
      creditNoteTableData: false,

      showInvoiceDrawer: false,
      showCreditNoteDrawer: false,
      showDebitNoteDrawer: false,
      loading: false,
      // add
      addInvoice_DrawerOpen: false,
      addInvoiceData: {},

      addDebitNote_DrawerOpen: false,
      addDebitNoteData: {},

      addCreditNote_DrawerOpen: false,
      addCreditNoteData: {},
      creditNoteDateDisplay: "",

      // edit
      editInvoice_DrawerOpen: false,
      editInvoiceData: {},

      editDebitNote_DrawerOpen: false,
      editDebitNoteData: {},

      editCreditNote_DrawerOpen: false,
      editCreditNoteData: {},

      // customer table modal
      allArcSellerCustomerData: {},
      OriginalDataAllArcSellerCustomerData: {},
      customerTableModalShow: false,
      invoiceModalBackDrop: false,

      // debit table modal
      invoiceApiDataForDebitModal: [],
      invoiceApiSearchDataForDebitModal: [],
      debitModalShow: false,
      debitModalBackDrop: false,

      // credit table modal
      invoiceApiDataForCreditModal: [],
      invoiceApiSearchDataForCreditModal: [],
      creditNoteModalShow: false,
      creditNoteModalBackDrop: false,

      //place of supply in edit invoice Note
      placeOfsupply: "",

      //get Api For Place Of Supply
      getApiForPlaceOfSupply: [],

      // import effitrac / tally
      openImportEffitracDrawer: false,

      EffitracInvoiceFetchData: {
        business_entity_id: parseInt(
          localStorage.getItem("business_entity_id"),
        ),
      },

      // import effitrac /tally debit
      openImportEffitracDebitDrawer: false,
      effitracDebitFetchData: {},

      // Edited by Harsh For Cridit
      openZohoCreditDrawer: false,
      // zohoFetchDate:{},

      //Debit Note (Harsh)
      openZohoDebitDrawer: false,
      zohoDataForCWS: false,
      // zohoFetchDateForDebit: {},
      zohoDate: {},

      //Invoice note
      openZohoDrawerForInvoice: false,
      messageForConnectionForInvoice: "Establish Connection",
      buttonColorForInvoice: "red",
      grantToken: "",
      url: "",
      // zohoFetchDateForInvoice: {},

      // import effitrac /tally credit
      openImportEffitracCreditDrawer: false,
      effitracCreditFetchData: {
        business_entity_id: parseInt(
          localStorage.getItem("business_entity_id"),
        ),
      },

      // pagination state.....
      page: 0,
      rowsPerPage: 25,
      rowCount: 0,
      invoiceSearchInput: "",
      // debit
      debitPage: 0,
      debitRowsPerPage: 25,
      debitRowCount: 0,
      debitSearchInput: "",
      // credit
      creditPage: 0,
      creditRowsPerPage: 25,
      creditRowCount: 0,
      creditSearchInput: "",

      // upload history table data
      uploadHistoryTableData: [],
      // showUploadHistroyTable: false,
      //Customer Select
      pageForAddInvoice: 0,
      rowsPerPageForAddInvoice: 25,
      rowCountForAddInvoice: 0,

      flagForZoho: false,
      timerForZoho: 60,
      // variableForTimer: null,

      disableEnableButtonForZoho: true,

      // loader...
      loaderForInvoice: true,
      loaderForDebit: true,
      loaderForCredit: true,
      erpConnectorModelOpen: false,
      erpConnectorName: "",
      erpDataExportLoading: false,
      importToCwsLoading: false,

      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: "",
      toPeriod: null,

      // ---------------------------------------------------------------
      // IN-GRID MULTI-FIELD FILTER — Invoice (same pattern as
      // ARCCustomer: sticky grouped header, sticky filter row, single
      // "Apply Filters" action, comma-separated "is any of" values).
      // ---------------------------------------------------------------
      invoiceInlineFilterValues: {},
      invoiceAppliedFilters: [],
      invoiceFilterMatchType: "AND",
      // invoice filter side panel
      invoiceFilterPanelOpen: false,
      invoiceAdvancedFiltersOpen: false,
      invoiceDraftValues: {},
      // The filter payload CURRENTLY applied against the backend filter
      // endpoint. Pagination handlers use this to know whether to hit the
      // filter endpoint (and resend it) or the plain listing endpoint.
      activeFilters: {},

      // IN-GRID MULTI-FIELD FILTER — Debit Note
      debitInlineFilterValues: {},
      debitAppliedFilters: [],
      debitFilterMatchType: "AND",
      // debit filter side panel
      debitFilterPanelOpen: false,
      debitAdvancedFiltersOpen: false,
      debitDraftValues: {},
      debitActiveFilters: {},

      // IN-GRID MULTI-FIELD FILTER — Credit Note
      creditInlineFilterValues: {},
      creditAppliedFilters: [],
      creditFilterMatchType: "AND",
      // credit filter side panel
      creditFilterPanelOpen: false,
      creditAdvancedFiltersOpen: false,
      creditDraftValues: {},
      creditActiveFilters: {},
    };
  }

  // ---------------------------------------------------------------------
  // GROUPED FILTERABLE / DISPLAY COLUMNS — same pattern as ARCCustomer:
  // group + width per column drives the sticky group-band header, the
  // sticky column-label header, the sticky filter row, and the data
  // cells, all automatically. Add a field here to make it available
  // everywhere — nothing else to wire.
  // ---------------------------------------------------------------------
  invoiceFilterableColumns = [
    { key: "cust_name", label: "Customer Name", group: "Customer", width: 200 },
    { key: "cust_code", label: "ERP Customer Code", group: "Customer", width: 150 },
    { key: "cust_gstin", label: "GSTIN", group: "Tax", width: 150 },
    { key: "cust_pan", label: "PAN", group: "Tax", width: 110 },
    { key: "entity_gstin", label: "Entity GSTIN", group: "Tax", width: 150 },
    { key: "hsn_sac_code", label: "HSN/SAC Code", group: "Tax", width: 120 },
    { key: "gst_tax_rate", label: "GST Tax %", group: "Tax", width: 100 },
    { key: "pos", label: "Place Of Supply", group: "Tax", width: 100 },
    { key: "invoice_no", label: "Invoice No", group: "Invoice", width: 150 },
    { key: "invoice_date", label: "Invoice Date", group: "Invoice", width: 120 },
    { key: "due_date", label: "Due Date", group: "Invoice", width: 120 },
    { key: "po_no", label: "PO No", group: "Invoice", width: 140 },
    { key: "einvoice_irn", label: "E-invoice IRN", group: "Invoice", width: 220 },
    { key: "invoice_type", label: "Revenue Type", group: "Invoice", width: 170 },
    { key: "gst_invoice_type", label: "GST Invoice Type", group: "Invoice", width: 130 },
    { key: "invoice_collection_agency", label: "Collection Agency", group: "Invoice", width: 170 },
    { key: "branch_name", label: "Branch", group: "Invoice", width: 130 },
    {
      key: "taxable_value",
      label: "Taxable Value",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.taxable_value),
    },
    {
      key: "non_taxable_adj",
      label: "Non Taxable Adj",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.non_taxable_adj),
    },
    { key: "cgst", label: "CGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.cgst) },
    { key: "sgst", label: "SGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.sgst) },
    { key: "igst", label: "IGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.igst) },
    { key: "cess", label: "CESS", group: "Amounts", width: 110, render: (row) => numberFormat(row.cess) },
    {
      key: "tax_amount",
      label: "Tax Amount",
      group: "Amounts",
      width: 130,
      render: (row) => numberFormat(row.tax_amount),
    },
    {
      key: "total_amount",
      label: "Total Amount",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.total_amount),
    },
    { key: "created_date", label: "Created Date", group: "Meta", width: 160 },
    { key: "modified_date", label: "Modified Date", group: "Meta", width: 160 },
  ];

  debitFilterableColumns = [
    { key: "cust_name", label: "Customer Name", group: "Customer", width: 200 },
    { key: "cust_code", label: "ERP Customer Code", group: "Customer", width: 150 },
    { key: "cust_gstin", label: "GSTIN", group: "Tax", width: 150 },
    { key: "cust_pan", label: "PAN", group: "Tax", width: 110 },
    { key: "hsn_sac_code", label: "HSN/SAC Code", group: "Tax", width: 120 },
    { key: "gst_tax_rate", label: "GST Tax %", group: "Tax", width: 100 },
    { key: "pos", label: "Place Of Supply", group: "Tax", width: 100 },
    { key: "invoice_no", label: "Invoice No", group: "Invoice", width: 150 },
    { key: "invoice_date", label: "Invoice Date", group: "Invoice", width: 120 },
    { key: "debit_note_no", label: "Debit Note No", group: "Invoice", width: 150 },
    { key: "debit_note_date", label: "Debit Note Date", group: "Invoice", width: 150 },
    { key: "debit_note_reason", label: "Debit Note Reason", group: "Invoice", width: 180 },
    {
      key: "taxable_value",
      label: "Taxable Value",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.taxable_value),
    },
    {
      key: "non_taxable_adj",
      label: "Non Taxable Adj",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.non_taxable_adj),
    },
    { key: "cgst", label: "CGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.cgst) },
    { key: "sgst", label: "SGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.sgst) },
    { key: "igst", label: "IGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.igst) },
    { key: "cess", label: "CESS", group: "Amounts", width: 110, render: (row) => numberFormat(row.cess) },
    {
      key: "tax_amount",
      label: "Tax Amount",
      group: "Amounts",
      width: 130,
      render: (row) => numberFormat(row.tax_amount),
    },
    {
      key: "total_amount",
      label: "Total Amount",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.total_amount),
    },
    { key: "created_date", label: "Created Date", group: "Meta", width: 160 },
    { key: "modified_date", label: "Modified Date", group: "Meta", width: 160 },
  ];

  creditFilterableColumns = [
    { key: "cust_name", label: "Customer Name", group: "Customer", width: 200 },
    { key: "cust_code", label: "ERP Customer Code", group: "Customer", width: 150 },
    { key: "cust_gstin", label: "GSTIN", group: "Tax", width: 150 },
    { key: "cust_pan", label: "PAN", group: "Tax", width: 110 },
    { key: "hsn_sac_code", label: "HSN/SAC Code", group: "Tax", width: 120 },
    { key: "gst_tax_rate", label: "GST Tax %", group: "Tax", width: 100 },
    { key: "pos", label: "Place Of Supply", group: "Tax", width: 100 },
    { key: "invoice_no", label: "Invoice No", group: "Invoice", width: 150 },
    { key: "invoice_date", label: "Invoice Date", group: "Invoice", width: 120 },
    { key: "credit_note_no", label: "Credit Note No", group: "Invoice", width: 150 },
    { key: "credit_note_date", label: "Credit Note Date", group: "Invoice", width: 150 },
    { key: "credit_note_reason", label: "Credit Note Reason", group: "Invoice", width: 180 },
    { key: "is_discount_baddebt", label: "Discount/Bad Debt", group: "Invoice", width: 170 },
    {
      key: "taxable_value",
      label: "Taxable Value",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.taxable_value),
    },
    {
      key: "non_taxable_adj",
      label: "Non Taxable Adj",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.non_taxable_adj),
    },
    { key: "cgst", label: "CGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.cgst) },
    { key: "sgst", label: "SGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.sgst) },
    { key: "igst", label: "IGST", group: "Amounts", width: 110, render: (row) => numberFormat(row.igst) },
    { key: "cess", label: "CESS", group: "Amounts", width: 110, render: (row) => numberFormat(row.cess) },
    {
      key: "tax_amount",
      label: "Tax Amount",
      group: "Amounts",
      width: 130,
      render: (row) => numberFormat(row.tax_amount),
    },
    {
      key: "total_amount",
      label: "Total Amount",
      group: "Amounts",
      width: 140,
      render: (row) => numberFormat(row.total_amount),
    },
    { key: "created_date", label: "Created Date", group: "Meta", width: 160 },
    { key: "modified_date", label: "Modified Date", group: "Meta", width: 160 },
  ];

  // Shared visual constants — identical to ARCCustomer's filter UI.
  SHOW_COL_WIDTH = 70;
  ACCENT = "#0f766e"; // deep teal — fintech-appropriate accent used throughout the filter UI
  GROUP_COLORS = {
    "Customer": "#0f766e",
    "Tax": "#7c3aed",
    "Invoice": "#0369a1",
    "Amounts": "#b45309",
    "Meta": "#475569",
  };

  // True whenever one or more column filters are currently applied.
  // Pagination / search handlers use this to decide whether to hit the
  // filter endpoint (and resend the active filters) or the plain listing
  // endpoint.
  hasActiveFilters = () => {
    const { activeFilters } = this.state;
    return !!activeFilters && Object.keys(activeFilters).length > 0;
  };
  hasActiveDebitFilters = () => {
    const { debitActiveFilters } = this.state;
    return !!debitActiveFilters && Object.keys(debitActiveFilters).length > 0;
  };

  hasActiveCreditFilters = () => {
    const { creditActiveFilters } = this.state;
    return !!creditActiveFilters && Object.keys(creditActiveFilters).length > 0;
  };

  // Splits a raw string on commas into trimmed, non-empty, de-duplicated
  // values. Used for every field's value box so a person can paste
  // "abc ltd, mr.gg, amazon" into one field and match any of them.
  parseBulkFilterValues = (raw) =>
    Array.from(
      new Set(
        (raw || "")
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
      )
    );

  // -----------------------------------------------------------------------
  // IN-GRID MULTI-FIELD FILTER — Invoice
  // -----------------------------------------------------------------------
  getInvoiceInlineFilterValue = (field) => this.state.invoiceInlineFilterValues[field] ?? "";

  handleInvoiceInlineFilterChange = (field, rawValue) => {
    this.setState((prev) => ({
      invoiceInlineFilterValues: { ...prev.invoiceInlineFilterValues, [field]: rawValue },
    }));
  };

  clearInvoiceInlineFilterField = (field) => {
    this.setState((prev) => ({
      invoiceInlineFilterValues: { ...prev.invoiceInlineFilterValues, [field]: "" },
    }));
  };

  hasStagedInvoiceFilterChanges = () => {
    const { invoiceInlineFilterValues, invoiceAppliedFilters } = this.state;
    const appliedByField = Object.fromEntries(invoiceAppliedFilters.map((c) => [c.field, c.value]));
    return this.invoiceFilterableColumns.some((col) => {
      const staged = (invoiceInlineFilterValues[col.key] ?? "").trim();
      const applied = (appliedByField[col.key] ?? "").trim();
      return staged !== applied;
    });
  };

  stagedInvoiceFilterFieldCount = () =>
    Object.values(this.state.invoiceInlineFilterValues).filter((v) => (v ?? "").toString().trim() !== "").length;

  applyInvoiceInlineFilters = () => {
    const conditions = this.invoiceFilterableColumns
      .map((col) => ({ field: col.key, value: (this.state.invoiceInlineFilterValues[col.key] ?? "").trim() }))
      .filter((c) => c.value !== "");

    this.setState({ invoiceAppliedFilters: conditions, page: 0 }, () =>
      this.applyInvoiceDynamicFilters(conditions, this.state.invoiceFilterMatchType)
    );
  };

  handleClearAllInvoiceFilters = () => {
    this.setState({ invoiceInlineFilterValues: {}, invoiceAppliedFilters: [], page: 0 }, () =>
      this.applyInvoiceDynamicFilters([], this.state.invoiceFilterMatchType)
    );
  };

  // Builds the backend payload from the current conditions and either calls
  // the filter API (when conditions exist, running against the entire
  // dataset before pagination) or falls back to the normal paginated
  // listing (when the filter set is empty). Every condition is sent as
  // operator "in" — "field value is any of these".
  applyInvoiceDynamicFilters = (
    conditions = this.state.invoiceAppliedFilters,
    matchType = this.state.invoiceFilterMatchType
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ activeFilters: {} });
      this.getSellerInvoiceDataApi(this.state.invoiceSearchInput);
      return;
    }
    const payload = {
      match_type: matchType,
      conditions: conditions.map((c) => ({
        field: c.field,
        operator: "in",
        value: this.parseBulkFilterValues(c.value),
      })),
    };
    this.getSellerInvoiceFilterApi(payload);
  };

  // -----------------------------------------------------------------------
  // IN-GRID MULTI-FIELD FILTER — Debit Note
  // -----------------------------------------------------------------------
  getDebitInlineFilterValue = (field) => this.state.debitInlineFilterValues[field] ?? "";

  handleDebitInlineFilterChange = (field, rawValue) => {
    this.setState((prev) => ({
      debitInlineFilterValues: { ...prev.debitInlineFilterValues, [field]: rawValue },
    }));
  };

  clearDebitInlineFilterField = (field) => {
    this.setState((prev) => ({
      debitInlineFilterValues: { ...prev.debitInlineFilterValues, [field]: "" },
    }));
  };

  hasStagedDebitFilterChanges = () => {
    const { debitInlineFilterValues, debitAppliedFilters } = this.state;
    const appliedByField = Object.fromEntries(debitAppliedFilters.map((c) => [c.field, c.value]));
    return this.debitFilterableColumns.some((col) => {
      const staged = (debitInlineFilterValues[col.key] ?? "").trim();
      const applied = (appliedByField[col.key] ?? "").trim();
      return staged !== applied;
    });
  };

  stagedDebitFilterFieldCount = () =>
    Object.values(this.state.debitInlineFilterValues).filter((v) => (v ?? "").toString().trim() !== "").length;

  applyDebitInlineFilters = () => {
    const conditions = this.debitFilterableColumns
      .map((col) => ({ field: col.key, value: (this.state.debitInlineFilterValues[col.key] ?? "").trim() }))
      .filter((c) => c.value !== "");

    this.setState({ debitAppliedFilters: conditions, debitPage: 0 }, () =>
      this.applyDebitDynamicFilters(conditions, this.state.debitFilterMatchType)
    );
  };

  handleClearAllDebitFilters = () => {
    this.setState({ debitInlineFilterValues: {}, debitAppliedFilters: [], debitPage: 0 }, () =>
      this.applyDebitDynamicFilters([], this.state.debitFilterMatchType)
    );
  };

  applyDebitDynamicFilters = (
    conditions = this.state.debitAppliedFilters,
    matchType = this.state.debitFilterMatchType
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ debitActiveFilters: {} });
      this.sellerDebitNoteGetApi(this.state.debitSearchInput);
      return;
    }
    const payload = {
      match_type: matchType,
      conditions: conditions.map((c) => ({
        field: c.field,
        operator: "in",
        value: this.parseBulkFilterValues(c.value),
      })),
    };
    this.getSellerDebitNoteFilterApi(payload);
  };

  // -----------------------------------------------------------------------
  // IN-GRID MULTI-FIELD FILTER — Credit Note
  // -----------------------------------------------------------------------
  getCreditInlineFilterValue = (field) => this.state.creditInlineFilterValues[field] ?? "";

  handleCreditInlineFilterChange = (field, rawValue) => {
    this.setState((prev) => ({
      creditInlineFilterValues: { ...prev.creditInlineFilterValues, [field]: rawValue },
    }));
  };

  clearCreditInlineFilterField = (field) => {
    this.setState((prev) => ({
      creditInlineFilterValues: { ...prev.creditInlineFilterValues, [field]: "" },
    }));
  };

  hasStagedCreditFilterChanges = () => {
    const { creditInlineFilterValues, creditAppliedFilters } = this.state;
    const appliedByField = Object.fromEntries(creditAppliedFilters.map((c) => [c.field, c.value]));
    return this.creditFilterableColumns.some((col) => {
      const staged = (creditInlineFilterValues[col.key] ?? "").trim();
      const applied = (appliedByField[col.key] ?? "").trim();
      return staged !== applied;
    });
  };

  stagedCreditFilterFieldCount = () =>
    Object.values(this.state.creditInlineFilterValues).filter((v) => (v ?? "").toString().trim() !== "").length;

  applyCreditInlineFilters = () => {
    const conditions = this.creditFilterableColumns
      .map((col) => ({ field: col.key, value: (this.state.creditInlineFilterValues[col.key] ?? "").trim() }))
      .filter((c) => c.value !== "");

    this.setState({ creditAppliedFilters: conditions, creditPage: 0 }, () =>
      this.applyCreditDynamicFilters(conditions, this.state.creditFilterMatchType)
    );
  };

  handleClearAllCreditFilters = () => {
    this.setState({ creditInlineFilterValues: {}, creditAppliedFilters: [], creditPage: 0 }, () =>
      this.applyCreditDynamicFilters([], this.state.creditFilterMatchType)
    );
  };

  applyCreditDynamicFilters = (
    conditions = this.state.creditAppliedFilters,
    matchType = this.state.creditFilterMatchType
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ creditActiveFilters: {} });
      this.sellerCreditNoteGetApi(this.state.creditSearchInput);
      return;
    }
    const payload = {
      match_type: matchType,
      conditions: conditions.map((c) => ({
        field: c.field,
        operator: "in",
        value: this.parseBulkFilterValues(c.value),
      })),
    };
    this.getSellerCreditNoteFilterApi(payload);
  };

  // -----------------------------------------------------------------------
  // GENERIC — grouped header / colgroup / min-width / action bar / filter
  // row helpers, parameterized by which column set they're rendering for.
  // Visuals match ARCCustomer's filter UI exactly for all three tables.
  // -----------------------------------------------------------------------
  getColumnGroupsFor = (columns) => {
    const groups = [];
    columns.forEach((col) => {
      const existing = groups.find((g) => g.name === col.group);
      if (existing) existing.span += 1;
      else groups.push({ name: col.group, span: 1 });
    });
    return groups;
  };

  getGroupWidthFor = (columns, groupName) =>
    columns.filter((c) => c.group === groupName).reduce((sum, c) => sum + c.width, 0);

  getTableMinWidthFor = (columns) => columns.reduce((sum, c) => sum + c.width, this.SHOW_COL_WIDTH);

  renderColGroupFor = (columns) => (
    <colgroup>
      {columns.map((col) => (
        <col key={col.key} style={{ width: col.width }} />
      ))}
      <col style={{ width: this.SHOW_COL_WIDTH }} />
    </colgroup>
  );

  renderGroupedHeaderFor = (columns, subtle = false) => {
    const groups = this.getColumnGroupsFor(columns);

    const groupRow = (
      <tr key="group-row">
        {groups.map((g) => (
          <th
            key={g.name}
            colSpan={g.span}
            style={{
              position: "sticky",
              top: 0,
              zIndex: 510,
              padding: "6px 8px",
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.4px",
              textTransform: "uppercase",
              color: subtle ? this.HEADER_TEXT : "#ffffff",
              background: subtle
                ? this.HEADER_GROUP_BG
                : this.GROUP_COLORS[g.name] || "#334155",
              textAlign: "center",
              borderRight: subtle
                ? `1px solid ${this.HEADER_BORDER}`
                : "1px solid rgba(255,255,255,0.25)",
              borderBottom: subtle ? `1px solid ${this.HEADER_BORDER}` : undefined,
              whiteSpace: "nowrap",
              boxSizing: "border-box",
            }}
          >
            {g.name}
          </th>
        ))}
        <th
          rowSpan={2}
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            zIndex: 520,
            backgroundColor: subtle ? this.HEADER_GROUP_BG : this.ACCENT,
            color: subtle ? this.HEADER_TEXT : "#ffffff",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            textAlign: "center",
            borderLeft: "2px solid rgba(255,255,255,0.25)",
            boxShadow: "-2px 0 4px rgba(0,0,0,0.18)",
            boxSizing: "border-box",
          }}
        >
          SHOW
        </th>
      </tr>
    );

    const labelRow = (
      <tr key="label-row">
        {columns.map((col) => (
          <th
            key={col.key}
            style={{
              position: "sticky",
              top: "29px",
              zIndex: 500,
              backgroundColor: subtle ? this.HEADER_LABEL_BG : "#f8fafc",
              padding: "6px 8px",
              fontSize: "11.5px",
              fontWeight: 600,
              color: "#334155",
              textAlign: "center",
              borderRight: subtle ? `1px solid ${this.HEADER_BORDER}` : "1px solid #e2e8f0",
              borderBottom: subtle ? `1px solid ${this.HEADER_BORDER}` : undefined,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
            }}
          >
            {col.label.toUpperCase()}
          </th>
        ))}
      </tr>
    );

    return [groupRow, labelRow];
  };

  // The slim status/action bar directly above a table. Returns null when
  // there is nothing to show (no applied filters, nothing staged) so it
  // never adds visual weight to the page until it's actually useful.
  renderFilterActionBarFor = ({ stagedCount, hasStaged, appliedCount, onApply, onClearAll }) => {
    if (!hasStaged && appliedCount === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
          padding: "7px 14px",
          marginBottom: "6px",
          borderRadius: "8px",
          background: hasStaged ? `linear-gradient(90deg, ${this.ACCENT}, #115e59)` : "#f1f5f9",
          color: hasStaged ? "#ffffff" : "#334155",
          transition: "background 0.2s ease",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "12.5px" }}>
          <TuneIcon style={{ fontSize: "16px" }} />
          <span>
            {hasStaged
              ? `${stagedCount} field${stagedCount === 1 ? "" : "s"} ready to filter`
              : `${appliedCount} filter${appliedCount === 1 ? "" : "s"} active`}
          </span>
        </div>

        <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
          {appliedCount > 0 && (
            <button
              type="button"
              onClick={onClearAll}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "12px",
                cursor: "pointer",
                color: hasStaged ? "rgba(255,255,255,0.9)" : this.ACCENT,
                textDecoration: "underline",
              }}
            >
              Clear all
            </button>
          )}
          {hasStaged && (
            <button
              type="button"
              onClick={onApply}
              style={{
                background: "#ffffff",
                color: this.ACCENT,
                border: "none",
                borderRadius: "999px",
                padding: "4px 18px",
                fontSize: "12px",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
              }}
            >
              Apply Filters
            </button>
          )}
        </div>
      </div>
    );
  };

  // The filter row itself — lives as a `<tr>` right under the two header
  // rows (group band + column labels), inside the same table, one box per
  // filterable column. Pressing Enter in any box applies every staged box
  // at once, same as clicking "Apply Filters" in the bar above. The
  // trailing cell (below SHOW) is pinned to the right edge with
  // `position: sticky` so it stays visible while the table scrolls
  // horizontally, matching the header's sticky SHOW column.
  renderInlineFilterRowFor = ({ columns, getValue, onChange, onClear, onApply, appliedFilters, onClearAll, topOffset }) => {
    const appliedByField = Object.fromEntries(appliedFilters.map((c) => [c.field, c.value]));

    return (
      <tr>
        {columns.map((col) => {
          const value = getValue(col.key);
          const isApplied = value.trim() !== "" && (appliedByField[col.key] ?? "").trim() === value.trim();

          return (
            <td
              key={col.key}
              style={{
                position: "sticky",
                top: topOffset,
                zIndex: 400,
                padding: "6px 10px",
                background: "#f0fdfa",
                borderBottom: `2px solid ${isApplied ? this.ACCENT : "#d9e6e4"}`,
                boxSizing: "border-box",
              }}
            >
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  type="text"
                  value={value}
                  onChange={(e) => onChange(col.key, e.target.value)}
                  onPaste={(e) => {
                    // Excel copy-paste brings multiple values separated by
                    // newlines (one per row) or tabs (one per column), with
                    // no commas at all. Detect that shape and convert it
                    // into the same comma-separated "is any of" format this
                    // box expects, appending to whatever is already typed.
                    const pasted = e.clipboardData.getData("text");
                    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // plain single-value paste — let default happen

                    e.preventDefault();
                    const pastedValues = pasted
                      .split(/[\r\n\t]+/)
                      .map((v) => v.trim())
                      .filter((v) => v.length > 0);
                    if (pastedValues.length === 0) return;

                    const joined = pastedValues.join(", ");
                    const current = value.replace(/\s+$/, "");
                    const newValue =
                      current === ""
                        ? joined
                        : current.endsWith(",")
                          ? `${current} ${joined}`
                          : `${current}, ${joined}`;

                    onChange(col.key, newValue);
                  }}
                  onKeyDown={(e) => {
                    // Enter applies every staged box at once — same effect
                    // as clicking "Apply Filters" in the bar above.
                    if (e.key === "Enter") {
                      e.preventDefault();
                      onApply();
                    }
                  }}
                  placeholder={`e.g. ${col.label.toLowerCase()} 1, 2`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "transparent",
                    outline: "none",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    padding: "3px 18px 3px 2px",
                    color: "#0f172a",
                    textAlign: "center",
                  }}
                />
                {value && (
                  <ClearIcon
                    onClick={() => onClear(col.key)}
                    style={{
                      position: "absolute",
                      right: 0,
                      fontSize: "14px",
                      color: "#94a3b8",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </td>
          );
        })}
        <td
          style={{
            position: "sticky",
            top: topOffset,
            right: 0,
            zIndex: 410,
            padding: "6px 10px",
            background: "#f0fdfa",
            borderBottom: "2px solid #d9e6e4",
            textAlign: "center",
            boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
            boxSizing: "border-box",
          }}
        >
          {appliedFilters.length > 0 && (
            <Tooltip title="Clear all filters">
              <IconButton size="small" onClick={onClearAll}>
                <ClearIcon style={{ fontSize: "16px", color: this.ACCENT }} />
              </IconButton>
            </Tooltip>
          )}
        </td>
      </tr>
    );
  };

  handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  handlePageChange = (newPage) => {
    console.log("Page change requested:", newPage);
    this.setState({ page: newPage, loading: true }, () => {
      this.uploadReport(this.props.id, newPage, this.state.perPage);
    });
  };

  handleNextPage = (event) => {
    const { errorPage, perErrorPages, errortotal } = this.state;
    const totalPages = Math.ceil(errortotal / perErrorPages);

    if (errorPage < totalPages) {
      const newPage = errorPage + 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handlePreviousPage = (event) => {
    const { errorPage } = this.state;

    if (errorPage > 1) {
      const newPage = errorPage - 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handleRowsPerPageChange = (index, value) => {
    console.log(`Changing rows per page to ${value}`);
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1,
      },
      () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, 1);
      },
    );
  };

  handleChangePageForAddInvoice = (event, newPage) => {
    this.setState({ pageForAddInvoice: newPage }, () => {
      this.getSellercustomerDataApi(this.state.invoiceSearchInput);
    });
  };

  handleChangeRowsPerPageForAddInvoice = (event) => {
    this.setState(
      { rowsPerPageForAddInvoice: +event.target.value, pageForAddInvoice: 0 },
      () => {
        this.getSellercustomerDataApi(this.state.invoiceSearchInput);
      },
    );
  };

  // table serach
  arcInvoiceModalSearchInput = (event) => {
    this.setState(
      {
        invoiceSearchInput: event.target.value,
        pageForAddInvoice: 0,
        rowsPerPageForAddInvoice: 25,
      },
      () => {
        this.getSellercustomerDataApi(this.state.invoiceSearchInput);
      },
    );
  };

  openModal = (index) => {
    this.setState(
      {
        targetId: index,
      },
      () => {
        this.setState({
          effitracInvShow: true,
        });
      },
    );
  };

  closeEffitracInvShowHandler = () => {
    this.setState({
      effitracInvShow: false,
      targetId: null,
    });
  };

  openEffitracDebitShowModal = (index) => {
    this.setState(
      {
        debitTargetId: index,
      },
      () => {
        this.setState({
          effitracDebitShow: true,
        });
      },
    );
  };

  closeEffitracDebitShowHandler = () => {
    this.setState({
      effitracDebitShow: false,
      debitTargetId: null,
    });
  };

  openEffitracCreditShowModal = (index) => {
    this.setState(
      {
        creditTargetId: index,
      },
      () => {
        this.setState({
          effitracCreditShow: true,
        });
      },
    );
  };

  closeEffitracCreditShowHandler = () => {
    this.setState({
      effitracCreditShow: false,
      creditTargetId: null,
    });
  };

  // seller customer api call for popup[modal]
  getSellercustomerDataApi = (serachIn) => {
    axios
      .post(`/arc/sellerCustomer`, {
        number_of_rows_per_page: this.state.rowsPerPageForAddInvoice,
        page_number: this.state.pageForAddInvoice,
        search_txt: serachIn,
        seller_code: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcSellerCustomerData: res.data.records,
          OriginalDataAllArcSellerCustomerData: res.data.records,
          rowCountForAddInvoice: res?.data?.row_count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ---------------------------------------------------------------------
  // FILTER SIDE PANEL — shared by the Invoice, Debit Note and Credit Note
  // tabs. One "Filter" button opens a compact panel next to the table
  // (Basic filters open, Advanced collapsed); applied filters show as chips.
  // Sends the same { match_type, conditions:[{field, operator:"in",
  // value:[...]}] } payload through the existing apply<Tab>DynamicFilters,
  // so pagination, search and export work exactly as before.
  // ---------------------------------------------------------------------
  HEADER_GROUP_BG = "#e6ecf2";
  HEADER_LABEL_BG = "#f5f7f9";
  HEADER_TEXT = "#03406f";
  HEADER_BORDER = "#d3dce5";

  // Basic filters are open by default; every other column goes to Advanced.
  FILTER_BASIC_KEYS = {
    invoice: ["invoice_no", "invoice_date", "due_date", "cust_name", "cust_code", "cust_gstin", "cust_pan", "pos", "gst_invoice_type"],
    debit: ["debit_note_no", "debit_note_date", "invoice_no", "invoice_date", "cust_name", "cust_code", "cust_gstin", "cust_pan", "pos"],
    credit: ["credit_note_no", "credit_note_date", "invoice_no", "invoice_date", "cust_name", "cust_code", "cust_gstin", "cust_pan", "pos"],
  };

  // Same value on every row of an entity, so filtering on them is useless.
  FILTER_EXCLUDED_KEYS = {
    invoice: ["entity_gstin", "branch_name"],
    debit: [],
    credit: [],
  };

  // Fixed-value fields shown as dropdowns (values seen in the API responses).
  FILTER_DROPDOWN_OPTIONS = {
    invoice: {
      gst_invoice_type: ["Regular B2B", "SEZ", "Export"],
      // invoice_type (Revenue Type) options come from the backend data —
      // see getInvoiceTypeOptions / loadInvoiceTypeOptions below.
    },
    debit: {},
    credit: {},
  };

  // Date fields shown with a calendar. The API stores DD-MM-YYYY, the
  // calendar works in YYYY-MM-DD, so values are converted both ways.
  FILTER_DATE_KEYS = ["invoice_date", "due_date", "debit_note_date", "credit_note_date"];

  // The filter API matches dates as YYYY-MM-DD (what the calendar gives),
  // but returns them the same way, while the listing shows DD-MM-YYYY.
  // These two helpers convert for display only.
  toDisplayDate = (v) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || "");
    return m ? `${m[3]}-${m[2]}-${m[1]}` : v;
  };

  normalizeFilterRecordDates = (records) =>
    (records || []).map((r) => {
      const out = { ...r };
      this.FILTER_DATE_KEYS.forEach((k) => {
        if (out[k]) out[k] = this.toDisplayDate(out[k]);
      });
      return out;
    });

  handleFilterDateChangeFor = (tab, key) => (event) => {
    const value = event.target.value || "";
    this.setState((prev) => ({
      [`${tab}DraftValues`]: { ...prev[`${tab}DraftValues`], [key]: value },
    }));
  };

  // Everything that differs between the three tabs lives here.
  getFilterTabCfg = (tab) => {
    const cap = tab.charAt(0).toUpperCase() + tab.slice(1);
    return {
      columns: this[`${tab}FilterableColumns`],
      applied: this.state[`${tab}AppliedFilters`],
      matchType: this.state[`${tab}FilterMatchType`],
      draft: this.state[`${tab}DraftValues`] || {},
      panelOpen: this.state[`${tab}FilterPanelOpen`],
      advancedOpen: this.state[`${tab}AdvancedFiltersOpen`],
      pageKey: tab === "invoice" ? "page" : `${tab}Page`,
      applyFn: this[`apply${cap}DynamicFilters`],
    };
  };

  getBasicFilterColumnsFor = (tab) =>
    this.FILTER_BASIC_KEYS[tab]
      .map((k) => this[`${tab}FilterableColumns`].find((c) => c.key === k))
      .filter(Boolean);

  getAdvancedFilterColumnsFor = (tab) =>
    this[`${tab}FilterableColumns`].filter(
      (c) =>
        !this.FILTER_BASIC_KEYS[tab].includes(c.key) &&
        !this.FILTER_EXCLUDED_KEYS[tab].includes(c.key)
    );

  getFilterFieldMetaFor = (tab, fieldKey) =>
    this[`${tab}FilterableColumns`].find((c) => c.key === fieldKey) ||
    this[`${tab}FilterableColumns`][0];

  // The Filter button toggles the panel; opening pre-fills it with what is applied.
  // Revenue Type (invoice_type) dropdown options, taken from the data the
  // backend returns — nothing is hardcoded. The listing is paginated, so the
  // distinct values are read once from the existing invoice listing api:
  // first a 1-row call for the total row_count, then one call for all rows.
  // Until that finishes (or if it fails) the values on the loaded page are used.
  toInvoiceTypeText = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "object") return String(v.name ?? v.value ?? v.label ?? "").trim();
    return String(v).trim();
  };

  collectInvoiceTypes = (records) =>
    Array.from(
      new Set(
        (records || []).map((r) => this.toInvoiceTypeText(r && r.invoice_type)).filter(Boolean),
      ),
    ).sort((a, b) => a.localeCompare(b));

  loadInvoiceTypeOptions = () => {
    if (this.invoiceTypeOptionsRequested) return;
    this.invoiceTypeOptionsRequested = true;
    const body = (rows) => ({
      number_of_rows_per_page: rows,
      page_number: 0,
      search_text: "",
      seller_code: localStorage.getItem("business_entity_id"),
    });
    axios
      .post(`/arc/sellerInvoice`, body(1))
      .then((res) =>
        axios.post(`/arc/sellerInvoice`, body(Math.max(res?.data?.row_count || 0, 1))),
      )
      .then((res) => {
        const records = res?.data?.records || res?.data?.record || [];
        this.setState({ invoiceTypeOptions: this.collectInvoiceTypes(records) });
      })
      .catch((error) => {
        console.log(error);
        this.invoiceTypeOptionsRequested = false;
      });
  };

  getInvoiceTypeOptions = (selected) => {
    const loaded = this.state.invoiceTypeOptions;
    const options = loaded.length
      ? loaded
      : this.collectInvoiceTypes(this.state.OriginalallArcInvoiceData);
    // keep a value that is already applied/selected visible in the dropdown
    return selected && !options.includes(selected) ? [...options, selected] : options;
  };

  openFilterPanelFor = (tab) => {
    if (this.state[`${tab}FilterPanelOpen`]) {
      this.setState({ [`${tab}FilterPanelOpen`]: false });
      return;
    }
    const draft = {};
    this.state[`${tab}AppliedFilters`].forEach((c) => {
      draft[c.field] = c.value;
    });
    this.setState({ [`${tab}FilterPanelOpen`]: true, [`${tab}DraftValues`]: draft });
    if (tab === "invoice") this.loadInvoiceTypeOptions();
  };

  // Closing without Apply discards unapplied edits.
  closeFilterPanelFor = (tab) => {
    this.setState({ [`${tab}FilterPanelOpen`]: false });
  };

  toggleAdvancedFiltersFor = (tab) => {
    this.setState((prev) => ({
      [`${tab}AdvancedFiltersOpen`]: !prev[`${tab}AdvancedFiltersOpen`],
    }));
  };

  handleFilterDraftChangeFor = (tab, key) => (event) => {
    const value = event.target.value;
    this.setState((prev) => ({
      [`${tab}DraftValues`]: { ...prev[`${tab}DraftValues`], [key]: value },
    }));
  };

  // Excel paste (newline / tab separated) -> comma separated "is any of".
  handleFilterPasteFor = (tab, key) => (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!pasted || !/[\r\n\t]/.test(pasted)) return;

    e.preventDefault();
    const joined = pasted
      .split(/[\r\n\t]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0)
      .join(", ");
    if (!joined) return;

    this.setState((prev) => {
      const current = ((prev[`${tab}DraftValues`] || {})[key] || "").replace(/\s+$/, "");
      const next = !current
        ? joined
        : current.endsWith(",")
          ? `${current} ${joined}`
          : `${current}, ${joined}`;
      return { [`${tab}DraftValues`]: { ...prev[`${tab}DraftValues`], [key]: next } };
    });
  };

  handleFilterKeyDownFor = (tab) => (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.applyFilterFromPanelFor(tab);
    }
  };

  // Apply: every non-empty input becomes a condition, sent in ONE api call.
  applyFilterFromPanelFor = (tab) => {
    const cfg = this.getFilterTabCfg(tab);
    const conditions = [
      ...this.getBasicFilterColumnsFor(tab),
      ...this.getAdvancedFilterColumnsFor(tab),
    ]
      .map((c) => ({ field: c.key, value: (cfg.draft[c.key] || "").trim() }))
      .filter((c) => c.value !== "");

    this.setState(
      {
        [`${tab}AppliedFilters`]: conditions,
        [`${tab}FilterPanelOpen`]: false,
        [cfg.pageKey]: 0,
      },
      () => cfg.applyFn(conditions, this.state[`${tab}FilterMatchType`])
    );
  };

  // Clear All: empties the inputs, removes every filter, reloads the full list.
  clearAllFilterPanelFor = (tab) => {
    const cfg = this.getFilterTabCfg(tab);
    this.setState(
      { [`${tab}DraftValues`]: {}, [`${tab}AppliedFilters`]: [], [cfg.pageKey]: 0 },
      () => cfg.applyFn([], this.state[`${tab}FilterMatchType`])
    );
  };

  // Chip cross: removes ONE applied filter and reloads the table.
  removeAppliedFilterFor = (tab, field) => {
    const cfg = this.getFilterTabCfg(tab);
    const conditions = cfg.applied.filter((c) => c.field !== field);
    this.setState(
      (prev) => {
        const draft = { ...prev[`${tab}DraftValues`] };
        delete draft[field];
        return {
          [`${tab}AppliedFilters`]: conditions,
          [`${tab}DraftValues`]: draft,
          [cfg.pageKey]: 0,
        };
      },
      () => cfg.applyFn(conditions, this.state[`${tab}FilterMatchType`])
    );
  };

  renderFilterButtonFor = (tab) => {
    const appliedCount = this.state[`${tab}AppliedFilters`].length;
    return (
      <button
        type="button"
        className="button-outlined-primary"
        onClick={() => this.openFilterPanelFor(tab)}
        style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
      >
        <FilterAltOutlinedIcon style={{ fontSize: "18px" }} />
        {appliedCount > 0 ? `Filter (${appliedCount})` : "Filter"}
      </button>
    );
  };

  // One label + white input (dropdown for fixed-value fields).
  renderFilterFieldFor = (tab, col) => {
    const draft = this.state[`${tab}DraftValues`] || {};
    let options = this.FILTER_DROPDOWN_OPTIONS[tab][col.key];
    if (tab === "invoice" && col.key === "invoice_type") {
      const dynamic = this.getInvoiceTypeOptions(draft[col.key]);
      options = dynamic.length ? dynamic : undefined; // none known yet -> plain text box
    }
    const common = {
      fullWidth: true,
      size: "small",
      variant: "outlined",
      value: draft[col.key] ?? "",
      onChange: this.handleFilterDraftChangeFor(tab, col.key),
      InputProps: { style: { background: "#fff" } },
    };

    return (
      <div key={col.key} style={{ minWidth: 0 }}>
        <label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
          {col.label}
        </label>
        {this.FILTER_DATE_KEYS.includes(col.key) ? (
          <ValidatorForm onSubmit={() => {}} style={{ margin: 0 }}>
            <DatePicker
              fullWidth
              name={`filter_${col.key}`}
              placeholder="Select date"
              value={draft[col.key] ? moment(draft[col.key], "YYYY-MM-DD").toDate() : ""}
              onChange={(v) =>
                this.handleFilterDateChangeFor(tab, col.key)({
                  target: { value: v && moment(v).isValid() ? moment(v).format("YYYY-MM-DD") : "" },
                })
              }
            />
          </ValidatorForm>
        ) : options ? (
          <TextField {...common} select SelectProps={{ native: true }}>
            <option value="">Select</option>
            {options.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </TextField>
        ) : (
          <TextField
            {...common}
            placeholder={`Enter ${col.label.toLowerCase()}`}
            onPaste={this.handleFilterPasteFor(tab, col.key)}
            onKeyDown={this.handleFilterKeyDownFor(tab)}
          />
        )}
      </div>
    );
  };

  renderFilterPanelFor = (tab) => {
    const cfg = this.getFilterTabCfg(tab);
    if (!cfg.panelOpen) return null;

    const advancedColumns = this.getAdvancedFilterColumnsFor(tab);
    const advancedCount = advancedColumns.filter(
      (c) => (cfg.draft[c.key] || "").trim() !== ""
    ).length;

    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    };

    return (
      <div
        style={{
          width: 440,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          minHeight: 360,
          maxHeight: "calc(100vh - 260px)",
          border: `1px solid ${this.HEADER_TEXT}`,
          borderRadius: 4,
          background: "#fff",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(3,64,111,0.12)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 6px 6px 14px",
            background: this.HEADER_TEXT,
            color: "#ffffff",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Filters</span>
          <Tooltip title="Close" arrow>
            <IconButton size="small" onClick={() => this.closeFilterPanelFor(tab)}>
              <ClearIcon style={{ fontSize: "16px", color: "#ffffff" }} />
            </IconButton>
          </Tooltip>
        </div>

        {/* Body: Basic (open) + Advanced (collapsed) */}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "12px 14px",
            background: "#eef3f8",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              marginBottom: "10px",
            }}
          >
            Basic Filters
          </div>
          <div style={gridStyle}>
            {this.getBasicFilterColumnsFor(tab).map((col) =>
              this.renderFilterFieldFor(tab, col)
            )}
          </div>

          <div
            role="button"
            onClick={() => this.toggleAdvancedFiltersFor(tab)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              marginTop: "14px",
              padding: "10px 0",
              borderTop: `1px solid ${this.HEADER_BORDER}`,
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              userSelect: "none",
            }}
          >
            <span>
              {advancedCount > 0
                ? `Advanced Filters (${advancedCount})`
                : "Advanced Filters"}
            </span>
            {cfg.advancedOpen ? (
              <ExpandLessIcon style={{ fontSize: "20px" }} />
            ) : (
              <ExpandMoreIcon style={{ fontSize: "20px" }} />
            )}
          </div>
          {cfg.advancedOpen && (
            <div style={gridStyle}>
              {advancedColumns.map((col) => this.renderFilterFieldFor(tab, col))}
            </div>
          )}
        </div>

        {/* Footer - bottom right */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "10px 14px",
            background: this.HEADER_GROUP_BG,
            borderTop: `1px solid ${this.HEADER_BORDER}`,
          }}
        >
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={() => this.clearAllFilterPanelFor(tab)}
          >
            Clear All
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={() => this.applyFilterFromPanelFor(tab)}
          >
            Apply Filters
          </button>
        </div>
      </div>
    );
  };

  // Applied filters as small chips, each with its own cross.
  renderAppliedFilterChipsFor = (tab) => {
    const applied = this.state[`${tab}AppliedFilters`];
    if (applied.length === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          marginBottom: "8px",
        }}
      >
        {applied.map((c) => (
          <Chip
            key={c.field}
            size="small"
            variant="outlined"
            label={`${this.getFilterFieldMetaFor(tab, c.field).label}: ${this.FILTER_DATE_KEYS.includes(c.field) ? this.toDisplayDate(c.value) : c.value
              }`}
            onDelete={() => this.removeAppliedFilterFor(tab, c.field)}
            style={{
              maxWidth: 280,
              backgroundColor: this.HEADER_GROUP_BG,
              color: this.HEADER_TEXT,
              borderColor: this.HEADER_BORDER,
            }}
          />
        ))}
      </div>
    );
  };

  // seller invoice get api function
  getSellerInvoiceDataApi = (invoiceSearch) => {
    let finalData = {
      number_of_rows_per_page: this.state.rowsPerPage,
      page_number: this.state.page,
      search_text: invoiceSearch,
      seller_code: localStorage.getItem("business_entity_id"),
    };

    if (this.state.fromPeriod && this.state.toPeriod) {
      finalData["from_period"] = moment(this.state.fromPeriod).format(
        "YYYY-MM-DD",
      );
      finalData["to_period"] = moment(this.state.toPeriod).format("YYYY-MM-DD");
    }
    axios
      .post(`/arc/sellerInvoice`, finalData)
      .then((res) => {
        this.setState({
          allArcInvoiceData: res.data.records,
          OriginalallArcInvoiceData: res.data.records,

          invoiceApiDataForDebitModal: res.data.records,
          invoiceApiSearchDataForDebitModal: res.data.records,

          invoiceApiDataForCreditModal: res.data.records,
          invoiceApiSearchDataForCreditModal: res.data.records,
          rowCount: res.data.row_count,
          loaderForInvoice: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // seller invoice filter api function (same pattern as getSellercustomerFilterApi)
  // Sends the current page/rowsPerPage along with the filters so the
  // backend can paginate the filtered result set. Does NOT reset the page
  // here — resetting page is applyInvoiceInlineFilters' job (only when the
  // filter SET changes), otherwise this function is reused by the
  // pagination handlers to fetch subsequent pages of an already-active
  // filter.
  getSellerInvoiceFilterApi = (filters = {}) => {
    this.setState({ loaderForInvoice: true, activeFilters: filters });

    axios
      .post(`/arc/sellerInvoiceFilter`, {   // ← change URL if your route is different
        seller_code: localStorage.getItem("business_entity_id"),
        search_txt: this.state.invoiceSearchInput || "",
        filters: filters,
        number_of_rows_per_page: this.state.rowsPerPage,
        page_number: this.state.page,
      })
      .then((res) => {
        this.setState({
          allArcInvoiceData: this.normalizeFilterRecordDates(res.data.records),
          OriginalallArcInvoiceData: this.normalizeFilterRecordDates(res.data.records),
          rowCount: res.data.row_count || 0,
          loaderForInvoice: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderForInvoice: false });
        toast.error("Failed to fetch filtered data");
      });
  };


  getSellerDebitNoteFilterApi = (filters = {}) => {
    this.setState({ loaderForDebit: true, debitActiveFilters: filters });

    axios
      .post(`/arc/sellerdebitNoteFilter`, {   // ← change URL if your route is different
        seller_code: localStorage.getItem("business_entity_id"),
        search_txt: this.state.debitSearchInput || "",
        filters: filters,
        number_of_rows_per_page: this.state.debitRowsPerPage,
        page_number: this.state.debitPage,
      })
      .then((res) => {
        this.setState({
          allArcSellerdebitNote: this.normalizeFilterRecordDates(res.data.records),
          OriginalDataAllArcSellerdebitNote: this.normalizeFilterRecordDates(res.data.records),
          debitRowCount: res.data.row_count || 0,
          loaderForDebit: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderForDebit: false });
        toast.error("Failed to fetch filtered data");
      });
  };

  getSellerCreditNoteFilterApi = (filters = {}) => {
    this.setState({ loaderForCredit: true, creditActiveFilters: filters });

    axios
      .post(`/arc/sellercreditNoteFilter`, {   // ← change URL if your route is different
        seller_code: localStorage.getItem("business_entity_id"),
        search_txt: this.state.creditSearchInput || "",
        filters: filters,
        number_of_rows_per_page: this.state.rowsPerPage, // matches sellerCreditNoteGetApi's existing pattern
        page_number: this.state.creditPage,
      })
      .then((res) => {
        this.setState({
          allArcSellerCreditNote: this.normalizeFilterRecordDates(res.data.records),
          creditRowCount: res.data.row_count || 0,
          loaderForCredit: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderForCredit: false });
        toast.error("Failed to fetch filtered data");
      });
  };

  // seller debit note get api function
  sellerDebitNoteGetApi = (debitSearch) => {
    const finalData = {
      number_of_rows_per_page: this.state.debitRowsPerPage,
      page_number: this.state.debitPage,
      search_text: debitSearch,
      seller_code: localStorage.getItem("business_entity_id"),
    };
    if (this.state.fromPeriod && this.state.toPeriod) {
      finalData["from_period"] = moment(this.state.fromPeriod).format(
        "YYYY-MM-DD",
      );
      finalData["to_period"] = moment(this.state.toPeriod).format("YYYY-MM-DD");
    }
    axios
      .post(`/arc/sellerdebitNote`, finalData)
      .then((res) => {
        this.setState({
          allArcSellerdebitNote: res.data.records,
          OriginalDataAllArcSellerdebitNote: res.data.records,

          debitRowCount: res.data.row_count,
          loaderForDebit: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // seller credit note get api function
  sellerCreditNoteGetApi = (creditSearch) => {
    const finalData = {
      number_of_rows_per_page: this.state.rowsPerPage,
      page_number: this.state.creditPage,
      search_text: creditSearch,
      seller_code: localStorage.getItem("business_entity_id"),
    };
    if (this.state.fromPeriod && this.state.toPeriod) {
      finalData["from_period"] = moment(this.state.fromPeriod).format(
        "YYYY-MM-DD",
      );
      finalData["to_period"] = moment(this.state.toPeriod).format("YYYY-MM-DD");
    }
    axios
      .post(`/arc/sellercreditNote`, finalData)
      .then((res) => {
        this.setState({
          allArcSellerCreditNote: res.data.records,
          creditRowCount: res.data.row_count,
          loaderForCredit: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSellerLastUploadDate = () => {
    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id",
        )}/Seller Invoice`,
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = dateFormatWithDash(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDateInvoice: Date,
          lastUploadTimeInvoice: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id",
        )}/Seller Debit Note`,
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = dateFormatWithDash(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDateDebit: Date,
          lastUploadTimeDebit: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id",
        )}/Seller Credit Note`,
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = dateFormatWithDash(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDateCredit: Date,
          lastUploadTimeCredit: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiForPlaceOfSupply = () => {
    axios
      .get(`/get_pos_state_data`)
      .then((res) => {
        this.setState({ getApiForPlaceOfSupply: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  functionForDebitDrawer = () => {
    this.setState({
      openZohoDebitDrawer: true,
      messageForConnectionForInvoice: "Connection Established",
      buttonColorForInvoice: "green",
    });
    this.clickDebitNote();
  };

  functionForCreditDrawer = () => {
    this.setState({
      openZohoCreditDrawer: true,
      messageForConnectionForInvoice: "Connection Established",
      buttonColorForInvoice: "green",
    });
    this.clickCreditNote();
  };

  getApiForClientID = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        res.data.record
          .filter((v) => v.source_system === "ZOHO")
          .map((value) =>
            localStorage.setItem("Client_ID", value.connection_info.client_id),
          );
        res?.data?.record.filter((v) => {
          if (v.source_system === "Effitrac" || v.source_system === "Tally") {
            localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
          }
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  // last upload table data fn
  getSellerUploadHistoryData = () => {
    if (this.state.section_name === "Invoice") {
      axios
        .get(
          `/arc/get_data_upload_history/${localStorage.getItem(
            "business_entity_id",
          )}/${2}`,
        )
        .then((res) => {
          this.setState({ uploadHistoryTableData: res.data.record });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (this.state.section_name === "Debit Note") {
      axios
        .get(
          `/arc/get_data_upload_history/${localStorage.getItem(
            "business_entity_id",
          )}/${4}`,
        )
        .then((res) => {
          this.setState({ uploadHistoryTableData: res.data.record });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (this.state.section_name === "Credit Note") {
      axios
        .get(
          `/arc/get_data_upload_history/${localStorage.getItem(
            "business_entity_id",
          )}/${3}`,
        )
        .then((res) => {
          this.setState({ uploadHistoryTableData: res.data.record });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  componentDidMount() {
    this.clickInvoice();
    let domain = new URL(window.location).searchParams;
    let code = domain.get("code");
    code && this.setState({ grantToken: code });
    let drawer = domain.get("drawer");

    drawer &&
      localStorage.getItem("DrawerForInvoice") === "true" &&
      this.setState({
        openZohoDrawerForInvoice: true,
        messageForConnectionForInvoice: "Connection Established",
        buttonColorForInvoice: "green",
      });

    drawer &&
      localStorage.getItem("DrawerForDebit") === "true" &&
      this.functionForDebitDrawer();
    drawer &&
      localStorage.getItem("DrawerForCredit") === "true" &&
      this.functionForCreditDrawer();

    let url = window.location;
    this.setState({ url: url.origin });
    localStorage.setItem("urlOrigin", url.origin);
    localStorage.setItem("pathName", url.pathname);

    // this.getApiForClientID();
    this.getSellercustomerDataApi();
    this.getSellerInvoiceDataApi();
    this.sellerDebitNoteGetApi();
    this.sellerCreditNoteGetApi();
    this.getSellerLastUploadDate();
    this.getApiForPlaceOfSupply();
    this.getSellerUploadHistoryData();
  }

  componentWillUnmount() { }

  getErpConnectorName = () => {
    axios
      .get(
        `/arc/verify_erp_data_pull_eligibility/${localStorage.getItem("business_entity_id")}`,
      )
      .then((res) => {
        if (res?.data?.status) {
          this.setState({ erpConnectorName: res?.data?.data });
        }
      })
      .catch((err) => { });
  };

  componentDidUpdate() {
    if (
      this.state.buttonColorForInvoice === "green" &&
      !this.state.flagForZoho
    ) {
      this.setState({ flagForZoho: true });
      variableForTimer = setInterval(() => {
        this.setState((prevstate) => ({
          timerForZoho: prevstate.timerForZoho - 1,
        }));
      }, 1000);
    }

    if (this.state.timerForZoho === 0) {
      clearInterval(variableForTimer);
      this.setState({
        flagForZoho: false,
        timerForZoho: 10,
        buttonColorForInvoice: "red",
      });
    }
  }

  // -----------------------------------------------Table Search--------------------------------------
  //---Search field---
  handleSearchInputChange = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  globalSearch = (event) => {
    // invoice serach
    if (this.state.isEffitrac) {
      const query = this.state.searchInput.trim().toLowerCase();
      const searchAdminData = this.state.oldInvoiceData.filter((item) => {
        return Object.keys(item).some((key) => {
          const regex = new RegExp(
            `^${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").trim()}`,
            "i",
          );
          return regex.test(String(item[key]));
        });
      });

      this.setState({ invoiceData: searchAdminData });
    } else if (this.state.isDebitEffitrac) {
      let searchedDataForDebitNote = this.state.oldDebitEffitracData.filter(
        (value) => {
          const query = this.state.searchInput.trim().toLowerCase();
          return (
            String(value.invoice_no).toLowerCase().indexOf(query) >= 0 ||
            String(value.debit_note_no).toLowerCase().indexOf(query) >= 0 ||
            String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
            String(value.invoice_date).indexOf(query) >= 0 ||
            String(value.total_amount).toLowerCase().indexOf(query) >= 0 ||
            String(numberFormat(value.total_amount))
              .toLowerCase()
              .indexOf(query) >= 0
          );
        },
      );
      this.setState({ debitEffitracData: searchedDataForDebitNote });
    } else if (this.state.isCreditEffitrac) {
      let searchedDataForCreditNote = this.state.searchForCreditDate.filter(
        (value) => {
          const query = this.state.searchInput.trim().toLowerCase();
          return (
            String(value.invoice_no).toLowerCase().indexOf(query) >= 0 ||
            String(value.invoice_date).indexOf(query) >= 0 ||
            String(value.credit_note_no).toLowerCase().indexOf(query) >= 0 ||
            String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
            String(value.total_amount).toLowerCase().indexOf(query) >= 0 ||
            String(numberFormat(value.total_amount))
              .toLowerCase()
              .indexOf(query) >= 0
          );
        },
      );
      this.setState({ creditEffitracData: searchedDataForCreditNote });
    }
  };

  // -----------------------------------------------Table Search End--------------------------------------

  // -----------------------------------------------file upload handler--------------------------------------
  fileUploader = (event) => {
    this.setState({ loading: true });
    //
    const file_data = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file_data);
    // var file_value;

    let dis = this;
    // var file_values=[]
    reader.onload = function () {
      let file_value = reader.result;
      axios
        .post(dis.state.uploadUrl, {
          file: file_value,
          business_entity_id: localStorage.getItem("business_entity_id"),
        })
        .then((data) => {
          if (data?.data?.message) {
            toast.error(data.data.message, { autoClose: 5000 });
            dis.setState({ loading: false });
            return;
          }

          dis.getSellerUploadHistoryData();
          dis.setState({ loading: false });

          if (dis.state.section_name === "Invoice") {
            axios
              .post(`/arc/sellerInvoice`, {
                number_of_rows_per_page: this.state.rowsPerPage,
                page_number: this.state.page,
                search_text: "",
                seller_code: localStorage.getItem("business_entity_id"),
              })
              .then((res) => {
                dis.setState({
                  allArcInvoiceData: res.data.records,
                  OriginalallArcInvoiceData: res.data.records,
                });
              })
              .catch((error) => {
                console.log(error);
              });
          } else if (dis.state.section_name === "Debit Note") {
            axios
              .post(`/arc/sellerdebitNote`, {
                number_of_rows_per_page: this.state.debitRowsPerPage,
                page_number: this.state.debitPage,
                search_text: "",
                seller_code: localStorage.getItem("business_entity_id"),
              })
              .then((res) => {
                dis.setState({
                  allArcSellerdebitNote: res.data.records,
                  OriginalDataAllArcSellerdebitNote: res.data.records,
                });
              })
              .catch((error) => {
                console.log(error);
              });
          } else if (dis.state.section_name === "Credit Note") {
            axios
              .post(`/arc/sellercreditNote`, {
                number_of_rows_per_page: this.state.rowsPerPage,
                page_number: this.state.creditPage,
                search_text: "",
                seller_code: localStorage.getItem("business_entity_id"),
              })
              .then((res) => {
                dis.setState({
                  allArcSellerCreditNote: res.data.records,
                  OriginalSellerCreditNote: res.data.records,
                });
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          const msg = error?.response?.data?.message;
          toast.error(msg, { autoClose: 5000 });
          dis.setState({ loading: false });
        });
    };
  };

  // excel download
  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };
  export_to_excel_Zoho = (dataFromZoho) => {
    const filename = `${this.state.section_name}.xlsx`;
    let url = "";

    if (this.state.section_name === "Invoice") {
      url = "/seller_invoice_extract/download";
    } else if (this.state.section_name === "Debit Note") {
      url = "/seller_debit_note_extract/download";
    } else {
      url = "/seller_credit_note_extract/download";
    }

    axios
      .post(
        url,
        {
          seller_code: localStorage.getItem("business_entity_id"),
          data: dataFromZoho,
          zoho_export: true,
        },
        { responseType: "arraybuffer" }
      )
      .then((res) => {
        const contentType = res.headers["content-type"];

        if (contentType && contentType.includes("application/json")) {
          const jsonString = new TextDecoder().decode(res.data);
          const json = JSON.parse(jsonString);

          if (json.file) {
            this.downloadBase64File(
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              json.file,
              filename
            );
          } else {
            toast.error(json.message || "Export failed", { autoClose: 2000 });
          }
        } else {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        }
      })
      .catch((error) => {
        console.error("Export failed:", error);
        toast.error("Failed to export file", { autoClose: 2000 });
      })
      .finally(() => {
        this.setState({ erpDataExportLoading: false }); // <-- THE FIX
      });
  };

  export_erp_data_to_excel = (apPointName, transId) => {

    this.setState({ erpDataExportLoading: true });

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `${this.state.section_name}.xlsx`;
    const payLoadData = {
      'business_entity_id': localStorage.getItem('business_entity_id'),
      'record_type': apPointName,
      'record_id': transId
    }

    axios.post('/export_erp_connector_data', payLoadData)

      .then((res) => {
        if (res) {
          // console.log("res?.data?.data.........", res?.data?.data)
          // data = res?.data?.data
          this.downloadBase64File(contentType, res.data.data, filename);
        } else {
          toast.error("Data not found. Please try again later.", {
            autoClose: 2000,
          });
          this.setState({ erpDataExportLoading: false });

        }

      })

      .catch((err) => {

        toast.error(err?.response?.data?.message || 'Error exporting data', {

          autoClose: 2000,

        });

        this.setState({ erpDataExportLoading: false }); // <-- was missing

      })
      .finally(() => {
        this.setState({ erpDataExportLoading: false, isExporting: false });
      })

  };

  // The invoice extract backend only uses the rows we send when they come in
  // `records`; its list keys differ slightly from the grid's, so map them.
  toInvoiceExtractRecords = (records) =>
    (records || []).map((r) => ({
      ...r,
      erp_cust_code: r.erp_cust_code ?? r.cust_code,
      cust_legal_name: r.cust_legal_name ?? r.cust_name,
    }));

  // Export with Invoice filters applied: fetch EVERY record matching the
  // applied filters (existing filter api, no pagination) and send exactly
  // those as `records`. A From/To period chosen in the export dialog narrows
  // them further by invoice date.
  export_filtered_invoice_to_excel = () => {
    const { activeFilters, fromPeriod, toPeriod } = this.state;
    const sellerCode = localStorage.getItem("business_entity_id");

    return axios
      .post(`/arc/sellerInvoiceFilter`, {
        seller_code: sellerCode,
        search_txt: this.state.invoiceSearchInput || "",
        filters: activeFilters,
        // one page as big as the whole filtered result => all matching records
        number_of_rows_per_page: Math.max(this.state.rowCount || 0, 1),
        page_number: 0,
      })
      .then((res) => {
        let records = this.normalizeFilterRecordDates(res?.data?.records);
        if (fromPeriod && toPeriod) {
          const from = moment(fromPeriod).startOf("day");
          const to = moment(toPeriod).endOf("day");
          records = records.filter((r) => {
            const d = moment(r.invoice_date, "DD-MM-YYYY", true);
            return d.isValid() && d.isBetween(from, to, null, "[]");
          });
        }
        if (records.length === 0) {
          toast.error("No records found for the selected filters", { autoClose: 2000 });
          return null;
        }
        return axios
          .post(
            `/seller_invoice_extract/download`,
            { seller_code: sellerCode, records: this.toInvoiceExtractRecords(records) },
            { responseType: "blob" },
          )
          .then((r) => {
            const blob = new Blob([r.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = `${this.state.section_name}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
          });
      })
      .catch((error) => {
        console.error("Export failed:", error);
        toast.error("Failed to export filtered data", { autoClose: 2000 });
      });
  };

  // The debit / credit extract backends write only the keys they know (any
  // other key makes them fail), so keep just those and rename the two list
  // keys that differ (cust_code -> erp_cust_code, cust_name -> cust_legal_name).
  NOTE_EXTRACT_KEYS = [
    "erp_cust_code", "cust_legal_name", "cust_gstin", "cust_pan", "entity_gstin", "branch_name",
    "gst_invoice_type", "supply_type", "voucher_id", "invoice_no", "invoice_date", "einvoice_irn",
    "debit_note_no", "debit_note_date", "credit_note_no", "credit_note_date", "due_date",
    "taxable_value", "non_taxable_adj", "gst_tax_rate", "applicable_percentage_of_tax",
    "igst", "cgst", "sgst", "cess", "tax_amount", "line_total", "total_amount",
    "item_name", "item_code", "uom", "total_quantity", "hsn_sac_code", "pos", "ecom_gstin",
    "rcm_applicability", "debit_note_reason", "credit_note_reason", "invoice_type", "contract_id",
    "item_supply_type", "non_taxable_ad",
  ];

  toNoteExtractRecords = (records) =>
    (records || []).map((r) => {
      const src = {
        ...r,
        erp_cust_code: r.erp_cust_code ?? r.cust_code,
        cust_legal_name: r.cust_legal_name ?? r.cust_name,
      };
      const out = {};
      this.NOTE_EXTRACT_KEYS.forEach((k) => {
        if (src[k] !== undefined) out[k] = src[k];
      });
      return out;
    });

  // Export with Debit / Credit Note filters applied: fetch EVERY record
  // matching the applied filters and send exactly those in `records` — the field
  // the debit / credit extract backends read (same as Invoice). A From/To
  // period chosen in the export dialog narrows them by the note date.
  export_filtered_note_to_excel = (tab) => {
    const isDebit = tab === "debit";
    const { fromPeriod, toPeriod } = this.state;
    const filters = isDebit ? this.state.debitActiveFilters : this.state.creditActiveFilters;
    const rowCount = isDebit ? this.state.debitRowCount : this.state.creditRowCount;
    const dateKey = isDebit ? "debit_note_date" : "credit_note_date";
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    return axios
      .post(isDebit ? `/arc/sellerdebitNoteFilter` : `/arc/sellercreditNoteFilter`, {
        seller_code: localStorage.getItem("business_entity_id"),
        search_txt: (isDebit ? this.state.debitSearchInput : this.state.creditSearchInput) || "",
        filters: filters,
        // one page as big as the whole filtered result => all matching records
        number_of_rows_per_page: Math.max(rowCount || 0, 1),
        page_number: 0,
      })
      .then((res) => {
        let records = this.normalizeFilterRecordDates(res?.data?.records);
        if (fromPeriod && toPeriod) {
          const from = moment(fromPeriod).startOf("day");
          const to = moment(toPeriod).endOf("day");
          records = records.filter((r) => {
            const d = moment(r[dateKey], "DD-MM-YYYY", true);
            return d.isValid() && d.isBetween(from, to, null, "[]");
          });
        }
        if (records.length === 0) {
          toast.error("No records found for the selected filters", { autoClose: 2000 });
          return null;
        }
        return axios
          .post(
            isDebit ? `/seller_debit_note_extract/download` : `/seller_credit_note_extract/download`,
            {
              seller_code: localStorage.getItem("business_entity_id"),
              records: this.toNoteExtractRecords(records),
            },
          )
          .then((r) => {
            this.downloadBase64File(contentType, r.data.file, `${this.state.section_name}.xlsx`);
          });
      })
      .catch((error) => {
        console.error("Export failed:", error);
        toast.error("Failed to export filtered data", { autoClose: 2000 });
      });
  };

  // Export All (Debit Note / Credit Note). Filters applied -> only the
  // records matching them (same filtered path as Export). No filters ->
  // every record, exactly as the backend already exports them.
  exportall_notes_to_excel = (tab) => {
    const isDebit = tab === "debit";
    const applied = isDebit ? this.state.debitAppliedFilters : this.state.creditAppliedFilters;
    const active = isDebit ? this.state.debitActiveFilters : this.state.creditActiveFilters;
    if (applied.length > 0 && active && Object.keys(active).length > 0) {
      this.setState({ isExportingAll: true });
      Promise.resolve(this.export_filtered_note_to_excel(tab)).finally(() => {
        this.setState({ isExportingAll: false });
      });
      return;
    }

    const extractUrl = isDebit ? `/seller_debit_note_extract/download` : `/seller_credit_note_extract/download`;
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `${isDebit ? "Debit Note" : "Credit Note"}.xlsx`;

    // No rows sent: the extract backend exports every record, as before.
    this.setState({ isExportingAll: true });
    axios
      .post(extractUrl, { seller_code: localStorage.getItem("business_entity_id") })
      .then((r) => {
        this.downloadBase64File(contentType, r.data.file, filename);
      })
      .catch((error) => {
        console.error("Export failed:", error);
        toast.error("Failed to export all data", { autoClose: 2000 });
      })
      .finally(() => {
        this.setState({ isExportingAll: false });
      });
  };

  export_to_excel = () => {
    // Debit / Credit tab with filters applied -> export only the filtered records.
    if (
      !this.state.isDebitEffitrac &&
      this.state.section_name === "Debit Note" &&
      this.state.debitAppliedFilters.length > 0 &&
      this.state.debitActiveFilters &&
      Object.keys(this.state.debitActiveFilters).length > 0
    ) {
      this.export_filtered_note_to_excel("debit");
      return;
    }
    if (
      !this.state.isCreditEffitrac &&
      this.state.section_name === "Credit Note" &&
      this.state.creditAppliedFilters.length > 0 &&
      this.state.creditActiveFilters &&
      Object.keys(this.state.creditActiveFilters).length > 0
    ) {
      this.export_filtered_note_to_excel("credit");
      return;
    }

    // Invoice tab with filters applied -> export only the filtered records.
    // Everything else (no filters, Debit/Credit, Zoho/ERP) runs unchanged below.
    if (
      !this.state.isEffitrac &&
      this.state.section_name === "Invoice" &&
      this.state.invoiceAppliedFilters.length > 0 &&
      this.state.activeFilters &&
      Object.keys(this.state.activeFilters).length > 0
    ) {
      this.export_filtered_invoice_to_excel();
      return;
    }

    const filename = `${this.state.section_name}.xlsx`;
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    let url = "";
    let data = [];
    let useBlobResponse = false;
    let sendZohoExportFlag = false;

    // ────────────────────────────────────────────────
    // Prepare URL + data + behavior flags
    // ────────────────────────────────────────────────
    if (this.state.isEffitrac && this.state.section_name === "Invoice") {
      url = "/seller_invoice_extract/download";
      sendZohoExportFlag = true;
      useBlobResponse = true;
      data = this.state.invoiceData.map((row) => ({
        ...row,
        invoiceDate: dateFormat(row.invoiceDate),
        dueDate: dateFormat(row.dueDate),
      }));
    } else if (
      this.state.isDebitEffitrac &&
      this.state.section_name === "Debit Note"
    ) {
      url = "/seller_debit_note_extract/download";
      sendZohoExportFlag = true;
      useBlobResponse = true;
      if (this.state.zohoDataForCWS) {
        data = this.state.debitEffitracData;
      } else {
        data = this.state.debitEffitracData.map((row) => ({
          ...row,
          invoiceDate: moment(row.invoiceDate).format("DD-MM-YYYY"),
          debitNoteDate: dateFormat(row.debitNoteDate),
        }));
      }
    } else if (
      this.state.isCreditEffitrac &&
      this.state.section_name === "Credit Note"
    ) {
      url = "/seller_credit_note_extract/download";
      sendZohoExportFlag = true;
      useBlobResponse = true;
      data = this.state.creditEffitracData.map((row) => ({
        ...row,
        invoiceDate: dateFormat(row.invoiceDate),
        creditNoteDate: dateFormat(row.creditNoteDate),
      }));
    }
    // ─── Non-Effitrac / ARC mode ─────────────────────
    else if (this.state.section_name === "Invoice") {
      url = "/seller_invoice_extract/download";
      useBlobResponse = true; // Changed to true - backend returns blob here too
      data = this.state.allArcInvoiceData;
    } else if (this.state.section_name === "Debit Note") {
      url = "/seller_debit_note_extract/download";
      // useBlobResponse = true;  // Changed to true - backend returns blob here too
      data = this.state.allArcSellerdebitNote;
    } else if (this.state.section_name === "Credit Note") {
      url = "/seller_credit_note_extract/download";
      // useBlobResponse = true;  // Changed to true - backend returns blob here too
      data = this.state.allArcSellerCreditNote;
    } else {
      console.warn("No matching section found");
      return;
    }

    // ────────────────────────────────────────────────
    // Common payload
    // ────────────────────────────────────────────────
    const payload = {
      seller_code: localStorage.getItem("business_entity_id"),
      data,
    };

    if (sendZohoExportFlag) {
      payload.zoho_export = true;
    }

    if (this.state.fromPeriod && this.state.toPeriod) {
      payload.from_period = moment(this.state.fromPeriod).format("YYYY-MM-DD");
      payload.to_period = moment(this.state.toPeriod).format("YYYY-MM-DD");
    }

    // ────────────────────────────────────────────────
    // Execute request
    // ────────────────────────────────────────────────
    if (useBlobResponse) {
      // ═══════════════════════════════════════════
      // Blob response (ALL endpoints use this now)
      // ═══════════════════════════════════════════
      axios
        .post(url, payload, {
          responseType: "blob",
        })
        .then((res) => {
          // Create a blob from the response
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Create download link and trigger download
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        })
        .catch((error) => {
          console.error("Export failed:", error);
        });
    } else {
      // ═══════════════════════════════════════════
      // Base64 response (for future use if needed)
      // ═══════════════════════════════════════════
      axios
        .post(url, payload)
        .then((res) => {
          this.downloadBase64File(contentType, res.data.file, filename);
        })
        .catch((error) => {
          console.error("Export failed:", error);
        });
    }
  };

  // -----------------------------------------------file upload handler end--------------------------------------
  // ---------------------------------------------file upload handler response-----------------------------------

  // refresh Upload History Table using refresh button
  refreshUploadHistoryTable = () => {
    this.getSellerUploadHistoryData();
    if (this.state.section_name === "Invoice") {
      this.getSellerInvoiceDataApi();
    } else if (this.state.section_name === "Debit Note") {
      this.sellerDebitNoteGetApi();
    } else {
      this.sellerCreditNoteGetApi();
    }
  };

  CollectionListActions = () => (
    <div>
      <a
        href={this.state.download_file}
        download={this.state.download_file_name}
        style={{ textDecoration: "none", marginRight: "30px" }}
      >
        {" "}
        <Button component="label" size="small" color="primary">
          <GetAppIcon style={{ fontSize: "20px" }} />
          {/* DOWNLOAD {this.state.section_name} TEMPLATE */}
          DOWNLOAD TEMPLATE
        </Button>
      </a>

      {canWrite("UPLOADING SALES") && (
        <Button component="label" size="small" color="primary">
          <PublishIcon style={{ fontSize: "20px" }} />
          {/* UPLOAD {this.state.section_name} TEMPLATE{" "} */}
          UPLOAD TEMPLATE
          <input
            accept=".xlsx"
            name="file"
            type="file"
            value=""
            hidden
            onChange={this.fileUploader}
          />
        </Button>
      )}

      <Button
        component="label"
        size="small"
        color="primary"
        style={{ float: "right" }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: "20px" }} />
        Refresh
      </Button>
      {/* <CreateButton label="add Customer" basePath={basePath} /> */}
    </div>
  );

  // ---------------------------------------------file upload handler response end--------------------------------------
  // ---------------------------------------------file upload button for all three--------------------------------------

  clickInvoice = (props) => {
    let promise = new Promise((reslove, reject) => {
      this.setState({
        showUploadHistroyTable: false,
        uploadUrl: "arc/excelupload/sellerinvoice",
        download_file: SellerInvoice,
        download_file_name: "seller_invoice.xlsx",
        section_name: "Invoice",
        debitNoteTableData: false,
        invoiceTableData: true,
        creditNoteTableData: false,
        showUploadData: false,
        disableEnableButtonForZoho: true,
        erpConnectorName: null,
        erpConnectorModelOpen: false,
        dateFilterOption: "withDateFilter",
        triggerModelFromToDate: false,
        fromPeriodDisplay: null,
        fromPeriod: null,
        toPeriodDisplay: "",
        toPeriod: null,
        activeFilters: {}, // clear any active invoice-table filters on tab switch
      });
      return reslove(true);
    });

    promise.then((value) => {
      this.getSellerUploadHistoryData();
      this.getSellerInvoiceDataApi();
      this.getErpConnectorName();
    });
  };

  clickDebitNote = (props) => {
    let promise = new Promise((resolve, reject) => {
      this.setState({
        invoiceData: null,
        oldInvoiceData: null,
        uploadUrl: "arc/excelupload/sellerdebit",
        download_file: SellerDebitNote,
        download_file_name: "seller_debit_note.xlsx",
        section_name: "Debit Note",
        debitNoteTableData: true,
        invoiceTableData: false,
        creditNoteTableData: false,
        showUploadData: false,
        disableEnableButtonForZoho: true,
        showUploadHistroyTable: false,
        erpConnectorName: null,
        erpConnectorModelOpen: false,
        dateFilterOption: "withDateFilter",
        triggerModelFromToDate: false,
        fromPeriodDisplay: null,
        fromPeriod: null,
        toPeriodDisplay: "",
        toPeriod: null,
      });
      return resolve(true);
    });
    promise.then((value) => {
      this.getSellerUploadHistoryData();
      this.sellerDebitNoteGetApi();
      this.getErpConnectorName();
    });
  };

  clickCreditNote = (props) => {
    let promise = new Promise((resolve, reject) => {
      this.setState({
        showUploadHistroyTable: false,
        uploadUrl: "arc/excelupload/sellercredit",
        download_file: SellerCreditNote,
        download_file_name: "seller_credit_note.xlsx",
        section_name: "Credit Note",
        debitNoteTableData: false,
        invoiceTableData: false,
        creditNoteTableData: true,
        showUploadData: false,
        disableEnableButtonForZoho: true,
        erpConnectorName: null,
        erpConnectorModelOpen: false,
        dateFilterOption: "withDateFilter",
        triggerModelFromToDate: false,
        fromPeriodDisplay: null,
        fromPeriod: null,
        toPeriodDisplay: "",
        toPeriod: null,
      });
      return resolve(true);
    });

    promise.then((value) => {
      this.getSellerUploadHistoryData();
      this.sellerCreditNoteGetApi();
      this.getErpConnectorName();
    });
  };

  // arc customer table header---
  arc_Customer_TableHeader() {
    const tableHeader = ["legal Name", "gstin", "pan", "select"];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  // arc Customer table body
  arc_CustomerTableBody__data() {
    const addGstin_Pan = (cust_gstin, cust_pan, cust_code) => {
      this.getSellercustomerDataApi();
      this.setState({
        addInvoiceData: {
          gstin: cust_gstin,
          pan: cust_pan,
          customerCode: cust_code,
        },
        customerTableModalShow: false,
        invoiceModalBackDrop: false,
        invoiceSearchInput: "",
      });
    };

    if (this.state.allArcSellerCustomerData.length >= 1) {
      return this.state.allArcSellerCustomerData.map((tableData, index) => {
        const { cust_gstin, cust_legal_name, cust_pan, cust_code } = tableData; //destructuring
        return (
          <tr key={index}>
            <td> {cust_legal_name}</td>
            <td>{cust_gstin}</td>
            <td>{cust_pan}</td>
            <td>
              <AddCircleOutlineIcon
                onClick={() => addGstin_Pan(cust_gstin, cust_pan, cust_code)}
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colspan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }
  // ------------------------------------------ARC invoice modal[ customer table] end---------------------------
  // ---------------------------------------------Arc debit note modal[invoice table]--------------------------------------
  // table search-----
  arcDebitNoteModalSearchInput = (event) => {
    this.setState({ debitNoteSearchInput: event.target.value }, () => {
      this.arcDebitNoteModalSearch(event);
    });
  };

  arcDebitNoteModalSearch = (event) => {
    let { debitNoteSearchInput } = this.state;
    let searchAdminData = this.state.invoiceApiSearchDataForDebitModal.filter(
      (value) => {
        const query = debitNoteSearchInput.toLowerCase();
        return (
          String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
          String(value.invoice_no).toLowerCase().indexOf(query) >= 0 ||
          String(value.invoice_date).toLowerCase().indexOf(query) >= 0 ||
          String(value.cust_pan).toLowerCase().indexOf(query) >= 0
        );
      },
    );
    this.setState({ invoiceApiDataForDebitModal: searchAdminData });
  };
  // invoice table header
  arc_debitNoteModal_TableHeader() {
    const tableHeader = [
      "gstin",
      "pan",
      "invoice number",
      "Invoice date",
      "select",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  arc_debitNoteModal_tableBody() {
    const addInvoice = (
      invoice_no,
      invoice_date,
      cust_gstin,
      cust_pan,
      cust_code,
    ) => {
      let invoice_Date_yyyy = dateFormat(invoice_date);
      this.getSellerInvoiceDataApi();
      this.setState({
        addDebitNoteData: {
          invoiceNo: invoice_no,
          invoiceDate: invoice_date,
          gstin: cust_gstin,
          pan: cust_pan,
          customerCode: cust_code,
        },
        debitModalShow: false,
        debitModalBackDrop: false,
        invoiceDateDisplay: invoice_Date_yyyy,
        debitNoteSearchInput: "",
      });
    };
    if (this.state.invoiceApiDataForDebitModal.length >= 1) {
      return this.state.invoiceApiDataForDebitModal.map((tableData, index) => {
        const { invoice_no, invoice_date, cust_gstin, cust_pan, cust_code } =
          tableData; //destructuring
        return (
          <tr key={index}>
            <td>{cust_gstin}</td>
            <td>{cust_pan}</td>
            <td>{invoice_no}</td>
            <td>{invoice_date}</td>
            <td>
              <AddCircleOutlineIcon
                onClick={() =>
                  addInvoice(
                    invoice_no,
                    invoice_date,
                    cust_gstin,
                    cust_pan,
                    cust_code,
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colspan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }

  // ---------------------------------------------Arc debit note modal[invoice table]--------------------------------------

  // ---------------------------------------------Arc credit note modal[invoice table]--------------------------------------
  // table search-----
  arcCreditNoteModalSearchInput = (event) => {
    this.setState({ creditNoteSearchInput: event.target.value }, () => {
      this.arcCreditNoteModalSearch(event);
    });
  };

  arcCreditNoteModalSearch = (event) => {
    let { creditNoteSearchInput } = this.state;
    let searchAdminData = this.state.invoiceApiSearchDataForCreditModal.filter(
      (value) => {
        const query = creditNoteSearchInput.toLowerCase();
        return (
          String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
          String(value.invoice_no).toLowerCase().indexOf(query) >= 0 ||
          String(value.invoice_date).toLowerCase().indexOf(query) >= 0 ||
          String(value.cust_pan).toLowerCase().indexOf(query) >= 0
        );
      },
    );
    this.setState({ invoiceApiDataForCreditModal: searchAdminData });
  };
  // invoice table header
  arc_creditNoteModal_TableHeader() {
    const tableHeader = [
      "gstin",
      "pan",
      "invoice number",
      "Invoice date",
      "select",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }

  arc_creditNoteModal_tableBody() {
    const addInvoice = (
      invoice_no,
      invoice_date,
      cust_gstin,
      cust_pan,
      cust_code,
    ) => {
      this.getSellerInvoiceDataApi();
      let invoice_Date_yyyy = dateFormat(invoice_date);
      this.setState({
        addCreditNoteData: {
          invoiceNo: invoice_no,
          invoiceDate: invoice_date,
          gstin: cust_gstin,
          pan: cust_pan,
          customerCode: cust_code,
        },
        creditNoteModalShow: false,
        creditNoteModalBackDrop: false,
        invoiceDateDisplay: invoice_Date_yyyy,
        creditNoteSearchInput: "",
      });
    };
    if (this.state.invoiceApiDataForCreditModal.length >= 1) {
      return this.state.invoiceApiDataForCreditModal.map((tableData, index) => {
        const { invoice_no, invoice_date, cust_gstin, cust_pan, cust_code } =
          tableData; //destructuring
        return (
          <tr key={index}>
            <td>{cust_gstin}</td>
            <td>{cust_pan}</td>
            <td>{invoice_no}</td>
            <td>{invoice_date}</td>
            <td>
              <AddCircleOutlineIcon
                onClick={() =>
                  addInvoice(
                    invoice_no,
                    invoice_date,
                    cust_gstin,
                    cust_pan,
                    cust_code,
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colspan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }

  // ---------------------------------------------Arc debit note modal[invoice table]--------------------------------------

  // ---------------------------------------------Arc invoice table--------------------------------------
  arc_SellerInvoiceTableHeader() {
    return this.renderGroupedHeaderFor(this.invoiceFilterableColumns, true);
  }

  renderInvoiceFilterActionBar = () =>
    this.renderFilterActionBarFor({
      stagedCount: this.stagedInvoiceFilterFieldCount(),
      hasStaged: this.hasStagedInvoiceFilterChanges(),
      appliedCount: this.state.invoiceAppliedFilters.length,
      onApply: this.applyInvoiceInlineFilters,
      onClearAll: this.handleClearAllInvoiceFilters,
    });

  renderInvoiceInlineFilterRow = () =>
    this.renderInlineFilterRowFor({
      columns: this.invoiceFilterableColumns,
      getValue: this.getInvoiceInlineFilterValue,
      onChange: this.handleInvoiceInlineFilterChange,
      onClear: this.clearInvoiceInlineFilterField,
      onApply: this.applyInvoiceInlineFilters,
      onClearAll: this.handleClearAllInvoiceFilters,
      appliedFilters: this.state.invoiceAppliedFilters,
      topOffset: "36px",
    });

  // invoice table data
  arc_SellerInvoice() {
    const showInvoiceDetails = (
      cust_code,
      einvoice_irn,
      modify_date,
      modified_date,
      po_no,
      cust_name,
      invoice_no,
      invoice_date,
      cust_gstin,
      gst_tax_rate,
      create_date,
      created_date,
      cust_pan,
      due_date,
      invoice_collection_agency,
      gst_invoice_type,
      taxable_value,
      adjusted_sgst,
      adjusted_cgst,
      adjusted_igst,
      cess,
      cgst,
      sgst,
      igst,
      adjusted_tax_amount,
      adjusted_non_taxable_adj,
      adjusted_total_amount,
      adjusted_taxable_value,
      tax_amount,
      non_taxable_adj,
      total_amount,
      hsn_sac_code,
      pos,
    ) => {
      this.setState({
        showInvoiceDetailsData: {
          cust_code: cust_code,
          cust_pan: cust_pan,
          due_date: due_date,
          invoice_collection_agency: invoice_collection_agency,
          gst_invoice_type: gst_invoice_type,
          taxable_value: taxable_value,
          adjusted_sgst: adjusted_sgst,
          adjusted_cgst: adjusted_cgst,
          adjusted_igst: adjusted_igst,
          cess: cess,
          gst_tax_rate: gst_tax_rate,
          hsnsaccode: hsn_sac_code,
          pos: pos,
          cgst: cgst,
          sgst: sgst,
          igst: igst,
          adjusted_tax_amount: adjusted_tax_amount,
          adjusted_non_taxable_adj: adjusted_non_taxable_adj,
          adjusted_total_amount: adjusted_total_amount,
          adjusted_taxable_value: adjusted_taxable_value,
          tax_amount: tax_amount,
          non_taxable_adj: non_taxable_adj,
          total_amount: total_amount,
          create_date: create_date,
          modify_date: modify_date,
          created_date: created_date,
          modified_date: modified_date,
        },
        showInvoiceDrawer: true,
      });
    };

    const editARCInvoice = (
      tax_amount,
      adjusted_non_taxable_adj,
      non_taxable_adj,
      adjusted_igst,
      modify_date,
      modified_date,
      taxable_value,
      adjusted_total_amount,
      adjusted_taxable_value,
      invoice_no,
      einvoice_irn,
      po_no,
      cgst,
      invoice_date,
      adjusted_tax_amount,
      create_date,
      created_date,
      hsn_sac_code,
      cust_pan,
      invoice_collection_agency,
      pos,
      total_amount,
      igst,
      adjusted_sgst,
      cust_code,
      seller_code,
      due_date,
      gst_tax_rate,
      gst_invoice_type,
      adjusted_cgst,
      cust_gstin,
      cust_name,
      cess,
      sgst,
    ) => {
      let invoice_date_yyyy = dateFormat(invoice_date);
      let due_date_yyyy = dateFormat(due_date);
      this.setState({
        editInvoiceData: {
          customerCode: cust_code,
          einvoiceIrn: einvoice_irn,
          poNo: po_no,
          invoiceNo: invoice_no,
          invoiceDate: invoice_date,
          gstin: cust_gstin,
          pan: cust_pan,
          dueDate: due_date,
          invoiceCollectionAgency: invoice_collection_agency,
          invoiceType: gst_invoice_type,
          taxableValue: taxable_value,
          cess: cess,
          cgst: cgst,
          sgst: sgst,
          igst: igst,
          taxAmount: tax_amount,
          nonTaxableValue: non_taxable_adj,
          totalAmount: total_amount,
          gstTaxRate: gst_tax_rate,
          hsnSacCode: hsn_sac_code,
          placeOfSupply: pos,
        },
        editInvoice_DrawerOpen: true,
        invoiceDateDisplay: invoice_date_yyyy,
        dueDateDisplay: due_date_yyyy,
      });
    };

    if (this.state.allArcInvoiceData.length >= 1) {
      return this.state.allArcInvoiceData.map((tableData, index) => {
        const {
          tax_amount,
          adjusted_non_taxable_adj,
          non_taxable_adj,
          adjusted_igst,
          modify_date,
          modified_date,
          taxable_value,
          adjusted_total_amount,
          adjusted_taxable_value,
          invoice_no,
          einvoice_irn,
          po_no,
          cgst,
          invoice_date,
          adjusted_tax_amount,
          create_date,
          created_date,
          hsn_sac_code,
          cust_pan,
          invoice_collection_agency,
          pos,
          total_amount,
          igst,
          adjusted_sgst,
          cust_code,
          seller_code,
          due_date,
          gst_tax_rate,
          gst_invoice_type,
          adjusted_cgst,
          cust_gstin,
          cust_name,
          cess,
          sgst,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            {this.invoiceFilterableColumns.map((col) => (
              <td
                key={col.key}
                style={{
                  borderRight: "1px solid #f1f5f9",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "6px 10px",
                  boxSizing: "border-box",
                  textAlign: "center",
                }}
              >
                {col.render
                  ? col.render(tableData)
                  : tableData[col.key] !== null && tableData[col.key] !== undefined
                    ? tableData[col.key]
                    : "-"}
              </td>
            ))}
            <td
              style={{
                position: "sticky",
                right: 0,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  showInvoiceDetails(
                    cust_code,
                    einvoice_irn,
                    modify_date,
                    modified_date,
                    po_no,
                    cust_name,
                    invoice_no,
                    invoice_date,
                    cust_gstin,
                    gst_tax_rate,
                    create_date,
                    created_date,
                    cust_pan,
                    due_date,
                    invoice_collection_agency,
                    gst_invoice_type,
                    taxable_value,
                    adjusted_sgst,
                    adjusted_cgst,
                    adjusted_igst,
                    cess,
                    cgst,
                    sgst,
                    igst,
                    adjusted_tax_amount,
                    adjusted_non_taxable_adj,
                    adjusted_total_amount,
                    adjusted_taxable_value,
                    tax_amount,
                    non_taxable_adj,
                    total_amount,
                    hsn_sac_code,
                    pos,
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loaderForInvoice) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.invoiceFilterableColumns.length + 1}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.invoiceFilterableColumns.length + 1}>
            {this.state.invoiceAppliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={() => this.clearAllFilterPanelFor("invoice")}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }
  // ---------------------------------------------Arc invoice table end--------------------------------------

  // ---------------------------------------------Arc invoice add--------------------------------------
  // add invoice drawer open handler---
  addInvoice_ButtonHandler = () => {
    this.setState({ addInvoice_DrawerOpen: true });
  };

  // invoice date handler
  handleInvoiceDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        addInvoiceData: {
          ...prevState.addInvoiceData,
          invoiceDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(-2)}-${yy}`,
        },
        invoiceDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      }));
    }
  };

  // due date handler
  handleDueDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        addInvoiceData: {
          ...prevState.addInvoiceData,
          dueDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(-2)}-${yy}`,
        },
        dueDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      }));
    }
  };
  // add Invoice inputfield handler---
  addInvoice_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      addInvoiceData: {
        ...prevState.addInvoiceData,
        [name]: String(value),
      },
    }));
  };

  // add invoice input field handler[number format]
  addInvoice_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      addInvoiceData: {
        ...prevState.addInvoiceData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // add invoice add submit handler
  addInvoice_submitHandler = () => {
    axios
      .post(`/arc/ui/sellerinvoice`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.addInvoiceData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.getSellerInvoiceDataApi();
          this.setState({
            addInvoice_DrawerOpen: false,
            addInvoiceData: {},
            dueDateDisplay: "",
            invoiceDateDisplay: "",
          });
          toast.success("Invoice added successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // add invoice drawer close handler---
  addInvoice_DrawerClose = () => {
    this.setState({
      addInvoice_DrawerOpen: false,
      addInvoiceData: {},
      dueDateDisplay: "",
      invoiceDateDisplay: "",
    });
  };
  // ---------------------------------------------Arc invoice add--------------------------------------

  // ---------------------------------------------Arc invoice edit-------------------------------------
  // edit invoice drawer open handler---
  editInvoice_ButtonHandler = () => {
    this.setState({ editInvoice_DrawerOpen: true });
  };

  // invoice date handler
  editInvoiceDateChangeHandler = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        editInvoiceData: {
          ...prevState.editInvoiceData,
          invoiceDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(-2)}-${yy}`,
        },
        invoiceDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      }));
    }
  };

  // due date handler
  editDueDateChangeHandler = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        editInvoiceData: {
          ...prevState.editInvoiceData,
          dueDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(-2)}-${yy}`,
        },
        dueDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      }));
    }
  };

  // edit Invoice inputfield handler---
  editInvoice_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      editInvoiceData: {
        ...prevState.editInvoiceData,
        [name]: String(value),
      },
    }));
  };

  // edit invoice input field handler[number format]
  editInvoice_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      editInvoiceData: {
        ...prevState.editInvoiceData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // edit invoice edit submit handler
  editInvoice_submitHandler = () => {
    axios
      .post(`/arc/ui/sellerinvoice`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.editInvoiceData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.getSellerInvoiceDataApi();
          this.setState({ editInvoice_DrawerOpen: false });
          toast.success("Invoice updated successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ editInvoice_DrawerOpen: false });
      });
  };

  // edit invoice drawer close handler---
  editInvoice_DrawerClose = () => {
    this.setState({
      editInvoice_DrawerOpen: false,
    });
  };
  // ---------------------------------------------Arc invoice edit end---------------------------------

  // --------------------arc debit note table-------------
  arc_SellerdebitNoteTableHeader() {
    return this.renderGroupedHeaderFor(this.debitFilterableColumns, true);
  }

  renderDebitFilterActionBar = () =>
    this.renderFilterActionBarFor({
      stagedCount: this.stagedDebitFilterFieldCount(),
      hasStaged: this.hasStagedDebitFilterChanges(),
      appliedCount: this.state.debitAppliedFilters.length,
      onApply: this.applyDebitInlineFilters,
      onClearAll: this.handleClearAllDebitFilters,
    });

  renderDebitInlineFilterRow = () =>
    this.renderInlineFilterRowFor({
      columns: this.debitFilterableColumns,
      getValue: this.getDebitInlineFilterValue,
      onChange: this.handleDebitInlineFilterChange,
      onClear: this.clearDebitInlineFilterField,
      onApply: this.applyDebitInlineFilters,
      onClearAll: this.handleClearAllDebitFilters,
      appliedFilters: this.state.debitAppliedFilters,
      topOffset: "36px",
    });

  arc_SellerdebitNotedata() {
    const showdebitnoteDetails = (
      tax_amount,
      non_taxable_adj,
      modify_date,
      modified_date,
      taxable_value,
      invoice_no,
      cgst,
      invoice_date,
      create_date,
      created_date,
      hsn_sac_code,
      cust_pan,
      pos,
      total_amount,
      igst,
      debit_note_date,
      cust_code,
      seller_code,
      gst_tax_rate,
      cust_gstin,
      cust_name,
      cess,
      debit_note_no,
      sgst,
      debit_note_reason,
    ) => {
      this.setState({
        showDebitNoteDetailsData: {
          cust_code: cust_code,
          debit_note_no: debit_note_no,
          debit_note_date: debit_note_date,
          taxable_value: taxable_value,
          cgst: cgst,
          sgst: sgst,
          igst: igst,
          total_amount: total_amount,
          non_taxable_adj: non_taxable_adj,
          debit_note_reason: debit_note_reason,
          tax_amount: tax_amount,
          gstTaxRate: gst_tax_rate,
          hsnSacCode: hsn_sac_code,
          placeOfSupply: pos,
          create_date: create_date,
          modify_date: modify_date,
          created_date: created_date,
          modified_date: modified_date,
        },
        showDebitNoteDrawer: true,
      });
    };

    const editARCDebitNote = (
      tax_amount,
      non_taxable_adj,
      modify_date,
      modified_date,
      taxable_value,
      invoice_no,
      cgst,
      invoice_date,
      create_date,
      created_date,
      hsn_sac_code,
      cust_pan,
      pos,
      total_amount,
      igst,
      debit_note_date,
      cust_code,
      seller_code,
      gst_tax_rate,
      cust_gstin,
      cust_name,
      cess,
      debit_note_no,
      sgst,
      debit_note_reason,
    ) => {
      let invoice_Date_yyyy = dateFormat(invoice_date);
      let debit_Note_yyyy = dateFormat(debit_note_date);
      this.setState({ placeOfsupply: pos });
      this.setState({
        editDebitNoteData: {
          customerCode: cust_code,
          invoiceNo: invoice_no,
          invoiceDate: invoice_date,
          gstin: cust_gstin,
          pan: cust_pan,

          debitNoteNo: debit_note_no,
          debitNoteDate: debit_note_date,
          taxableValue: taxable_value,
          cgst: cgst,
          sgst: sgst,
          igst: igst,
          cess: cess,
          totalAmount: total_amount,
          nonTaxableValue: non_taxable_adj,
          debitNoteReason: debit_note_reason,
          taxAmount: tax_amount,
          gstTaxRate: gst_tax_rate,
          hsnSacCode: hsn_sac_code,
          placeOfSupply: pos,
        },
        editDebitNote_DrawerOpen: true,
        invoiceDateDisplay: invoice_Date_yyyy,
        debitNoteDateDisplay: debit_Note_yyyy,
      });
    };

    if (this.state.allArcSellerdebitNote.length >= 1) {
      return this.state.allArcSellerdebitNote.map((tableData, index) => {
        const {
          tax_amount,
          non_taxable_adj,
          modify_date,
          modified_date,
          taxable_value,
          invoice_no,
          cgst,
          invoice_date,
          create_date,
          created_date,
          hsn_sac_code,
          cust_pan,
          pos,
          total_amount,
          igst,
          debit_note_date,
          cust_code,
          seller_code,
          gst_tax_rate,
          cust_gstin,
          cust_name,
          cess,
          debit_note_no,
          sgst,
          debit_note_reason,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            {this.debitFilterableColumns.map((col) => (
              <td
                key={col.key}
                style={{
                  borderRight: "1px solid #f1f5f9",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "6px 10px",
                  boxSizing: "border-box",
                  textAlign: "center",
                }}
              >
                {col.render
                  ? col.render(tableData)
                  : tableData[col.key] !== null && tableData[col.key] !== undefined
                    ? tableData[col.key]
                    : "-"}
              </td>
            ))}
            <td
              style={{
                position: "sticky",
                right: 0,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  showdebitnoteDetails(
                    tax_amount,
                    non_taxable_adj,
                    modify_date,
                    modified_date,
                    taxable_value,
                    invoice_no,
                    cgst,
                    invoice_date,
                    create_date,
                    created_date,
                    hsn_sac_code,
                    cust_pan,
                    pos,
                    total_amount,
                    igst,
                    debit_note_date,
                    cust_code,
                    seller_code,
                    gst_tax_rate,
                    cust_gstin,
                    cust_name,
                    cess,
                    debit_note_no,
                    sgst,
                    debit_note_reason,
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loaderForDebit) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.debitFilterableColumns.length + 1}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.debitFilterableColumns.length + 1}>
            {this.state.debitAppliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={() => this.clearAllFilterPanelFor("debit")}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }
  // -------------------debit note table end----------------------

  // --------------------------add debit note -------------------------
  // add debit note drawer open handler---
  addDebitNote_ButtonHandler = () => {
    this.setState({ addDebitNote_DrawerOpen: true });
  };

  // debit note date handler
  handleDebitNoteDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        addDebitNoteData: {
          ...prevState.addDebitNoteData,
          debitNoteDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(
            -2,
          )}-${yy}`,
        },
        debitNoteDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      }));
    }
  };

  // add debit note inputfield handler---
  addDebitNote_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      addDebitNoteData: {
        ...prevState.addDebitNoteData,
        [name]: String(value),
      },
    }));
  };

  // add debit note input field handler[number format]
  addDebitNote_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      addDebitNoteData: {
        ...prevState.addDebitNoteData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // add debit note add submit handler
  addDebitNote_submitHandler = () => {
    axios
      .post(`/arc/ui/sellerdebit`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.addDebitNoteData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.sellerDebitNoteGetApi();
          this.setState({
            addDebitNote_DrawerOpen: false,
            addDebitNoteData: {},
            invoiceDateDisplay: "",
            debitNoteDateDisplay: "",
          });
          toast.success("Debit note added successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // add debit note drawer close handler---
  addDebitNote_DrawerClose = () => {
    this.setState({
      addDebitNote_DrawerOpen: false,
      addDebitNoteData: {},
      debitNoteDateDisplay: "",
      invoiceDateDisplay: "",
    });
  };

  // edit debit note drawer open handler---
  editDebitNote_ButtonHandler = () => {
    this.setState({ editDebitNote_DrawerOpen: true });
  };

  // debit note date handler
  editDebitNoteDateChangeHandler = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        editDebitNoteData: {
          ...prevState.editDebitNoteData,
          debitNoteDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(
            -2,
          )}-${yy}`,
        },
        debitNoteDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      }));
    }
  };

  // edit debit note inputfield handler---
  editDebitNote_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      editDebitNoteData: {
        ...prevState.editDebitNoteData,
        [name]: String(value),
      },
    }));
  };

  // edit debit note input field handler[number format]
  editDebitNote_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      editDebitNoteData: {
        ...prevState.editDebitNoteData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // edit debit note edit submit handler
  editDebitNote_submitHandler = () => {
    axios
      .post(`/arc/ui/sellerdebit`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.editDebitNoteData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.sellerDebitNoteGetApi();
          this.setState({
            editDebitNote_DrawerOpen: false,
          });
          toast.success("Debit Note updated successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        this.setState({
          editDebitNote_DrawerOpen: false,
        });
      });
  };

  // edit debit note drawer close handler---
  editDebitNote_DrawerClose = () => {
    this.setState({
      editDebitNote_DrawerOpen: false,
    });
  };

  // credit note table
  arc_SellerCebitNoteTableHeader() {
    return this.renderGroupedHeaderFor(this.creditFilterableColumns, true);
  }

  renderCreditFilterActionBar = () =>
    this.renderFilterActionBarFor({
      stagedCount: this.stagedCreditFilterFieldCount(),
      hasStaged: this.hasStagedCreditFilterChanges(),
      appliedCount: this.state.creditAppliedFilters.length,
      onApply: this.applyCreditInlineFilters,
      onClearAll: this.handleClearAllCreditFilters,
    });

  renderCreditInlineFilterRow = () =>
    this.renderInlineFilterRowFor({
      columns: this.creditFilterableColumns,
      getValue: this.getCreditInlineFilterValue,
      onChange: this.handleCreditInlineFilterChange,
      onClear: this.clearCreditInlineFilterField,
      onApply: this.applyCreditInlineFilters,
      onClearAll: this.handleClearAllCreditFilters,
      appliedFilters: this.state.creditAppliedFilters,
      topOffset: "36px",
    });

  arc_SellerCebitNotedata() {
    const showCreditnoteDetails = (
      tax_amount,
      non_taxable_adj,
      modify_date,
      modified_date,
      taxable_value,
      credit_note_reason,
      credit_note_no,
      invoice_no,
      cgst,
      invoice_date,
      is_discount_baddebt,
      create_date,
      created_date,
      hsn_sac_code,
      cust_pan,
      pos,
      total_amount,
      igst,
      cust_code,
      seller_code,
      gst_tax_rate,
      cust_gstin,
      cust_name,
      credit_note_date,
      cess,
      sgst,
    ) => {
      this.setState({
        showCreditNoteDetailsData: {
          cust_code: cust_code,
          credit_note_no: credit_note_no,
          credit_note_date: credit_note_date,
          taxable_value: taxable_value,
          cgst: cgst,
          sgst: sgst,
          igst: igst,
          total_amount: total_amount,
          non_taxable_adj: non_taxable_adj,
          credit_note_reason: credit_note_reason,
          tax_amount: tax_amount,
          is_discount_baddebt: is_discount_baddebt,
          gstTaxRate: gst_tax_rate,
          hsnSacCode: hsn_sac_code,
          placeOfSupply: pos,
          create_date: create_date,
          modify_date: modify_date,
          created_date: created_date,
          modified_date: modified_date,
        },
        showCreditNoteDrawer: true,
      });
    };

    const editARCCreditNote = (
      tax_amount,
      non_taxable_adj,
      modify_date,
      modified_date,
      taxable_value,
      credit_note_reason,
      credit_note_no,
      invoice_no,
      cgst,
      invoice_date,
      is_discount_baddebt,
      create_date,
      created_date,
      hsn_sac_code,
      cust_pan,
      pos,
      total_amount,
      igst,
      cust_code,
      seller_code,
      gst_tax_rate,
      cust_gstin,
      cust_name,
      credit_note_date,
      cess,
      sgst,
    ) => {
      let invoice_Date_yyyy = dateFormat(invoice_date);
      let credit_Note_yyyy = dateFormat(credit_note_date);

      this.setState({
        editCreditNoteData: {
          customerCode: cust_code,
          invoiceNo: invoice_no,
          invoiceDate: invoice_date,
          gstin: cust_gstin,
          pan: cust_pan,
          isDiscountBadDebtOtherreason: is_discount_baddebt,
          creditNoteNo: credit_note_no,
          creditNoteDate: credit_note_date,
          taxableValue: taxable_value,
          nonTaxableValue: non_taxable_adj,
          cgst: cgst,
          sgst: sgst,
          igst: igst,
          cess: cess,
          totalAmount: total_amount,
          gstTaxRate: gst_tax_rate,
          hsnSacCode: hsn_sac_code,
          placeOfSupply: pos,
          creditNoteReason: credit_note_reason,
          taxAmount: tax_amount,
        },
        editCreditNote_DrawerOpen: true,
        invoiceDateDisplay: invoice_Date_yyyy,
        creditNoteDateDisplay: credit_Note_yyyy,
      });
    };

    if (this.state.allArcSellerCreditNote.length >= 1) {
      return this.state.allArcSellerCreditNote.map((tableData, index) => {
        const {
          tax_amount,
          non_taxable_adj,
          modify_date,
          modified_date,
          taxable_value,
          credit_note_reason,
          credit_note_no,
          invoice_no,
          cgst,
          invoice_date,
          is_discount_baddebt,
          create_date,
          created_date,
          hsn_sac_code,
          cust_pan,
          pos,
          total_amount,
          igst,
          cust_code,
          seller_code,
          gst_tax_rate,
          cust_gstin,
          cust_name,
          credit_note_date,
          cess,
          sgst,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            {this.creditFilterableColumns.map((col) => (
              <td
                key={col.key}
                style={{
                  borderRight: "1px solid #f1f5f9",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  padding: "6px 10px",
                  boxSizing: "border-box",
                  textAlign: "center",
                }}
              >
                {col.render
                  ? col.render(tableData)
                  : tableData[col.key] !== null && tableData[col.key] !== undefined
                    ? tableData[col.key]
                    : "-"}
              </td>
            ))}
            <td
              style={{
                position: "sticky",
                right: 0,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  showCreditnoteDetails(
                    tax_amount,
                    non_taxable_adj,
                    modify_date,
                    modified_date,
                    taxable_value,
                    credit_note_reason,
                    credit_note_no,
                    invoice_no,
                    cgst,
                    invoice_date,
                    is_discount_baddebt,
                    create_date,
                    created_date,
                    hsn_sac_code,
                    cust_pan,
                    pos,
                    total_amount,
                    igst,
                    cust_code,
                    seller_code,
                    gst_tax_rate,
                    cust_gstin,
                    cust_name,
                    credit_note_date,
                    cess,
                    sgst,
                  )
                }
              />
            </td>
          </tr>
        );
      });
    } else if (this.state.loaderForCredit) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.creditFilterableColumns.length + 1}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.creditFilterableColumns.length + 1}>
            {this.state.creditAppliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={() => this.clearAllFilterPanelFor("credit")}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }
  // --------------------Credit note table end------------

  // --------------------------add Credit note -------------------------
  // add Credit note drawer open handler---
  addCreditNote_ButtonHandler = () => {
    this.setState({ addCreditNote_DrawerOpen: true });
  };

  // Credit note date handler
  handleCreditNoteDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        addCreditNoteData: {
          ...prevState.addCreditNoteData,
          creditNoteDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(
            -2,
          )}-${yy}`,
        },
        creditNoteDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(
          pad + dd
        ).slice(-2)}`,
      }));
    }
  };

  // add Credit note inputfield handler---
  addCreditNote_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      addCreditNoteData: {
        ...prevState.addCreditNoteData,
        [name]: String(value),
      },
    }));
  };

  // add Credit note input field handler[number format]
  addCreditNote_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      addCreditNoteData: {
        ...prevState.addCreditNoteData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // add Credit note add submit handler
  addCreditNote_submitHandler = () => {
    axios
      .post(`/arc/ui/sellercredit`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.addCreditNoteData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.sellerCreditNoteGetApi();
          this.setState({
            addCreditNote_DrawerOpen: false,
            addCreditNoteData: {},
            creditNoteDateDisplay: "",
            invoiceDateDisplay: "",
          });
          toast.success("Credit Note added successfully", { autoClose: 2000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // add Credit note drawer close handler---
  addCreditNote_DrawerClose = () => {
    this.setState({
      addCreditNote_DrawerOpen: false,
      addCreditNoteData: {},
      creditNoteDateDisplay: "",
      invoiceDateDisplay: "",
    });
  };
  // ----------------------add Credit note end-------------------
  // --------------------------edit Credit note -------------------------
  // edit Credit note drawer open handler---
  editCreditNote_ButtonHandler = () => {
    this.setState({ editCreditNote_DrawerOpen: true });
  };

  // Credit note date handler
  editCreditNoteDateChangeHandler = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();

      this.setState((prevState) => ({
        editCreditNoteData: {
          ...prevState.editCreditNoteData,
          creditNoteDate: `${(pad + dd).slice(-2)}-${(pad + mm).slice(
            -2,
          )}-${yy}`,
        },
        creditNoteDateDisplay: `${yy}-${(pad + mm).slice(-2)}-${(
          pad + dd
        ).slice(-2)}`,
      }));
    }
  };

  // edit Credit note inputfield handler---
  editCreditNote_inputHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState((prevState) => ({
      editCreditNoteData: {
        ...prevState.editCreditNoteData,
        [name]: String(value),
      },
    }));
  };

  // edit Credit note input field handler[number format]
  editCreditNote_inputNumberHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    var numb = value.match(/\d/g);
    if (numb && numb.length > 10) return false;
    numb = numb ? numb.join("") : 0;

    this.setState((prevState) => ({
      editCreditNoteData: {
        ...prevState.editCreditNoteData,
        [name]: parseFloat(numb),
      },
    }));
  };

  // edit Credit note edit submit handler
  editCreditNote_submitHandler = () => {
    axios
      .post(`/arc/ui/sellercredit`, {
        entityGst: localStorage.getItem("gst"),
        records: [this.state.editCreditNoteData],
      })
      .then((res) => {
        if (res.data.status === false) {
          let error = "";
          Object.keys(res.data.record.details[0].errors_in).map((v, i) => {
            return (error +=
              String(v) + " " + res.data.record.details[0].errors_in[v]);
          });
          toast.error(error, {
            autoClose: 2000,
          });
        } else {
          this.sellerCreditNoteGetApi();
          this.setState({
            editCreditNote_DrawerOpen: false,
          });
          toast.success("Credit Note updated successfully", {
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        this.setState({
          editCreditNote_DrawerOpen: false,
        });
      });
  };

  // edit Credit note drawer close handler---
  editCreditNote_DrawerClose = () => {
    this.setState({
      editCreditNote_DrawerOpen: false,
    });
  };
  // ----------------------add Credit note end-------------------

  closeUploadData = () => {
    this.setState({ showUploadData: false });
    if (this.state.section_name === "Invoice") {
      this.getSellerInvoiceDataApi();
    } else if (this.state.section_name === "Debit Note") {
      this.sellerDebitNoteGetApi();
    } else if (this.state.section_name === "Credit Note") {
      this.sellerCreditNoteGetApi();
    }
  };

  // close invoice drawer
  closeInvoiceDrawer = () => {
    this.setState({ showInvoiceDrawer: false });
  };

  // close credit drawer
  closeShowDrawer_CreditNoteData = () => {
    this.setState({ showCreditNoteDrawer: false });
  };
  // close debit Drawer
  closeShowDrawer_DebitNoteData = () => {
    this.setState({ showDebitNoteDrawer: false });
  };

  customerTableModalOpen = () => {
    this.setState({
      customerTableModalShow: true,
      invoiceModalBackDrop: true,
    });
  };

  customerTableModalClose = () => {
    this.setState({
      customerTableModalShow: false,
      invoiceModalBackDrop: false,
    });
  };

  // debit note modal
  debitModalOpen = () => {
    this.setState({
      debitModalShow: true,
      debitModalBackDrop: true,
    });
  };

  debitModalClose = () => {
    this.setState({
      debitModalShow: false,
      debitModalBackDrop: false,
    });
  };

  // debit note modal
  creditNoteModalOpen = () => {
    this.setState({
      creditNoteModalShow: true,
      creditNoteModalBackDrop: true,
    });
  };

  creditNoteModalClose = () => {
    this.setState({
      creditNoteModalShow: false,
      creditNoteModalBackDrop: false,
    });
  };

  // import Effitrac /tally
  importEffitracDrawerOpen = () => {
    this.setState({ openImportEffitracDrawer: true });
  };

  importToCWS = (data, uploadType = "Zoho", transId) => {
    this.setState({ importToCwsLoading: true });
    let payLoadData = {};
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: data,
        upload_type: uploadType,
        api_point_name: "invoice",
        is_import: true,
        record_id: transId,
      };
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: data.map((row, index) => {
          let newRow = { ...row };
          newRow["invoiceDate"] = newRow["invoiceDate"]
            ? dateFormatWithDash(newRow["invoiceDate"])
            : null;
          newRow["dueDate"] = newRow["dueDate"]
            ? dateFormatWithDash(newRow["dueDate"])
            : null;
          return newRow;
        }),
        upload_type: uploadType,
      };
    }
    axios
      .post("/arc/effitrac/sellerinvoice", payLoadData)
      .then((res) => {
        this.setState({
          showUploadHistroyTable: true,
        });
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });
        this.refreshUploadHistoryTable();
      })
      .catch((error) => {
        if (error?.response?.data?.message !== "") {
          toast.error(error?.response?.data?.message, {
            autoClose: 5000,
            progress: 0,
          });
        } else {
          toast.error("Server Error Try After Some Time", {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .finally(() => {
        this.setState({ importToCwsLoading: false });
        this.closeErpDrawer();
      });
  };


  // Export All (Invoice): with no filters applied, one call to the invoice
  // extract with only the seller code. No records are sent, so the backend
  // exports everything from the database. With filters applied it exports
  // only the matching records (see the check below).
  exportall_to_excel = () => {
    // Invoice filters applied -> export only the records matching them
    // (same filtered path the Export button uses). No filters -> unchanged.
    if (
      !this.state.isEffitrac &&
      this.state.invoiceAppliedFilters.length > 0 &&
      this.state.activeFilters &&
      Object.keys(this.state.activeFilters).length > 0
    ) {
      this.setState({ isExportingAll: true });
      Promise.resolve(this.export_filtered_invoice_to_excel()).finally(() => {
        this.setState({ isExportingAll: false });
      });
      return;
    }

    const filename = `${this.state.section_name || "Invoice"}.xlsx`;
    this.setState({ isExportingAll: true });
    axios
      .post(
        `/seller_invoice_extract/download`,
        { seller_code: localStorage.getItem("business_entity_id") },
        { responseType: "blob" },
      )
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to export all data", { autoClose: 2000 });
      })
      .finally(() => {
        this.setState({ erpDataExportLoading: false, isExportingAll: false });
      });
  };

  importEffitracInvoiceFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        invoiceFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importEffitracInvoiceToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        invoiceToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importEffitracDueFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        dueFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importEffitracDueToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        dueToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importEffitracFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importEffitracModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  closeImportEffitracDrawer = () => {
    this.setState({
      openImportEffitracDrawer: false,
      EffitracInvoiceFetchData: {},
    });
  };

  // import effitrac/tally debit section
  import_Debit_Effitrac_tally = () => {
    this.setState({ openImportEffitracDebitDrawer: true });
  };

  importDebitFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        invoiceFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importDebitToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        invoiceToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importDebitOriginalInvFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        originalInvFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importDebitOriginalInvToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        originalInvToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importDebitModifiedFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importDebitModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  debitEffitracFormSubmitHandler = () => {
    this.setState({ debitEffitracFormloading: true });
    this.setState((prevState) => ({
      effitracDebitFetchData: {
        ...prevState.effitracDebitFetchData,
        business_entity_id: parseInt(
          localStorage.getItem("business_entity_id"),
        ),
      },
    }));
    axios
      .post("/arc/effitrac/debitnotereport", this.state.effitracDebitFetchData)
      .then((res) => {
        if (res.data.status) {
          this.setState({
            debitEffitracData: res.data.records.records,
            oldDebitEffitracData: res.data.records.records,
            isDebitEffitrac: true,
            debitEffitracFormloading: false,
            openImportEffitracDebitDrawer: false,
            effitracDebitFetchData: {},
          });
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ debitEffitracFormloading: false });
      });
  };

  debitImportToCWS = (funData, uploadType = "Zoho") => {
    let dis = this;
    let recordForZohoAndEff;
    if (uploadType === "Zoho") {
      if (dis.state.zohoDataForCWS) {
        recordForZohoAndEff = funData.map((row) => {
          let newRow = { ...row };
          newRow["invoiceDate"] = newRow["invoiceDate"]
            ? dateFormatWithslash(newRow["invoiceDate"])
            : null;
          newRow["debitNoteDate"] = newRow["debitNoteDate"]
            ? moment(newRow["debitNoteDate"]).format("DD-MM-YYYY")
            : null;
          return newRow;
        });
      } else {
        recordForZohoAndEff = funData.map((row, index) => {
          let newRow = { ...row };
          newRow["invoiceDate"] = newRow["invoiceDate"]
            ? dateFormatWithslash(newRow["invoiceDate"])
            : null;
          newRow["debitNoteDate"] = newRow["debitNoteDate"]
            ? dateFormatWithDash(newRow["debitNoteDate"])
            : null;
          return newRow;
        });
      }
    }

    this.setState({ importToCwsLoading: true });
    let payLoadData = {};
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: funData,
        upload_type: uploadType,
        api_point_name: "debit",
        is_import: true,
      };
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: recordForZohoAndEff,
        upload_type: uploadType,
      };
    }

    axios
      .post("/arc/effitrac/sellerdebit", payLoadData)
      .then((res) => {
        this.setState({
          showUploadHistroyTable: true,
        });
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });
        this.refreshUploadHistoryTable();
      })
      .catch((error) => {
        toast.error(error.response?.data.message, {
          autoClose: 5000,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState({ importToCwsLoading: false });
        this.closeErpDrawer();
      });
  };

  closeDebitEffitractally = () => {
    this.setState({ openImportEffitracDebitDrawer: false });
  };

  // import effitrac/tally credit section
  import_Credit_Effitrac_tally = () => {
    this.setState({ openImportEffitracCreditDrawer: true });
  };

  importCreditFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        invoiceFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importCreditToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        invoiceToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importCreditModifiedFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importCreditModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importCreditOriginalInvFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        originalInvFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  importCreditOriginalInvToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        originalInvToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2,
        )}`,
      },
    }));
  };

  creditEffitracFormSubmitHandler = () => {
    this.setState({ creditEffitracFormloading: true });
    this.setState((prevState) => ({
      effitracCreditFetchData: {
        ...prevState.effitracCreditFetchData,
        business_entity_id: parseInt(
          localStorage.getItem("business_entity_id"),
        ),
      },
    }));
    axios
      .post(
        "/arc/effitrac/creditnotereport",
        this.state.effitracCreditFetchData,
      )
      .then((res) => {
        if (res.data.status) {
          this.setState({
            creditEffitracData: res.data.records.records,
            searchForCreditDate: res.data.records.records,
            isCreditEffitrac: true,
            creditEffitracFormloading: false,
            openImportEffitracCreditDrawer: false,
            effitracCreditFetchData: {},
          });
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ creditEffitracFormloading: false });
      });
  };

  creditImportToCWS = (dataFromCredit, uploadType = "Zoho", transId) => {
    this.setState({ importToCwsLoading: true });
    let payLoadData = {};
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataFromCredit,
        upload_type: uploadType,
        api_point_name: "salesCN",
        is_import: true,
        record_id: transId,
      };
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataFromCredit.map((row, index) => {
          let newRow = { ...row };
          newRow["invoiceDate"] = newRow["invoiceDate"]
            ? dateFormatWithDash(newRow["invoiceDate"])
            : null;
          newRow["creditNoteDate"] = newRow["creditNoteDate"]
            ? dateFormatWithDash(newRow["creditNoteDate"])
            : null;
          return newRow;
        }),
        upload_type: uploadType,
      };
    }
    axios
      .post("/arc/effitrac/sellercredit", payLoadData)
      .then((res) => {
        this.setState({
          showUploadHistroyTable: true,
        });
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });
        this.refreshUploadHistoryTable();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState({ importToCwsLoading: false });
        this.closeErpDrawer();
      });
  };

  closeCreditEffitractally = () => {
    this.setState({
      openImportEffitracCreditDrawer: false,
      effitracCreditFetchData: {},
    });
  };

  closeErpDrawer = () => {
    this.setState({
      erpConnectorModelOpen: false,
    });
  };

  // effitrac form handler---------------------------------------------------------------------------------------
  effitracFetchHandler = () => {
    this.setState({ InvoiceEffitracFormloading: true });
    this.setState((prevState) => ({
      EffitracInvoiceFetchData: {
        ...prevState.EffitracInvoiceFetchData,
        business_entity_id: parseInt(
          localStorage.getItem("business_entity_id"),
        ),
      },
    }));

    axios
      .post(
        "/arc/effitrac/salesinvoicereport",
        this.state.EffitracInvoiceFetchData,
      )
      .then((res) => {
        if (res.data.status) {
          this.setState({
            invoiceData: res.data.records.records,
            oldInvoiceData: res.data.records.records,
            isEffitrac: true,
            InvoiceEffitracFormloading: false,
            openImportEffitracDrawer: false,
            EffitracInvoiceFetchData: {},
          });
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ InvoiceEffitracFormloading: false });
      });
  };

  // back button after import effitrac data
  backToPrevTableHandler = () => {
    this.setState({
      showUploadHistroyTable: false,
      isEffitrac: false,
      isDebitEffitrac: false,
      isCreditEffitrac: false,
      zohoDataForCWS: false,
      disableEnableButtonForZoho: true,
      activeFilters: {}, // clear active filters when leaving the effitrac view
    });
  };

  //Edited by Harsh Invoice
  openInvoiceDrawerOpen = () => {
    flagForInvoice = 1;
    this.setState({ openZohoDrawerForInvoice: true });
    localStorage.setItem("DrawerForInvoice", "true");
  };

  closeZohoInvoiceDrawer = () => {
    clearInterval(variableForTimer);
    this.setState({
      openZohoDrawerForInvoice: false,
      zohoDate: {},
      messageForConnectionForInvoice: "Establish Connection",
      buttonColorForInvoice: "red",
      grantToken: "",
    });
    localStorage.setItem("DrawerForInvoice", "false");
  };

  establishConnectionForInvoice = (e) => {
    e.preventDefault();
    window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
      "Client_ID",
    )}&state=testing&response_type=code&redirect_uri=${this.state.url
      }/zohoTesting&access_type=offline&prompt=Consent`;
  };

  inputHandlerForZohoInvoice = () => {
    clearInterval(variableForTimer);
    flagForInvoice += 1;

    this.setState({ InvoiceEffitracFormloading: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        type_of_data: "seller_invoice",
        code: this.state.grantToken,
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        if (res.data.status === true) {
          this.setState({
            zohoDate: {},
            messageForConnectionForInvoice: "Establish Connection",
            buttonColorForInvoice: "red",
            grantToken: "",
            InvoiceEffitracFormloading: false,
            autoSync: false,
          });
        } else {
          this.setState({
            zohoDate: {},
            messageForConnectionForInvoice: "Establish Connection",
            buttonColorForInvoice: "red",
            grantToken: "",
            InvoiceEffitracFormloading: false,
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          zohoDate: {},
          messageForConnectionForInvoice: "Establish Connection",
          buttonColorForInvoice: "red",
          grantToken: "",
          InvoiceEffitracFormloading: false,
          autoSync: false,
        });

        if (err?.response?.data?.message !== "") {
          toast.error(err?.response?.data?.message, {
            autoClose: 5000,
            progress: 0,
          });
        } else {
          toast.error("Server Error Try After Some Time", {
            autoClose: 5000,
            progress: 0,
          });
        }
      });
  };

  handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  // Edited by Harsh For Debit

  handleZohoDrawerOpen = () => {
    flagForDebit = 1;
    this.setState({ openZohoDebitDrawer: true });
    localStorage.setItem("DrawerForDebit", "true");
  };

  handleZohoDrawerCloseForDebit = () => {
    clearInterval(variableForTimer);
    this.setState({
      openZohoDebitDrawer: false,
      debitEffitracFormloading: false,
      zohoDate: {},
      messageForConnectionForInvoice: "Establish Connection",
      buttonColorForInvoice: "red",
      grantToken: "",
    });
    localStorage.setItem("DrawerForDebit", "false");
  };

  inputHandlerForZohoDebit = () => {
    clearInterval(variableForTimer);
    flagForDebit += 1;

    this.setState({ debitEffitracFormloading: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        code: this.state.grantToken,
        type_of_data: "seller_debit_note",
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        console.log(res.data.records);
        if (res.data.status === true) {
          this.setState({
            debitEffitracFormloading: false,
            zohoDate: {},
            messageForConnectionForInvoice: "Establish Connection",
            buttonColorForInvoice: "red",
            grantToken: "",
            autoSync: false,
          });
        } else {
          this.setState({
            debitEffitracFormloading: false,
            zohoDate: {},
            messageForConnectionForInvoice: "Establish Connection",
            buttonColorForInvoice: "red",
            grantToken: "",
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          debitEffitracFormloading: false,
          zohoDate: {},
          messageForConnectionForInvoice: "Establish Connection",
          buttonColorForInvoice: "red",
          autoSync: false,
          grantToken: "",
        });
        toast.error(err?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      });
  };

  handleZohoDrawerForCredit = () => {
    flagForCredit = 1;
    this.setState({ openZohoCreditDrawer: true });
    localStorage.setItem("DrawerForCredit", "true");
  };

  handleZohoDrawerCloseForCredit = () => {
    clearInterval(variableForTimer);
    this.setState({
      openZohoCreditDrawer: false,
      zohoDate: {},
      messageForConnectionForInvoice: "Establish Connection",
      buttonColorForInvoice: "red",
      grantToken: "",
    });
    localStorage.setItem("DrawerForCredit", "false");
  };

  zohoDateChangeHandler = (item) => {
    const { name, value } = item;

    var d = new Date(value);
    var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    let dateValue = newd.toISOString().replace("Z", "");

    this.setState((prevState) => ({
      zohoDate: {
        ...prevState.zohoDate,
        [name]: dateValue,
      },
    }));
  };

  inputHandlerForZohoCredit = () => {
    clearInterval(variableForTimer);
    flagForCredit += 1;

    this.setState({ creditEffitracFormloading: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        code: this.state.grantToken,
        type_of_data: "seller_credit_note",
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        if (res.data.status === true) {
          this.setState({
            zohoDate: {},
            messageForConnectionForInvoice: "Establish Connection",
            buttonColorForInvoice: "red",
            grantToken: "",
            creditEffitracFormloading: false,
            autoSync: false,
          });
        } else {
          this.setState({
            zohoDate: {},
            messageForConnectionForInvoice: "Establish Connection",
            buttonColorForInvoice: "red",
            grantToken: "",
            creditEffitracFormloading: false,
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          zohoDate: {},
          messageForConnectionForInvoice: "Establish Connection",
          buttonColorForInvoice: "red",
          grantToken: "",
          creditEffitracFormloading: false,
          autoSync: false,
        });
        toast.error(err?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      });
  };
  // .............................................pagination sand search........................................
  // table pagination fns
  // invoice
  // Branches on whether column filters are currently active. When they are,
  // resend the SAME active filters along with the new page — otherwise the
  // filtered result set is lost the moment the user tries to page through it.
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      if (this.hasActiveFilters()) {
        this.getSellerInvoiceFilterApi(this.state.activeFilters);
      } else {
        this.getSellerInvoiceDataApi(this.state.invoiceSearchInput);
      }
    });
  };
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 }, () => {
      if (this.hasActiveFilters()) {
        this.getSellerInvoiceFilterApi(this.state.activeFilters);
      } else {
        this.getSellerInvoiceDataApi(this.state.invoiceSearchInput);
      }
    });
  };
  // table serach
  invoiceSearchHandler = (event) => {
    this.setState(
      { invoiceSearchInput: event.target.value, page: 0, rowsPerPage: 25 },
      () => {
        if (this.hasActiveFilters()) {
          this.getSellerInvoiceFilterApi(this.state.activeFilters);
        } else {
          this.getSellerInvoiceDataApi(this.state.invoiceSearchInput);
        }
      },
    );
  };

  // debit...
  handleChangePageForDebit = (event, newPage) => {
    this.setState({ debitPage: newPage }, () => {
      if (this.hasActiveDebitFilters()) {
        this.getSellerDebitNoteFilterApi(this.state.debitActiveFilters);
      } else {
        this.sellerDebitNoteGetApi(this.state.debitSearchInput);
      }
    });
  };
  handleChangeRowsPerPageForDebit = (event) => {
    this.setState({ debitRowsPerPage: +event.target.value, debitPage: 0 }, () => {
      if (this.hasActiveDebitFilters()) {
        this.getSellerDebitNoteFilterApi(this.state.debitActiveFilters);
      } else {
        this.sellerDebitNoteGetApi(this.state.debitSearchInput);
      }
    });
  };
  // table serach
  debitSearchHandler = (event) => {
    this.setState({ debitSearchInput: event.target.value, page: 0, debitRowsPerPage: 25 }, () => {
      if (this.hasActiveDebitFilters()) {
        this.getSellerDebitNoteFilterApi(this.state.debitActiveFilters);
      } else {
        this.sellerDebitNoteGetApi(this.state.debitSearchInput);
      }
    });
  };

  // credit...
  handleChangePageForCredit = (event, newPage) => {
    this.setState({ creditPage: newPage }, () => {
      if (this.hasActiveCreditFilters()) {
        this.getSellerCreditNoteFilterApi(this.state.creditActiveFilters);
      } else {
        this.sellerCreditNoteGetApi(this.state.creditSearchInput);
      }
    });
  };

  handleChangeRowsPerPageForCredit = (event) => {
    this.setState({ creditRowsPerPage: +event.target.value, creditPage: 0 }, () => {
      if (this.hasActiveCreditFilters()) {
        this.getSellerCreditNoteFilterApi(this.state.creditActiveFilters);
      } else {
        this.sellerCreditNoteGetApi(this.state.creditSearchInput);
      }
    });
  };
  // table serach
  creditSearchHandler = (event) => {
    this.setState({ creditSearchInput: event.target.value, page: 0, creditRowsPerPage: 25 }, () => {
      if (this.hasActiveCreditFilters()) {
        this.getSellerCreditNoteFilterApi(this.state.creditActiveFilters);
      } else {
        this.sellerCreditNoteGetApi(this.state.creditSearchInput);
      }
    });
  };

  uploadReport = (id, pageParam = null) => {
    // Get ID from localStorage if not provided
    let currentId = id;
    if (!currentId) {
      currentId = localStorage.getItem("uploadReportId");
    }

    // If still no ID, show error
    if (!currentId) {
      console.error("uploadReport: Invalid ID", currentId);
      this.setState({ error: "Invalid ID", loading: false });
      return;
    }

    // Store ID in localStorage for future use
    localStorage.setItem("uploadReportId", currentId);

    const page = pageParam !== null ? pageParam : this.state.errorPage;
    const perErrorPages = this.state.perErrorPages || 10;

    if (page < 1 || !Number.isInteger(page)) {
      console.error("uploadReport: Invalid page number", page);
      this.setState({ error: "Invalid page number", loading: false });
      return;
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error("uploadReport: Invalid rows per page", perErrorPages);
      this.setState({ error: "Invalid rows per page", loading: false });
      return;
    }

    console.log(
      `Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`,
    );
    console.log(
      `API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`,
    );

    this.setState({ loading: true, error: null });

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then((response) => {
        console.log("API Response:", JSON.stringify(response.data, null, 2));
        const res = response.data.records;

        if (
          res.type === "json" &&
          res.records &&
          Array.isArray(res.records.details)
        ) {
          const error_records = res.records.details.filter(
            (v) => v.status === "Fail",
          );
          this.setState({
            showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records:
              parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: error_records,
            error: null,
            loading: false,
          });
        } else if (res.type === "message") {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false,
          });
        } else {
          console.warn("Invalid response format:", res);
          this.setState({
            error: "Invalid response format",
            total_records: 0,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`,
        });
      });
  };

  zohoHandlerForAll = () => {
    if (this.state.section_name === "Invoice") {
      this.openInvoiceDrawerOpen();
    } else if (this.state.section_name === "Debit Note") {
      this.handleZohoDrawerOpen();
    } else if (this.state.section_name === "Credit Note") {
      this.handleZohoDrawerForCredit();
    }
  };

  handlAllEffitally = () => {
    if (this.state.section_name === "Invoice") {
      this.importEffitracDrawerOpen();
    } else if (this.state.section_name === "Debit Note") {
      this.import_Debit_Effitrac_tally();
    } else if (this.state.section_name === "Credit Note") {
      this.import_Credit_Effitrac_tally();
    }
  };

  errorLogExportHandlerForUpload = () => {
    // Get the currentId from localStorage
    this.setState({ loadingExport: true });
    let uploadId = localStorage.getItem("uploadReportId");

    let data = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      upload_id: uploadId,
    };

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `CustomersInvoiceUploadErrorLog.xlsx`;

    axios
      .post(`/uploads_errors_extract/download`, data)
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
        this.setState({ loadingExport: false });
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        this.setState({ loadingExport: false });
      });
  };

  handleErpConnectorButton = () => {
    this.setState({ erpConnectorModelOpen: true });
  };

  handleOpenAndCloseModel = () => {
    console.log(
      "handle clcik invoice date filter ",
      !this.state.triggerModelFromToDate,
    );
    this.setState((prevState) => ({
      triggerModelFromToDate: !prevState.triggerModelFromToDate,
    }));
  };

  inputHandlerFromDatePicker = (v) => {
    this.setState({ fromPeriodDisplay: v });
    this.setState({ fromPeriod: v });
  };

  inputHandlerToDatePicker = (v) => {
    this.setState({ toPeriodDisplay: v });
    this.setState({ toPeriod: v });
  };

  onSubmitHandlerForDateFilter = () => {
    this.export_to_excel();

    this.setState({
      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: "",
      toPeriod: null,
    });
  };

  renderDateFilter = () => {
    return (
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={this.state.triggerModelFromToDate}
        onHide={this.handleOpenAndCloseModel}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Export {this.state.section_name}</Modal.Title>
        </Modal.Header>
        <ValidatorForm
          useRef="form"
          onSubmit={this.onSubmitHandlerForDateFilter}
          onError={(errors) => console.log(errors)}
        >
          <Modal.Body>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="dateFilterOption"
                    value={this.state.dateFilterOption}
                    onChange={(e) =>
                      this.setState({ dateFilterOption: e.target.value })
                    }
                  >
                    <FormControlLabel
                      value="withDateFilter"
                      control={<Radio />}
                      label="With Date Filter"
                    />
                    <FormControlLabel
                      value="withoutDateFilter"
                      control={<Radio />}
                      label="Without Date Filter"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {this.state.dateFilterOption === "withDateFilter" && (
                <>
                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      From Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      maxDate={this.state.toPeriodDisplay ?? ""}
                      placeholder="From Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.fromPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerFromDatePicker(v)}
                    />
                  </Grid>

                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      To Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      minDateForDatepicker={this.state.fromPeriodDisplay ?? ""}
                      placeholder="To Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.toPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerToDatePicker(v)}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button className="button-primary" type="submit">
              Export
            </button>
            <button
              className="button-outlined-secondary"
              type="button"
              onClick={this.handleOpenAndCloseModel}
            >
              Cancel
            </button>
          </Modal.Footer>
        </ValidatorForm>
      </Modal>
    );
  };

  render() {
    const { push, ...props } = this.props;

    return (
      <React.Fragment>
        {this.state.openZohoDrawerForInvoice && (
          <ZohoModel
            openZohoDrawer={this.state.openZohoDrawerForInvoice}
            buttonColor={this.state.buttonColorForInvoice}
            establishConnection={this.establishConnectionForInvoice}
            messageForConnection={this.state.messageForConnectionForInvoice}
            timerForZohoInSalesCustomer={this.state.timerForZoho}
            closeZohoDrawer={this.closeZohoInvoiceDrawer}
            zohoDateChangeHandler={this.zohoDateChangeHandler}
            effitracImportFormloader={this.state.InvoiceEffitracFormloading}
            fetchingdataForZoho={this.inputHandlerForZohoInvoice}
            zohoDate={this.state.zohoDate}
            logApitName="seller_invoice"
            nameOfTheModel="Invoice Management"
            importToCWS={this.importToCWS}
            exportToExcel={this.export_to_excel_Zoho}
            zohoTableHeader={this.state.invoiceHeader}
            zohoTableColumn={this.state.invoiceCol}
            drawerKeys={this.state.actionHeaderForZohoInvoice}
            autoSync={this.state.autoSync} // Added autoSync prop
            setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
          />
        )}

        {this.state.erpConnectorModelOpen && (
          <ErpConnectorModel
            opeErpConnector={this.state.erpConnectorModelOpen}
            closeErpConnector={this.closeErpDrawer}
            logApitName={
              this.state.section_name === "Credit Note"
                ? "salesCN"
                : this.state.section_name === "Debit Note"
                  ? "debit"
                  : "invoice"
            }
            nameOfTheModel={
              this.state.section_name === "Credit Note"
                ? "Credit Note Management"
                : this.state.section_name === "Debit Note"
                  ? "Debit Note Management"
                  : "Invoice Management"
            }
            importToCWS={
              this.state.section_name === "Credit Note"
                ? this.creditImportToCWS
                : this.state.section_name === "Debit Note"
                  ? this.debitImportToCWS
                  : this.importToCWS
            }
            exportToExcel={this.export_erp_data_to_excel}
            ErpTableHeader={this.state.invoiceHeader}
            ErpTableColumn={this.state.invoiceCol}
            connecotrName={this.state.erpConnectorName}
            erpDataExportLoading={this.state.erpDataExportLoading}
            importToCwsLoading={this.state.importToCwsLoading}
          />
        )}

        {this.state.openZohoDebitDrawer && (
          <ZohoModel
            openZohoDrawer={this.state.openZohoDebitDrawer}
            buttonColor={this.state.buttonColorForInvoice}
            establishConnection={this.establishConnectionForInvoice}
            messageForConnection={this.state.messageForConnectionForInvoice}
            timerForZohoInSalesCustomer={this.state.timerForZoho}
            closeZohoDrawer={this.handleZohoDrawerCloseForDebit}
            zohoDateChangeHandler={this.zohoDateChangeHandler}
            effitracImportFormloader={this.state.debitEffitracFormloading}
            fetchingdataForZoho={this.inputHandlerForZohoDebit}
            zohoDate={this.state.zohoDate}
            logApitName="seller_debit_note"
            nameOfTheModel="Debit Note Management"
            importToCWS={this.debitImportToCWS}
            exportToExcel={this.export_to_excel_Zoho}
            zohoTableHeader={this.state.debitEffitracHeader}
            zohoTableColumn={this.state.debitEffitracCol}
            drawerKeys={this.state.actionHeaderForZohoDebit}
            autoSync={this.state.autoSync} // Added autoSync prop
            setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
          />
        )}

        {this.state.openZohoCreditDrawer && (
          <ZohoModel
            openZohoDrawer={this.state.openZohoCreditDrawer}
            buttonColor={this.state.buttonColorForInvoice}
            establishConnection={this.establishConnectionForInvoice}
            messageForConnection={this.state.messageForConnectionForInvoice}
            timerForZohoInSalesCustomer={this.state.timerForZoho}
            closeZohoDrawer={this.handleZohoDrawerCloseForCredit}
            zohoDateChangeHandler={this.zohoDateChangeHandler}
            effitracImportFormloader={this.state.creditEffitracFormloading}
            fetchingdataForZoho={this.inputHandlerForZohoCredit}
            zohoDate={this.state.zohoDate}
            logApitName="seller_credit_note"
            nameOfTheModel="Credit Note Management"
            importToCWS={this.creditImportToCWS}
            exportToExcel={this.export_to_excel_Zoho}
            zohoTableHeader={this.state.creditEffitracHeader}
            zohoTableColumn={this.state.creditEffitracCol}
            drawerKeys={this.state.actionHeaderForZohoCredit}
            autoSync={this.state.autoSync} // Added autoSync prop
            setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
          />
        )}

        {/* -----------add invoice modal-----------  */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.customerTableModalShow}
          onHide={this.customerTableModalClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Any Customer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.searchField}>
              <Grid container spacing={3}>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                  >
                    <InputField
                      // textLabel="Search"
                      inputPlacholder="Search...."
                      inputType="text"
                      requiredField=" "
                      name="Search_by_customer_name"
                      value={this.state.invoiceSearchInput ?? ""}
                      textOnchangeFunction={this.arcInvoiceModalSearchInput}
                    />
                  </ValidatorForm>
                </Grid>
              </Grid>
            </div>
            <div className={classes.modalTableResponisve}>
              <table className={classes.tableCss}>
                <tbody>
                  <tr>{this.arc_Customer_TableHeader()}</tr>
                  {this.arc_CustomerTableBody__data()}
                </tbody>
              </table>
            </div>
            <TablePagination
              rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
              component="div"
              count={this.state.rowCountForAddInvoice} //total row count
              rowsPerPage={this.state.rowsPerPageForAddInvoice}
              page={this.state.pageForAddInvoice}
              onPageChange={this.handleChangePageForAddInvoice}
              onRowsPerPageChange={this.handleChangeRowsPerPageForAddInvoice}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="small"
              variant="outlined"
              onClick={this.customerTableModalClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
        {/* add invoice modal end  */}

        {/* -----------------add debit modal--------------------  */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.debitModalShow}
          onHide={this.debitModalClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Any Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.searchField}>
              <Grid container spacing={3}>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                  >
                    <InputField
                      // textLabel="Search"
                      inputPlacholder="Search...."
                      inputType="text"
                      requiredField=" "
                      name="Search_by_customer_name"
                      value={this.state.invoiceSearchInput ?? ""}
                      textOnchangeFunction={this.invoiceSearchHandler}
                    />
                  </ValidatorForm>
                </Grid>
              </Grid>
            </div>
            <div className={classes.modalTableResponisve}>
              <table className={classes.tableCss}>
                <tbody>
                  <tr>{this.arc_debitNoteModal_TableHeader()}</tr>
                  {this.arc_debitNoteModal_tableBody()}
                </tbody>
              </table>
            </div>
            <TablePagination
              rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
              component="div"
              count={this.state.rowCount} //total row count
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="small"
              variant="outlined"
              onClick={this.debitModalClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* add debit modal end  */}
        {/* -----------------add credit modal---------------  */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.creditNoteModalShow}
          onHide={this.creditNoteModalClose}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Any Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={classes.searchField}>
              <Grid container spacing={3}>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={this.onSubmitHandler}
                    onError={(errors) => console.log(errors)}
                  >
                    <InputField
                      // textLabel="Search"
                      inputPlacholder="Search...."
                      inputType="text"
                      requiredField=" "
                      name="Search_by_customer_name"
                      value={this.state.invoiceSearchInput ?? ""}
                      textOnchangeFunction={this.invoiceSearchHandler}
                    />
                  </ValidatorForm>
                </Grid>
              </Grid>
            </div>
            <div className={classes.modalTableResponisve}>
              <table className={classes.tableCss}>
                <tbody>
                  <tr>{this.arc_creditNoteModal_TableHeader()}</tr>
                  {this.arc_creditNoteModal_tableBody()}
                </tbody>
              </table>
            </div>
            <TablePagination
              rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
              component="div"
              count={this.state.rowCount} //total row count
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="small"
              variant="outlined"
              onClick={this.creditNoteModalClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* import tally/Effitrac drawer */}
        <RightDrawer
          drawerName="Import Effitrac/Tally"
          open={this.state.openImportEffitracDrawer}
          onClose={this.closeImportEffitracDrawer}
        >
          <ValidatorForm
            ref="form"
            onSubmit={this.effitracFetchHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ textAlign: "center" }}>
              Last Upload Date<br></br>
              {this.state.lastUploadDateInvoice}{" "}
              {this.state.lastUploadTimeInvoice}
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>Invoice From Date:</label>
              <ValidatedDatePicker
                fullWidth
                name="invoiceFromDate"
                value={
                  this.state.EffitracInvoiceFetchData.invoiceFromDate ?? ""
                }
                onChange={(v) =>
                  this.importEffitracInvoiceFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Invoice To Date:</label>
              <ValidatedDatePicker
                name="invoiceToDate"
                value={this.state.EffitracInvoiceFetchData.invoiceToDate ?? ""}
                onChange={(v) =>
                  this.importEffitracInvoiceToDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Due From Date:</label>
              <ValidatedDatePicker
                name="dueFromDate"
                value={this.state.EffitracInvoiceFetchData.dueFromDate ?? ""}
                onChange={(v) => this.importEffitracDueFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Due To Date:</label>
              <ValidatedDatePicker
                name="dueToDate"
                value={this.state.EffitracInvoiceFetchData.dueToDate ?? ""}
                onChange={(v) => this.importEffitracDueToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified From Date:</label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={
                  this.state.EffitracInvoiceFetchData.modifiedFromDate ?? ""
                }
                onChange={(v) => this.importEffitracFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified To Date:</label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.EffitracInvoiceFetchData.modifiedToDate ?? ""}
                onChange={(v) =>
                  this.importEffitracModifiedToDateChangeHandler(v)
                }
              />
            </div>

            {/* submit and back button */}
            <div className="mt-20">
              {this.state.InvoiceEffitracFormloading ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeImportEffitracDrawer}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>

        {/* import debit effitrac/tally */}
        <RightDrawer
          drawerName="Import Effitrac/Tally"
          open={this.state.openImportEffitracDebitDrawer}
          onClose={this.closeDebitEffitractally}
        >
          <ValidatorForm
            ref="form"
            onSubmit={this.debitEffitracFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ textAlign: "center" }}>
              Last Upload Date<br></br>
              {this.state.lastUploadDateDebit} {this.state.lastUploadTimeDebit}
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>Modified From Date:</label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={this.state.effitracDebitFetchData.modifiedFromDate ?? ""}
                onChange={(v) =>
                  this.importDebitModifiedFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified To Date:</label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.effitracDebitFetchData.modifiedToDate ?? ""}
                onChange={(v) => this.importDebitModifiedToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Debit Note From Date:</label>
              <ValidatedDatePicker
                fullWidth
                name="invoiceFromDate"
                value={this.state.effitracDebitFetchData.invoiceFromDate ?? ""}
                onChange={(v) => this.importDebitFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Debit Note To Date:</label>
              <ValidatedDatePicker
                name="invoiceToDate"
                value={this.state.effitracDebitFetchData.invoiceToDate ?? ""}
                onChange={(v) => this.importDebitToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Org Inv From Date:</label>
              <ValidatedDatePicker
                name="originalInvFromDate"
                value={
                  this.state.effitracDebitFetchData.originalInvFromDate ?? ""
                }
                onChange={(v) =>
                  this.importDebitOriginalInvFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Org Inv To Date:</label>
              <ValidatedDatePicker
                name="originalInvToDate"
                value={
                  this.state.effitracDebitFetchData.originalInvToDate ?? ""
                }
                onChange={(v) =>
                  this.importDebitOriginalInvToDateChangeHandler(v)
                }
              />
            </div>

            {/* submit and back button */}
            <div className="mt-20">
              {this.state.debitEffitracFormloading ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}

              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeDebitEffitractally}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>

        {/* import credit effitrac/tally */}
        <RightDrawer
          drawerName="Import Effitrac/Tally"
          open={this.state.openImportEffitracCreditDrawer}
          onClose={this.closeCreditEffitractally}
        >
          <ValidatorForm
            ref="form"
            onSubmit={this.creditEffitracFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ textAlign: "center" }}>
              Last Upload Date<br></br>
              {this.state.lastUploadDateCredit}{" "}
              {this.state.lastUploadTimeCredit}
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>Modified From Date:</label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={
                  this.state.effitracCreditFetchData.modifiedFromDate ?? ""
                }
                onChange={(v) =>
                  this.importCreditModifiedFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified To Date:</label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.effitracCreditFetchData.modifiedToDate ?? ""}
                onChange={(v) =>
                  this.importCreditModifiedToDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Credit Note From Date:</label>
              <ValidatedDatePicker
                fullWidth
                name="invoiceFromDate"
                value={this.state.effitracCreditFetchData.invoiceFromDate ?? ""}
                onChange={(v) => this.importCreditFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Credit Note To Date:</label>
              <ValidatedDatePicker
                name="invoiceToDate"
                value={this.state.effitracCreditFetchData.invoiceToDate ?? ""}
                onChange={(v) => this.importCreditToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Org Inv From Date:</label>
              <ValidatedDatePicker
                name="originalInvFromDate"
                value={
                  this.state.effitracCreditFetchData.originalInvFromDate ?? ""
                }
                onChange={(v) =>
                  this.importCreditOriginalInvFromDateChangeHandler(v)
                }
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Org Inv To Date:</label>
              <ValidatedDatePicker
                name="originalInvToDate"
                value={
                  this.state.effitracCreditFetchData.originalInvToDate ?? ""
                }
                onChange={(v) =>
                  this.importCreditOriginalInvToDateChangeHandler(v)
                }
              />
            </div>

            <div className="mt-20">
              {this.state.creditEffitracFormloading ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeCreditEffitractally}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>


        {/* HEADER */}
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Tooltip title="Back" arrow>
            <IconButton
              onClick={() => this.props.history.push('/Data-Upload')}
              sx={{
                borderRadius: '50%',
                padding: '6px',
                color: '#263238',
                backgroundColor: '#ffffff',
                height: '36px',
                width: '36px',
                '&:hover': {
                  backgroundColor: '#455a64',
                  color: '#ffffff',
                },
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                transition: 'background-color 0.3s ease',
              }}
            >
              <ArrowBackIcon sx={{ fontSize: '20px' }} />
            </IconButton>
          </Tooltip>

          <div style={{ display: "flex" }}>
            <button
              className={this.state.section_name === "Invoice" ? "button-normal-secondary-active" : "button-normal-secondary"}
              style={{ borderRadius: "15px" }}
              onClick={this.clickInvoice}
              {...props}
            >
              Invoice
            </button>
            <button
              className={this.state.section_name === "Debit Note" ? "button-normal-secondary-active" : "button-normal-secondary"}
              style={{ borderRadius: "15px" }}
              onClick={this.clickDebitNote}
              {...props}
            >
              Debit Note
            </button>
            <button
              className={this.state.section_name === "Credit Note" ? "button-normal-secondary-active" : "button-normal-secondary"}
              style={{ borderRadius: "15px" }}
              onClick={this.clickCreditNote}
              {...props}
            >
              Credit Note
            </button>
          </div>
        </div>
        {localStorage.getItem("is_uploads") !== "N" && (
          <>
            {/* File upload history table  */}
            {localStorage.getItem("is_uploads") !== "N" && (
              <div>
                <BoxWrapper
                  boxTitle={`Upload ${this.state.section_name} History`}
                  zohoEffitracEnable={
                    canWrite("UPLOADING SALES") &&
                    localStorage.getItem("Client_ID") &&
                    this.state.disableEnableButtonForZoho &&
                    true
                  }
                  zohoEffitracFn={this.zohoHandlerForAll}
                  enableImportToEffTallybutton={
                    canWrite("UPLOADING SALES") &&
                    localStorage.getItem("Trigger_Effitrac/Tally_Button") &&
                    localStorage.getItem("Trigger_Effitrac/Tally_Button") === "true"
                  }
                  enableAddButton={canWrite("UPLOADING SALES") && this.state.erpConnectorName ? true : false}
                  addButtonLabel={this.state.erpConnectorName}
                  addButtonHandlerFn={this.handleErpConnectorButton}
                  importToEffiTallyFn={this.handlAllEffitally}
                >
                  <div style={{ marginBottom: "10px" }}>
                    {" "}
                    {this.state.uploadUrl && <this.CollectionListActions />}
                  </div>

                  <div className="responsive-table">
                    <table className="custome-table">
                      <thead>
                        <tr>
                          <th>Last Upload Date & Time</th>
                          <th>Status</th>
                          <th>Upload Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.uploadHistoryTableData.length > 0 &&
                          this.state.uploadHistoryTableData.map((item, i) => {
                            return (
                              <tr>
                                <td>{item.upload_date}</td>
                                <td>{item.status}</td>
                                <td>{item.upload_type}</td>
                                <td>
                                  {item.status === "In Progress" ? (
                                    <RemoveRedEyeOutlinedIcon
                                      className="action-icon-button-disabled"
                                      color="disabled"
                                    />
                                  ) : item.status === "Uploaded" ? (
                                    <RemoveRedEyeOutlinedIcon
                                      className="action-icon-button-disabled"
                                      color="disabled"
                                    />
                                  ) : (
                                    <RemoveRedEyeOutlinedIcon
                                      className="action-icon-button showIcon"
                                      onClick={() => this.uploadReport(item.id)}
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        {this.state.uploadHistoryTableData.length === 0 && (
                          <tr>
                            <td
                              style={{ color: "red", textAlign: "center" }}
                              colspan={4}
                            >
                              No Data Found!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </BoxWrapper>
              </div>
            )}
          </>
        )}

        {/* ---- */}
        {this.state.showUploadData ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className={classes.Main_frame}>
                  <div className={classes.form_title_bar}>
                    <div
                      class="form_title_name"
                      style={{ background: "#dddddd" }}
                    >
                      <ul
                        style={{
                          listStyle: "none",
                          marginBottom: "0px",
                          padding: "0px",
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <li style={{ fontWeight: "700" }}>Upload Details</li>
                        <li>
                          {this.state.error_records > 0 && (
                            <button
                              className="button-outlined-primary"
                              onClick={this.errorLogExportHandlerForUpload}
                              disabled={this.state.loadingExport} // Disable button during loading
                            >
                              {this.state.loadingExport ? (
                                <span>Loading...</span> // Simple text loader
                              ) : (
                                <span>Export</span>
                              )}
                            </button>
                          )}

                          <button
                            className="close-icon-button"
                            onClick={this.closeUploadData}
                          >
                            <ClearIcon style={{ color: "var(--app-bar-bg)" }} />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={classes.form_body_part}>
                    {this.state.total_records > 0 && (
                      <div>
                        {/* card component */}
                        <div
                          style={{ marginLeft: "30px", marginRight: "30px" }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#6f9eaf"
                                cardTitle="Total Records"
                                cardBody={this.state.total_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#007965"
                                cardTitle="Successful Records"
                                cardBody={this.state.successful_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#eb596e"
                                cardTitle="Error Records"
                                cardBody={this.state.error_records}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        {/* datatable component */}
                        <div
                          style={{
                            height: "300",
                            margin: "20px 30px 0px 30px",
                          }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <div>
                                <MuiThemeProvider>
                                  <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    page={this.state.errorPage}
                                    count={this.state.errortotal}
                                    rowSize={this.state.perErrorPages}
                                    showRowSizeControls={true}
                                    showFooterToolbar={true}
                                    onNextPageClick={this.handleNextPage}
                                    onPreviousPageClick={
                                      this.handlePreviousPage
                                    }
                                    onRowSizeChange={
                                      this.handleRowsPerPageChange
                                    }
                                  />
                                </MuiThemeProvider>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    )}
                    {this.state.error && (
                      <div style={{ color: "red" }}>
                        <ErrorIcon />
                        {this.state.error}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}

        {/* .........................................debit note  */}
        {this.state.debitNoteTableData ? (
          <>
            {/* arc seller debit note table */}
            <BoxWrapper
              boxTitle="Debit Note Details"
              headerExtra={
                FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isDebitEffitrac
                  ? this.renderFilterButtonFor("debit")
                  : null
              }
              backButtonForZohoEnable={this.state.isDebitEffitrac}
              backButton={this.backToPrevTableHandler}
              importToCwsEnableForZoho={this.state.isDebitEffitrac}
              importToCwsForZoho={this.debitImportToCWS}
              exportToExcelEnable={true}
              exportToExcelFn={this.handleOpenAndCloseModel}
              exportToExcelEnable1={true}
              exportButtonLabel1={this.state.debitAppliedFilters.length > 0 && this.state.debitActiveFilters ? "Export Filtered" : "Export All"}
              exportToExcelFn1={() => this.exportall_notes_to_excel("debit")}
              loadingexcel1={this.state.isExportingAll}
              // enableSearchInput={true}
              // searchInputPlaceholder={"Search..."}
              // searchInputOnchange={
              //   this.state.isDebitEffitrac
              //     ? this.handleSearchInputChange
              //     : this.debitSearchHandler
              // }
            >
              {this.state.isDebitEffitrac ? (
                <CustomTable
                  headers={this.state.debitEffitracHeader}
                  columns={this.state.debitEffitracCol}
                  data={this.state.debitEffitracData}
                  actions={this.state.debitEffitracActions}
                />
              ) : (
                <>
                  {/* Filter button here only until it is moved into BoxWrapper */}
                  {!FILTER_BUTTON_IN_BOXWRAPPER && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "8px",
                      }}
                    >
                      {this.renderFilterButtonFor("debit")}
                    </div>
                  )}

                  {this.renderAppliedFilterChipsFor("debit")}

                  {/* Table on the left, filter panel (when open) on the right */}
                  <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        className="responsive-table"
                        style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                      >
                        <table
                          className="custome-table"
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                            width: "100%",
                            minWidth: this.getTableMinWidthFor(this.debitFilterableColumns),
                            tableLayout: "fixed",
                          }}
                        >
                          {this.renderColGroupFor(this.debitFilterableColumns)}
                          <tbody>
                            {this.arc_SellerdebitNoteTableHeader()}
                            {this.arc_SellerdebitNotedata()}
                          </tbody>
                        </table>
                      </div>
                      <TablePagination
                        rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                        component="div"
                        count={this.state.debitRowCount} //total row count
                        rowsPerPage={this.state.debitRowsPerPage}
                        page={this.state.debitPage}
                        onPageChange={this.handleChangePageForDebit}
                        onRowsPerPageChange={this.handleChangeRowsPerPageForDebit}
                      />
                    </div>

                    {this.renderFilterPanelFor("debit")}
                  </div>
                </>
              )}
            </BoxWrapper>
          </>
        ) : (
          ""
        )}

        {/* add debit note drawer  */}
        <Drawer
          anchor="right"
          open={this.state.addDebitNote_DrawerOpen}
          variant={this.state.debitModalBackDrop === true ? "persistent" : ""}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}

            {/* modal open button */}
            <Button
              style={{ marginTop: "45px" }}
              size="small"
              fullWidth
              variant="outlined"
              onClick={this.debitModalOpen}
            >
              select invoice*
            </Button>

            <ValidatorForm
              ref="form"
              onSubmit={this.addDebitNote_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.addDebitNoteData.customerCode ?? ""}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.addDebitNoteData.gstin ?? ""}
              />
              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                requiredField=""
                validator={["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["Invalid PAN Numaber"]}
                value={this.state.addDebitNoteData.pan ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="Invoice No"
                name="invoiceNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.addDebitNoteData.invoiceNo ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addDebitNoteData.invoiceDate ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Debit Note No"
                name="debitNoteNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addDebitNoteData.debitNoteNo ?? ""}
                textOnchangeFunction={this.addDebitNote_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  Debit Note Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="debitNoteDate"
                  value={this.state.debitNoteDateDisplay ?? ""}
                  onChange={(v) => this.handleDebitNoteDateChange(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        taxableValue: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Non Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        nonTaxableValue: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ SGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        sgst: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        cgst: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ IGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        igst: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CESS:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  name="cess"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        cess: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="GST Tax %"
                name="gstTaxRate"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.addDebitNoteData.gstTaxRate ?? ""}
                textOnchangeFunction={this.addDebitNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="HSN/SAC Code"
                name="hsnSacCode"
                value={this.state.addDebitNoteData.hsnSacCode}
                textOnchangeFunction={this.addDebitNote_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>₹ Tax Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        taxAmount: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Total Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addDebitNoteData: {
                        ...prevState.addDebitNoteData,
                        totalAmount: String(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>Place Of Supply</label> <br />
                <Autocomplete
                  id="combo-box-demo"
                  name="placeOfSupply"
                  onChange={(e, value) => {
                    if (value === null) {
                      this.setState((prevState) => ({
                        addDebitNoteData: {
                          ...prevState.addDebitNoteData,
                          placeOfSupply: "",
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        addDebitNoteData: {
                          ...prevState.addDebitNoteData,
                          placeOfSupply: String(value),
                        },
                      }));
                    }
                  }}
                  options={this.state.getApiForPlaceOfSupply}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      name="placeOfSupply"
                    />
                  )}
                />
              </div>
              <InputField
                inputType="text"
                textLabel="Debit Note Reason"
                name="debitNoteReason"
                requiredField=""
                value={this.state.addDebitNoteData.debitNoteReason ?? ""}
                textOnchangeFunction={this.addDebitNote_inputHandler}
              />
              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="outlined"
                size="small"
                onClick={this.addDebitNote_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* edit debit note drawer  */}
        <Drawer
          anchor="right"
          open={this.state.editDebitNote_DrawerOpen}
          onClose={this.editDebitNote_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.editDebitNote_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="ERP Customer Code"
                name="customerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editDebitNoteData.customerCode ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.editDebitNoteData.gstin ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                validator={["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]}
                errorMsg={["Invalid PAN Numaber"]}
                value={this.state.editDebitNoteData.pan ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Invoice No"
                name="invoiceNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editDebitNoteData.invoiceNo ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editDebitNoteData.invoiceDate ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Debit Note No"
                name="debitNoteNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editDebitNoteData.debitNoteNo ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
                inputProps={{
                  readOnly: true,
                }}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  Debit Note Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="debitNoteDate"
                  value={this.state.debitNoteDateDisplay ?? ""}
                  onChange={(v) => this.editDebitNoteDateChangeHandler(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.taxableValue
                      ? this.state.editDebitNoteData.taxableValue
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        taxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Non Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.nonTaxableValue
                      ? this.state.editDebitNoteData.nonTaxableValue
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        nonTaxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ SGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.sgst
                      ? this.state.editDebitNoteData.sgst
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        sgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.cgst
                      ? this.state.editDebitNoteData.cgst
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        cgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ IGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.igst
                      ? this.state.editDebitNoteData.igst
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        igst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CESS:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.cess
                      ? this.state.editDebitNoteData.cess
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        cess: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="GST Tax %"
                name="gstTaxRate"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.editDebitNoteData.gstTaxRate ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="HSN/SAC Code"
                name="hsnSacCode"
                value={this.state.editDebitNoteData.hsnSacCode}
                textOnchangeFunction={this.editDebitNote_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>₹ Tax Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.taxAmount
                      ? this.state.editDebitNoteData.taxAmount
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        taxAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Total Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editDebitNoteData.totalAmount
                      ? this.state.editDebitNoteData.totalAmount
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editDebitNoteData: {
                        ...prevState.editDebitNoteData,
                        totalAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>Place Of Supply</label> <br />
                <Autocomplete
                  id="combo-box-demo"
                  name="placeOfSupply"
                  value={this.state.editDebitNoteData.placeOfSupply ?? ""}
                  onChange={(e, value) => {
                    if (value === null) {
                      this.setState((prevState) => ({
                        editDebitNoteData: {
                          ...prevState.editDebitNoteData,
                          placeOfSupply: "",
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        editDebitNoteData: {
                          ...prevState.editDebitNoteData,
                          placeOfSupply: String(value),
                        },
                      }));
                    }
                  }}
                  options={this.state.getApiForPlaceOfSupply}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      name="placeOfSupply"
                    />
                  )}
                />
              </div>
              <InputField
                inputType="text"
                textLabel="Debit Note Reason"
                name="debitNoteReason"
                requiredField=""
                value={this.state.editDebitNoteData.debitNoteReason ?? ""}
                textOnchangeFunction={this.editDebitNote_inputHandler}
              />
              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="outlined"
                size="small"
                onClick={this.editDebitNote_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* show data  */}
        <RightDrawer
          drawerName="Debit Note Details"
          open={this.state.showDebitNoteDrawer}
          onClose={this.closeShowDrawer_DebitNoteData}
        >
          {Object.keys(this.state.showDebitNoteDetailsData).length && (
            <>
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Debit Note No"
                value={this.state.showDebitNoteDetailsData.debit_note_no ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Debit Note Date"
                value={this.state.showDebitNoteDetailsData.debit_note_date}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Taxable Value"
                value={numberFormat(
                  this.state.showDebitNoteDetailsData.taxable_value,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="CGST"
                value={numberFormat(this.state.showDebitNoteDetailsData.cgst)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="SGST"
                value={numberFormat(this.state.showDebitNoteDetailsData.sgst)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="IGST"
                value={numberFormat(this.state.showDebitNoteDetailsData.igst)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="GST Tax %"
                value={this.state.showDebitNoteDetailsData.gstTaxRate ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="HSN/SAC Code"
                value={this.state.showDebitNoteDetailsData.hsnSacCode ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Total Amount"
                value={numberFormat(
                  this.state.showDebitNoteDetailsData.total_amount,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Non Taxable Value"
                value={numberFormat(
                  this.state.showDebitNoteDetailsData.non_taxable_adj,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Tax Amount"
                value={numberFormat(
                  this.state.showDebitNoteDetailsData.tax_amount,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Place Of Supply"
                value={this.state.showDebitNoteDetailsData.placeOfSupply ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Debit Note Reason"
                value={this.state.showDebitNoteDetailsData.debit_note_reason}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="ERP Customer Code"
                value={this.state.showDebitNoteDetailsData.cust_code}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Create Date"
                value={this.state.showDebitNoteDetailsData.created_date}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Modify Date"
                value={this.state.showDebitNoteDetailsData.modified_date}
              />
            </>
          )}
          <button
            className="button-outlined-secondary mt-20"
            onClick={this.closeShowDrawer_DebitNoteData}
          >
            close
          </button>
        </RightDrawer>
        {/* end */}

        {/*1. ......................................................................................invoice  */}
        {this.state.invoiceTableData ? (
          <>
            {/* arc seller debit note table */}
            <BoxWrapper
              boxTitle="Invoice Details"
              headerExtra={
                FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isEffitrac
                  ? this.renderFilterButtonFor("invoice")
                  : null
              }
              backButtonForZohoEnable={this.state.isEffitrac}
              backButton={this.backToPrevTableHandler}
              importToCwsEnableForZoho={this.state.isEffitrac}
              importToCwsForZoho={this.importToCWS}
              exportToExcelEnable={true}
              exportToExcelFn={this.handleOpenAndCloseModel}
              exportToExcelEnable1={true}
              exportButtonLabel1={!this.state.isEffitrac && this.state.invoiceAppliedFilters.length > 0 && this.state.activeFilters ? "Export Filtered" : "Export All"}
              exportToExcelFn1={this.exportall_to_excel}
              loadingexcel1={this.state.isExportingAll}
              // enableSearchInput={true}
              // searchInputPlaceholder={"Search..."}
              // searchInputOnchange={
              //   this.state.isEffitrac
              //     ? this.handleSearchInputChange
              //     : this.invoiceSearchHandler
              // }
            >
              {this.state.isEffitrac ? (
                <CustomTable
                  headers={this.state.invoiceHeader}
                  columns={this.state.invoiceCol}
                  data={this.state.invoiceData}
                  actions={this.state.actions}
                />
              ) : (
                <>
                  {/* Filter button here only until it is moved into BoxWrapper */}
                  {!FILTER_BUTTON_IN_BOXWRAPPER && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "8px",
                      }}
                    >
                      {this.renderFilterButtonFor("invoice")}
                    </div>
                  )}

                  {this.renderAppliedFilterChipsFor("invoice")}

                  {/* Table on the left, filter panel (when open) on the right */}
                  <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        className="responsive-table"
                        style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                      >
                        <table
                          className="custome-table"
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                            width: "100%",
                            minWidth: this.getTableMinWidthFor(this.invoiceFilterableColumns),
                            tableLayout: "fixed",
                          }}
                        >
                          {this.renderColGroupFor(this.invoiceFilterableColumns)}
                          <tbody>
                            {this.arc_SellerInvoiceTableHeader()}
                            {this.arc_SellerInvoice()}
                          </tbody>
                        </table>
                      </div>
                      <TablePagination
                        rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                        component="div"
                        count={this.state.rowCount} //total row count
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </div>

                    {this.renderFilterPanelFor("invoice")}
                  </div>
                </>
              )}
            </BoxWrapper>
          </>
        ) : (
          ""
        )}

        {/* add invoice drawer  */}
        <Drawer
          anchor="right"
          variant={this.state.invoiceModalBackDrop === true ? "persistent" : ""}
          open={this.state.addInvoice_DrawerOpen}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.addInvoice_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              {/* modal open button */}
              <Button
                style={{ marginTop: "45px" }}
                size="small"
                fullWidth
                variant="outlined"
                onClick={this.customerTableModalOpen}
              >
                select customer*
              </Button>
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.addInvoiceData.customerCode ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.addInvoiceData.gstin ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                validator={["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["Invalid PAN Numaber"]}
                value={this.state.addInvoiceData.pan ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Invoice No"
                name="invoiceNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addInvoiceData.invoiceNo ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  Invoice Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="invoiceDate"
                  value={this.state.invoiceDateDisplay ?? ""}
                  onChange={(v) => this.handleInvoiceDateChange(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Einvoice IRN"
                name="einvoiceIrn"
                requiredField=""
                value={this.state.addInvoiceData.einvoiceIrn ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  Due Date
                  <span style={{ color: "red" }}></span>:
                </label>
                <ValidatedDatePicker
                  name="dueDate"
                  value={this.state.dueDateDisplay ?? ""}
                  onChange={(v) => this.handleDueDateChange(v)}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        taxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Non Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        nonTaxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ SGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        sgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        cgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ IGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        igst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CESS:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        cess: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="GST Tax %"
                name="gstTaxRate"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.addInvoiceData.gstTaxRate ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="HSN/SAC Code"
                name="hsnSacCode"
                value={this.state.addInvoiceData.hsnSacCode ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>₹ Tax Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        taxAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Total Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addInvoiceData: {
                        ...prevState.addInvoiceData,
                        totalAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Invoice Type"
                name="invoiceType"
                value={this.state.addInvoiceData.invoiceType ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />
              <div style={{ marginTop: "20px" }}>
                <label>Place Of Supply</label>
                <Autocomplete
                  id="combo-box-demo"
                  name="placeOfSupply"
                  onChange={(e, value) => {
                    if (value === null) {
                      this.setState((prevState) => ({
                        addInvoiceData: {
                          ...prevState.addInvoiceData,
                          placeOfSupply: "",
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        addInvoiceData: {
                          ...prevState.addInvoiceData,
                          placeOfSupply: String(value),
                        },
                      }));
                    }
                  }}
                  options={this.state.getApiForPlaceOfSupply}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      name="placeOfSupply"
                    />
                  )}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="PO No"
                name="poNo"
                value={this.state.addInvoiceData.poNo ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Collection Agency"
                name="invoiceCollectionAgency"
                value={this.state.addInvoiceData.invoiceCollectionAgency ?? ""}
                textOnchangeFunction={this.addInvoice_inputHandler}
              />

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="outlined"
                size="small"
                onClick={this.addInvoice_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* edit invoice drawer  */}
        <Drawer
          anchor="right"
          open={this.state.editInvoice_DrawerOpen}
          onClose={this.editInvoice_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.editInvoice_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editInvoiceData.customerCode ?? ""}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.editInvoiceData.gstin ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                validator={["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]}
                errorMsg={["Invalid PAN Numaber"]}
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editInvoiceData.pan ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="Invoice No"
                name="invoiceNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editInvoiceData.invoiceNo ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Type"
                name="invoiceType"
                value={this.state.editInvoiceData.invoiceType ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editInvoiceData.invoiceDate ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Einvoice IRN"
                name="einvoiceIrn"
                requiredField=""
                value={this.state.editInvoiceData.einvoiceIrn ?? ""}
                textOnchangeFunction={this.editInvoice_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  Due Date
                  <span style={{ color: "red" }}></span>:
                </label>
                <ValidatedDatePicker
                  name="dueDate"
                  value={this.state.dueDateDisplay ?? ""}
                  onChange={(v) => this.handleDueDateChange(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.taxableValue
                      ? this.state.editInvoiceData.taxableValue
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        taxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Non Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.nonTaxableValue
                      ? this.state.editInvoiceData.nonTaxableValue
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        nonTaxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ SGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.sgst
                      ? this.state.editInvoiceData.sgst
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        sgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.cgst
                      ? this.state.editInvoiceData.cgst
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        cgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ IGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.igst
                      ? this.state.editInvoiceData.igst
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        igst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CESS:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.cess
                      ? this.state.editInvoiceData.cess
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        cess: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="GST Tax %"
                name="gstTaxRate"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.editInvoiceData.gstTaxRate ?? ""}
                textOnchangeFunction={this.editInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="HSN/SAC Code"
                name="hsnSacCode"
                value={this.state.editInvoiceData.hsnSacCode ?? ""}
                textOnchangeFunction={this.editInvoice_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>₹ Tax Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.taxAmount
                      ? this.state.editInvoiceData.taxAmount
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        taxAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Total Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  value={
                    this.state.editInvoiceData.totalAmount
                      ? this.state.editInvoiceData.totalAmount
                      : ""
                  }
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      editInvoiceData: {
                        ...prevState.editInvoiceData,
                        totalAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="PO No"
                name="poNo"
                requiredField=""
                value={this.state.editInvoiceData.poNo ?? ""}
                textOnchangeFunction={this.editInvoice_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Collection Agency"
                name="invoiceCollectionAgency"
                value={this.state.editInvoiceData.invoiceCollectionAgency ?? ""}
                textOnchangeFunction={this.editInvoice_inputHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>Place Of Supply</label> <br />
                <Autocomplete
                  id="combo-box-demo"
                  name="placeOfSupply"
                  value={this.state.editInvoiceData.placeOfSupply ?? ""}
                  onChange={(e, value) => {
                    if (value === null) {
                      this.setState((prevState) => ({
                        editInvoiceData: {
                          ...prevState.editInvoiceData,
                          placeOfSupply: "",
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        editInvoiceData: {
                          ...prevState.editInvoiceData,
                          placeOfSupply: String(value),
                        },
                      }));
                    }
                  }}
                  options={this.state.getApiForPlaceOfSupply}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      name="placeOfSupply"
                    />
                  )}
                />
              </div>

              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="outlined"
                size="small"
                onClick={this.editInvoice_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* invoice drawer show data */}
        <RightDrawer
          open={this.state.showInvoiceDrawer}
          onClose={this.closeInvoiceDrawer}
          drawerName="Invoice Details"
        >
          {Object.keys(this.state.showInvoiceDetailsData).length != 0 && (
            <>
              <TextField
                inputProps={{ readOnly: true }}
                fullWidth
                label="Customer PAN"
                value={this.state.showInvoiceDetailsData.cust_pan ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="GST Invoice Type"
                value={this.state.showInvoiceDetailsData.gst_invoice_type ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Due Date"
                value={this.state.showInvoiceDetailsData.due_date}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Taxable Value"
                value={numberFormat(
                  this.state.showInvoiceDetailsData.taxable_value,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Non Taxable Value"
                value={numberFormat(
                  this.state.showInvoiceDetailsData.non_taxable_adj,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="CESS"
                value={numberFormat(this.state.showInvoiceDetailsData.cess)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="GST Tax %"
                value={this.state.showInvoiceDetailsData.gst_tax_rate ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="HSN/SAC Code"
                value={this.state.showInvoiceDetailsData.hsnsaccode ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="CGST"
                value={numberFormat(this.state.showInvoiceDetailsData.cgst)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="IGST"
                value={numberFormat(this.state.showInvoiceDetailsData.igst)}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="SGST"
                value={numberFormat(this.state.showInvoiceDetailsData.sgst)}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Invoice Collection Agency"
                value={
                  this.state.showInvoiceDetailsData.invoice_collection_agency
                }
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Place Of Supply"
                value={this.state.showInvoiceDetailsData.pos ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="ERP Customer Code"
                value={this.state.showInvoiceDetailsData.cust_code}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Create Date"
                value={this.state.showInvoiceDetailsData.created_date}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Modify Date"
                value={this.state.showInvoiceDetailsData.modified_date}
              />
            </>
          )}
          <button
            className="button-outlined-secondary mt-20"
            onClick={this.closeInvoiceDrawer}
          >
            close
          </button>
        </RightDrawer>

        {/* Invoice table end */}

        {/* ..............................................................................................credit note table */}
        {this.state.creditNoteTableData ? (
          <>
            {/* arc seller crdit note table */}
            <BoxWrapper
              boxTitle=" Credit Note Details"
              headerExtra={
                FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isCreditEffitrac
                  ? this.renderFilterButtonFor("credit")
                  : null
              }
              backButtonForZohoEnable={this.state.isCreditEffitrac}
              backButton={this.backToPrevTableHandler}
              importToCwsEnableForZoho={this.state.isCreditEffitrac}
              importToCwsForZoho={this.creditImportToCWS}
              exportToExcelEnable={true}
              exportToExcelFn={this.handleOpenAndCloseModel}
              exportToExcelEnable1={true}
              exportButtonLabel1={this.state.creditAppliedFilters.length > 0 && this.state.creditActiveFilters ? "Export Filtered" : "Export All"}
              exportToExcelFn1={() => this.exportall_notes_to_excel("credit")}
              loadingexcel1={this.state.isExportingAll}
              // enableSearchInput={true}
              // searchInputPlaceholder={"Search..."}
              // searchInputOnchange={
              //   this.state.isCreditEffitrac
              //     ? this.handleSearchInputChange
              //     : this.creditSearchHandler
              // }
            >
              {this.state.isCreditEffitrac ? (
                <CustomTable
                  headers={this.state.creditEffitracHeader}
                  columns={this.state.creditEffitracCol}
                  data={this.state.creditEffitracData}
                  actions={this.state.creditEffitracActions}
                />
              ) : (
                <>
                  {/* Filter button here only until it is moved into BoxWrapper */}
                  {!FILTER_BUTTON_IN_BOXWRAPPER && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "8px",
                      }}
                    >
                      {this.renderFilterButtonFor("credit")}
                    </div>
                  )}

                  {this.renderAppliedFilterChipsFor("credit")}

                  {/* Table on the left, filter panel (when open) on the right */}
                  <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        className="responsive-table"
                        style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                      >
                        <table
                          className="custome-table"
                          style={{
                            borderCollapse: "separate",
                            borderSpacing: 0,
                            width: "100%",
                            minWidth: this.getTableMinWidthFor(this.creditFilterableColumns),
                            tableLayout: "fixed",
                          }}
                        >
                          {this.renderColGroupFor(this.creditFilterableColumns)}
                          <tbody>
                            {this.arc_SellerCebitNoteTableHeader()}
                            {this.arc_SellerCebitNotedata()}
                          </tbody>
                        </table>
                      </div>
                      <TablePagination
                        rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                        component="div"
                        count={this.state.creditRowCount} //total row count
                        rowsPerPage={this.state.creditRowsPerPage}
                        page={this.state.creditPage}
                        onPageChange={this.handleChangePageForCredit}
                        onRowsPerPageChange={this.handleChangeRowsPerPageForCredit}
                      />
                    </div>

                    {this.renderFilterPanelFor("credit")}
                  </div>
                </>
              )}
            </BoxWrapper>
          </>
        ) : (
          ""
        )}

        {/* add credit note drawer  */}
        <Drawer
          anchor="right"
          open={this.state.addCreditNote_DrawerOpen}
          variant={
            this.state.creditNoteModalBackDrop === true ? "persistent" : ""
          }
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}

            <ValidatorForm
              ref="form"
              onSubmit={this.addCreditNote_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              {/* modal open button */}
              <Button
                style={{ marginTop: "45px" }}
                size="small"
                fullWidth
                variant="outlined"
                onClick={this.creditNoteModalOpen}
              >
                select invoice*
              </Button>
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="customerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.addCreditNoteData.customerCode ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.addCreditNoteData.gstin ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                requiredField=""
                validator={["matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["Invalid PAN Numaber"]}
                value={this.state.addCreditNoteData.pan ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Invoice No"
                name="invoiceNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.addCreditNoteData.invoiceNo ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCreditNoteData.invoiceDate ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />
              <InputField
                inputType="text"
                textLabel="Credit Note No"
                name="creditNoteNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.addCreditNoteData.creditNoteNo ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <div style={{ marginTop: "20px" }}>
                <label>
                  Credit Note Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="creditNoteDate"
                  value={this.state.creditNoteDateDisplay ?? ""}
                  onChange={(v) => this.handleCreditNoteDateChange(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        taxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ Non Taxable Value:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        nonTaxableValue: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ SGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        sgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ CGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        cgst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <div style={{ marginTop: "20px" }}>
                <label>₹ IGST:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        igst: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <label>₹ CESS:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        cess: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>
              <InputField
                inputType="text"
                textLabel="GST Tax %"
                name="gstTaxRate"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.addCreditNoteData.gstTaxRate ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <InputField
                inputType="text"
                textLabel="HSN/SAC Code"
                name="hsnSacCode"
                value={this.state.addCreditNoteData.hsnSacCode ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <div style={{ marginTop: "20px" }}>
                <label>₹ Tax Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        taxAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>
              <div style={{ marginTop: "20px" }}>
                <label>₹ Total Amount:</label> <br />
                <NumberFormat
                  className={classes.numberFormate}
                  style={{ paddingLeft: "10.5px" }}
                  thousandsGroupStyle="lakh"
                  prefix="₹"
                  decimalSeparator="."
                  displayType="number"
                  type="text"
                  decimalScale={2}
                  thousandSeparator={true}
                  allowNegative={true}
                  onValueChange={(values) => {
                    const { value } = values;
                    this.setState((prevState) => ({
                      addCreditNoteData: {
                        ...prevState.addCreditNoteData,
                        totalAmount: parseFloat(value),
                      },
                    }));
                  }}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Is Discount/Bad Debt/Other reason"
                name="isDiscountBadDebtOtherreason"
                requiredField=""
                value={
                  this.state.addCreditNoteData.isDiscountBadDebtOtherreason ??
                  ""
                }
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              <div style={{ marginTop: "20px" }}>
                <label>Place Of Supply</label> <br />
                <Autocomplete
                  id="combo-box-demo"
                  name="placeOfSupply"
                  value={this.state.addCreditNoteData.placeOfSupply ?? ""}
                  onChange={(e, value) => {
                    if (value === null) {
                      this.setState((prevState) => ({
                        addCreditNoteData: {
                          ...prevState.addCreditNoteData,
                          placeOfSupply: "",
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        addCreditNoteData: {
                          ...prevState.addCreditNoteData,
                          placeOfSupply: String(value),
                        },
                      }));
                    }
                  }}
                  options={this.state.getApiForPlaceOfSupply}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      name="placeOfSupply"
                    />
                  )}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Credit Note Reason"
                name="creditNoteReason"
                requiredField=""
                value={this.state.addCreditNoteData.creditNoteReason ?? ""}
                textOnchangeFunction={this.addCreditNote_inputHandler}
              />
              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="outlined"
                size="small"
                onClick={this.addCreditNote_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* edit credit note drawer  */}
        <Drawer
          anchor="right"
          open={this.state.editCreditNote_DrawerOpen}
          onClose={this.editCreditNote_DrawerClose}
        >
          <div className={classes.DrawerBody}>
            {/* Drawer body */}
            <ValidatorForm
              ref="form"
              onSubmit={this.editCreditNote_submitHandler}
              onError={(errors) => console.log(errors)}
            >
              <InputField
                inputType="text"
                textLabel="Customer Code"
                name="cuistomerCode"
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCreditNoteData.customerCode ?? ""}
              />
              <InputField
                inputType="text"
                textLabel="GSTIN"
                name="gstin"
                requiredField="*"
                validator={["required"]}
                inputProps={{
                  readOnly: true,
                }}
                errorMsg={["This field is required"]}
                value={this.state.editCreditNoteData.gstin ?? ""}
              />
              <InputField
                inputType="text"
                textLabel="PAN"
                name="pan"
                requiredField="*"
                inputProps={{
                  readOnly: true,
                }}
                validator={[
                  "required",
                  "matchRegexp:[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}",
                ]}
                errorMsg={["This field is required", "Invalid PAN Numaber"]}
                value={this.state.editCreditNoteData.pan ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="Invoice No"
                name="invoiceNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                inputProps={{
                  readOnly: true,
                }}
                value={this.state.editCreditNoteData.invoiceNo ?? ""}
              />

              <InputField
                inputType="text"
                textLabel="Invoice Date"
                name="invoiceDate"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCreditNoteData.invoiceDate ?? ""}
                inputProps={{
                  readOnly: true,
                }}
              />

              <InputField
                inputType="text"
                textLabel="Credit Note No"
                name="creditNoteNo"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={this.state.editCreditNoteData.creditNoteNo ?? ""}
              />

              <div style={{ marginTop: "20px" }}>
                <label>
                  Credit Note Date
                  <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                  name="creditNoteDate"
                  value={this.state.creditNoteDateDisplay ?? ""}
                  onChange={(v) => this.editCreditNoteDateChangeHandler(v)}
                  validators={["required"]}
                  errorMessages={["Date is required"]}
                />
              </div>

              <InputField
                inputType="text"
                textLabel="Taxable Value"
                name="taxableValue"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={
                  this.state.editCreditNoteData.taxableValue
                    ? numberFormat(this.state.editCreditNoteData.taxableValue)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <InputField
                inputType="text"
                textLabel="Non Taxable Value"
                name="nonTaxableValue"
                value={
                  this.state.editCreditNoteData.nonTaxableValue
                    ? numberFormat(
                      this.state.editCreditNoteData.nonTaxableValue,
                    )
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <InputField
                inputType="text"
                textLabel="SGST"
                name="sgst"
                value={
                  this.state.editCreditNoteData.sgst
                    ? numberFormat(this.state.editCreditNoteData.sgst)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <InputField
                inputType="text"
                textLabel="CGST"
                name="cgst"
                value={
                  this.state.editCreditNoteData.cgst
                    ? numberFormat(this.state.editCreditNoteData.cgst)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <InputField
                inputType="text"
                textLabel="IGST"
                name="igst"
                value={
                  this.state.editCreditNoteData.igst
                    ? numberFormat(this.state.editCreditNoteData.igst)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <InputField
                inputType="text"
                textLabel="CESS"
                name="cess"
                value={
                  this.state.editCreditNoteData.cess
                    ? numberFormat(this.state.editCreditNoteData.cess)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />
              <InputField
                inputType="text"
                textLabel="GST Tax %"
                name="gstTaxRate"
                validator={[
                  "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
                  "maxFloat:100.00",
                ]}
                errorMsg={["invalid percentage.", "invalid percentage."]}
                value={this.state.editCreditNoteData.gstTaxRate ?? ""}
                textOnchangeFunction={this.editCreditNote_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="HSN/SAC Code"
                name="hsnSacCode"
                value={this.state.editCreditNoteData.hsnSacCode ?? ""}
                textOnchangeFunction={this.editCreditNote_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Tax Amount"
                name="taxAmount"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={
                  this.state.editCreditNoteData.taxAmount
                    ? numberFormat(this.state.editCreditNoteData.taxAmount)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <InputField
                inputType="text"
                textLabel="Total Amount"
                name="totalAmount"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={
                  this.state.editCreditNoteData.totalAmount
                    ? numberFormat(this.state.editCreditNoteData.totalAmount)
                    : numberFormat(0)
                }
                textOnchangeFunction={this.editCreditNote_inputNumberHandler}
              />

              <div style={{ marginTop: "20px" }}>
                <label>Place Of Supply</label> <br />
                <Autocomplete
                  id="combo-box-demo"
                  name="placeOfSupply"
                  value={this.state.editCreditNoteData.placeOfSupply ?? ""}
                  onChange={(e, value) => {
                    if (value === null) {
                      this.setState((prevState) => ({
                        editCreditNoteData: {
                          ...prevState.editCreditNoteData,
                          placeOfSupply: "",
                        },
                      }));
                    } else {
                      this.setState((prevState) => ({
                        editCreditNoteData: {
                          ...prevState.editCreditNoteData,
                          placeOfSupply: String(value),
                        },
                      }));
                    }
                  }}
                  options={this.state.getApiForPlaceOfSupply}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      name="placeOfSupply"
                    />
                  )}
                />
              </div>

              {/* Is Discount/Bad Debt/Other reason */}
              <InputField
                inputType="text"
                textLabel="Is Discount/Bad Debt/Other reason"
                name="isDiscountBadDebtOtherreason"
                requiredField=""
                value={
                  this.state.editCreditNoteData.isDiscountBadDebtOtherreason ??
                  ""
                }
                textOnchangeFunction={this.editCreditNote_inputHandler}
              />

              <InputField
                inputType="text"
                textLabel="Credit Note Reason"
                name="creditNoteReason"
                requiredField=""
                value={this.state.editCreditNoteData.creditNoteReason ?? ""}
                textOnchangeFunction={this.editCreditNote_inputHandler}
              />
              {/* submit and back button */}
              <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                size="small"
                type="submit"
              >
                Submit
              </Button>
              <Button
                style={{
                  float: "right",
                  marginTop: "20px",
                }}
                variant="outlined"
                size="small"
                onClick={this.editCreditNote_DrawerClose}
              >
                cancel
              </Button>
            </ValidatorForm>
          </div>
        </Drawer>

        {/* crdit note show drawer  */}
        <RightDrawer
          drawerName="Credit Note Details"
          open={this.state.showCreditNoteDrawer}
          onClose={this.closeShowDrawer_CreditNoteData}
        >
          {Object.keys(this.state.showCreditNoteDetailsData).length ? (
            <>
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Credit Note No"
                value={this.state.showCreditNoteDetailsData.credit_note_no}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Credit Note Date"
                value={this.state.showCreditNoteDetailsData.credit_note_date}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Taxable Value"
                value={numberFormat(
                  this.state.showCreditNoteDetailsData.taxable_value,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="CGST"
                value={numberFormat(this.state.showCreditNoteDetailsData.cgst)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="SGST"
                value={numberFormat(this.state.showCreditNoteDetailsData.sgst)}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="IGST"
                value={numberFormat(this.state.showCreditNoteDetailsData.igst)}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="GST Tax %"
                value={this.state.showCreditNoteDetailsData.gstTaxRate ?? ""}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="HSN/SAC Code"
                value={this.state.showCreditNoteDetailsData.hsnSacCode ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Total Amount"
                value={numberFormat(
                  this.state.showCreditNoteDetailsData.total_amount,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Tax Amount"
                value={numberFormat(
                  this.state.showCreditNoteDetailsData.tax_amount,
                )}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Place Of Supply"
                value={this.state.showCreditNoteDetailsData.placeOfSupply ?? ""}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Credit Note Reason"
                value={this.state.showCreditNoteDetailsData.credit_note_reason}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="EPR Customer Code"
                value={this.state.showCreditNoteDetailsData.cust_code}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Create Date"
                value={this.state.showCreditNoteDetailsData.created_date}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Modify Date"
                value={this.state.showCreditNoteDetailsData.modified_date}
              />
            </>
          ) : (
            ""
          )}

          <button
            className="button-outlined-secondary mt-20"
            onClick={this.closeShowDrawer_CreditNoteData}
          >
            close
          </button>
        </RightDrawer>

        {/* credit note table end */}

        {/* effitrac debit show drawer */}
        <Drawer
          anchor="right"
          open={this.state.effitracDebitShow}
          onClose={this.closeEffitracDebitShowHandler}
        >
          <div className={classes.showDetails}>
            <>
              <div className={classes.showDetailsBody}>
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Customer Code"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    this.state.debitEffitracData[this.state.debitTargetId]
                      .erp_cust_code
                  }
                />

                {this.state.zohoDataForCWS ? (
                  <>
                    <TextField
                      className={classes.showTextField}
                      inputProps={{ readOnly: true }}
                      fullWidth
                      label="Debit Note Date"
                      defaultValue={
                        this.state.debitTargetId !== null &&
                        this.state.debitEffitracData[this.state.debitTargetId]
                          .debitNoteDate
                      }
                    />
                  </>
                ) : (
                  <TextField
                    className={classes.showTextField}
                    inputProps={{ readOnly: true }}
                    fullWidth
                    label="Debit Note Date"
                    defaultValue={
                      this.state.debitTargetId !== null &&
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .debit_note_date
                    }
                  />
                )}

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Customer PAN"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    this.state.debitEffitracData[this.state.debitTargetId]
                      .cust_pan
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Taxable Value"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .taxable_value,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Non Taxable Value"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .non_taxable_adj,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CESS"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .cess,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="GST Tax %"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    this.state.debitEffitracData[this.state.debitTargetId]
                      .gst_tax_rate
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="HSN/SAC Code"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    this.state.debitEffitracData[this.state.debitTargetId]
                      .hsn_sac_code
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CGST"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .cgst,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="IGST"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .igst,
                    )
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="SGST"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .sgst,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Tax Amount"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    numberFormat(
                      this.state.debitEffitracData[this.state.debitTargetId]
                        .tax_amount,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Place Of Supply"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    this.state.debitEffitracData[this.state.debitTargetId].pos
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Debit Note Reason"
                  defaultValue={
                    this.state.debitTargetId != null &&
                    this.state.debitEffitracData[this.state.debitTargetId]
                      .debit_note_reason
                  }
                />
              </div>
            </>
            <Button
              style={{
                marginTop: "25px",
                marginBottom: "30px",
                marginLeft: "10px",
              }}
              variant="contained"
              size="small"
              onClick={this.closeEffitracDebitShowHandler}
            >
              Back
            </Button>
          </div>
        </Drawer>

        {/* credit note effitrac table show drawer */}

        <Drawer
          anchor="right"
          open={this.state.effitracCreditShow}
          onClose={this.closeEffitracCreditShowHandler}
        >
          <div className={classes.showDetails}>
            <>
              <div className={classes.showDetailsBody}>
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Customer Code"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId]
                      .erp_cust_code
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Credit Note Date"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId]
                      .credit_note_date
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Customer PAN"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId]
                      .cust_pan
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Taxable Value"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .taxable_value,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Non Taxable Value"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .non_taxable_adj,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CESS"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .cess,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="GST Tax %"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId]
                      .gst_tax_rate
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="HSN/SAC Code"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId]
                      .hsn_sac_code
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CGST"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .cgst,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="IGST"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .igst,
                    )
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="SGST"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .sgst,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Tax Amount"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    numberFormat(
                      this.state.creditEffitracData[this.state.creditTargetId]
                        .tax_amount,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Place Of Supply"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId].pos
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Credit Note Reason"
                  defaultValue={
                    this.state.creditTargetId != null &&
                    this.state.creditEffitracData[this.state.creditTargetId]
                      .credit_note_reason
                  }
                />
              </div>
            </>
            <Button
              style={{
                marginTop: "25px",
                marginBottom: "30px",
                marginLeft: "10px",
              }}
              variant="contained"
              size="small"
              onClick={this.closeEffitracCreditShowHandler}
            >
              Back
            </Button>
          </div>
        </Drawer>

        <Drawer
          anchor="right"
          open={this.state.effitracInvShow}
          onClose={this.closeEffitracInvShowHandler}
        >
          <div className={classes.showDetails}>
            <>
              <div className={classes.showDetailsBody}>
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Customer PAN"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId].cust_pan
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Invoice Type"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId].gst_invoice_type
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Taxable Value"
                  defaultValue={
                    this.state.targetId != null &&
                    numberFormat(
                      this.state.invoiceData[this.state.targetId].taxable_value,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Non Taxable Value"
                  defaultValue={
                    this.state.targetId != null &&
                    numberFormat(
                      this.state.invoiceData[this.state.targetId]
                        .non_taxable_adj,
                    )
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CESS"
                  defaultValue={
                    this.state.targetId != null &&
                    numberFormat(
                      this.state.invoiceData[this.state.targetId].cess,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="GST Tax %"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId].gst_tax_rate
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="HSN/SAC Code"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId].hsn_sac_code
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="CGST"
                  defaultValue={
                    this.state.targetId != null &&
                    numberFormat(
                      this.state.invoiceData[this.state.targetId].cgst,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="IGST"
                  defaultValue={
                    this.state.targetId != null &&
                    numberFormat(
                      this.state.invoiceData[this.state.targetId].igst,
                    )
                  }
                />
                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="SGST"
                  defaultValue={
                    this.state.targetId != null &&
                    numberFormat(
                      this.state.invoiceData[this.state.targetId].sgst,
                    )
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Place Of Supply"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId].pos
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Invoice Collection Agency"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId]
                      .invoice_collection_agency
                  }
                />

                <TextField
                  className={classes.showTextField}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  label="Customer Code"
                  defaultValue={
                    this.state.targetId != null &&
                    this.state.invoiceData[this.state.targetId].erp_cust_code
                  }
                />
              </div>
            </>
            <Button
              style={{
                marginTop: "25px",
                marginBottom: "30px",
                marginLeft: "10px",
              }}
              variant="contained"
              size="small"
              onClick={this.closeEffitracInvShowHandler}
            >
              Back
            </Button>
          </div>
        </Drawer>
        {this.renderDateFilter()}
      </React.Fragment>
    );
  }
}

export default withRouter(InvoiceManagement);